
export default function calcInit () {
// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();




/**
 * Formats given number according to given options.
 * @param {number} number The number to be formatted.
 * @param {!Object.<string, *>} options The formatting options.
 * @return {string} The formatted number string.
 */
function formatNumber(number, options) {
  var result = (options['fraction'] ? number.toFixed(options['fraction']) : '' + number).split('.');
  return options['prefix'] + result[0].replace(/\B(?=(\d{3})+(?!\d))/g,
      /** @type {string} */ (options['grouping'])) + (result[1] ? options['decimal'] + result[1] : '') + options['suffix'];
}
// var formatted = formatNumber(parseFloat('8987787,98'), {'decimal': ',', 'grouping': '.', 'fraction': 2 , 'prefix': '', 'suffix':''});




Number.prototype.regular_to_euro = function(n, x, s, c) {
  console.log('args', n, x, s, c);
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
      num = this.toFixed(Math.max(0, ~~n));
  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

var euro_to_regular = function(str) {
  return parseFloat(str.replace(/\./g, '').replace(',', '.'));
};
// console.log(euro_to_regular('1.900,89'));

function euroCurrency(ctrl) {
  var val = ctrl;
  val = val.replace(/\./g, "")
  ctrl = "";
  val += '';
  console.log('#typeof val', typeof val);
  console.log('#val', val);
  var xxx = val.split(',');
  var x1 = xxx[0];
  var x2 = xxx.length > 1 ? ',' + xxx[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }
  return x1 + x2;
}







/////
var PMT = function(rate, nperiod, pv, fv, type) {
  if (!fv) fv = 0;
  if (!type) type = 0;

  if (rate == 0) return -(pv + fv)/nperiod;

  var pvif = Math.pow(1 + rate, nperiod);
  var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

  if (type == 1) {
    pmt /= (1 + rate);
  };
  return pmt;
};
// var pmt = -PMT(1.7/1200, 10*12, 8000, 0, 0).toFixed(2);



/* 
	RENTABILITEIT OP EIGEN INBRENG (ROI)
	RENTABILITEIT VAN HET PROJECT
	Maandelijkse SPAARINSPANNING (rood) / OVERSCHOT (groen) - gemiddeld over duur van krediet
*/

$.fn.common = function(){
	var F60p = $("#F60");
	var F60phide = $("#F60hide");
	var F61p = $("#F61");
	var F61phide = $("#F61hide");
	var F62p = $("#F62");
	var F62phide = $("#F62hide");

	var F72p = parseInt($("#F72").val());
	var F75p = $("#F75");
	var F75phide = $("#F75hide");

	var D15p = $("#D15");
	var D15phide = $("#D15hide");
	var D51p = $("#D51");
	var D51phide = $("#D51hide");

	var G15p = $("#G15");
	var G15phide = $("#G15");
	var G19p = $("#G19");
	var G19phide = $("#G19hide");
	var G20p = $("#G20");
	var G20phide = $("#G20hide");
	var G21p = $("#G21");
	var G21phide = $("#G21hide");
	var G26p = $("#G26");
	var G26phide = $("#G26hide");
	var G40p = $("#G40");
	var G40phide = $("#G40hide");
	var G41p = $("#G41");
	var G41phide = $("#G41hide");
	var G42p = $("#G42");
	var G42phide = $("#G42hide");
	var G43p = $("#G43");
	var G43phide = $("#G43hide");
	var G44p = $("#G44");
	var G44phide = $("#G44hide");
	var G45p = $("#G45");
	var G45phide = $("#G45hide");
	var G46p = $("#G46");
	var G46phide = $("#G46hide");
	var G47p = $("#G47");
	var G47phide = $("#G47hide");
	var G51p = $("#G51");
	var G51phide = $("#G51hide");
	var G52p = $("#G52");
	var G52phide = $("#G52hide");
	var G53p = $("#G53");
	var G53phide = $("#G53hide");
	var G54p = $("#G54");
	var G54phide = $("#G54hide");
	var G55p = $("#G55");
	var G55phide = $("#G55hide");
	var G56p = $("#G56");
	var G56phide = $("#G56hide");
	var G60p = $("#G60");
	var G60phide = $("#G60hide");
	var G61p = $("#G61");
	var G61phide = $("#G61hide");
	var G62p = $("#G62");
	var G62phide = $("#G62hide");
	var G66p = $("#G66");
	var G66phide = $("#G66hide");
	var G67p = $("#G67");
	var G67phide = $("#G67hide");
	var G68p = $("#G68");
	var G68phide = $("#G68hide");
	var G74p = $("#G74");
	var G74phide = $("#G74hide");
	var G75p = $("#G75");
	var G75phide = $("#G75hide");
	var G76p = $("#G76");
	var G76phide = $("#G76hide");
	var G78p = $("#G78");
	var G78phide = $("#G78hide");
	var G79p = $("#G79");
	var G79phide = $("#G79hide");
	var G80p = $("#G80");
	var G80phide = $("#G80hide");
	var G82p = $("#G82");
	var G82phide = $("#G82hide");
	var G86p = $("#G86");
	var G86phide = $("#G86hide");
	var G87p = $("#G87");
	var G87phide = $("#G87hide");
	var G88p = $("#G88");
	var G88phide = $("#G88hide");

	var I19p = $("#I19");
	var I19phide = $("#I19hide");
	var I20p = $("#I20");
	var I20phide = $("#I20hide");
	var I21p = $("#I21");
	var I21phide = $("#I21hide");
	var I23p = $("#I23");
	var I23phide = $("#I23hide");
	var I40p = $("#I40");
	var I40phide = $("#I40hide");
	var I41p = $("#I41");
	var I41phide = $("#I41hide");
	var I42p = $("#I42");
	var I42phide = $("#I42hide");
	var I43p = $("#I43");
	var I43phide = $("#I43hide");
	var I44p = $("#I44");
	var I44phide = $("#I44hide");
	var I45p = $("#I45");
	var I45phide = $("#I45hide");
	var I46p = $("#I46");
	var I46phide = $("#I46hide");
	var I47p = $("#I47");
	var I47phide = $("#I47hide");
	var I51p = $("#I51");
	var I51phide = $("#I51hide");
	var I52p = $("#I52");
	var I52phide = $("#I52hide");
	var I53p = $("#I53");
	var I53phide = $("#I53hide");
	var I54p = $("#I54");
	var I54phide = $("#I54hide");
	var I55p = $("#I55");
	var I55phide = $("#I55hide");
	var I56p = $("#I56");
	var I56phide = $("#I56hide");
	var I60p = $("#I60");
	var I60phide = $("#I60hide");
	var I61p = $("#I61");
	var I61phide = $("#I61hide");
	var I62p = $("#I62");
	var I62phide = $("#I62hide");
	var I66p = $("#I66");
	var I66phide = $("#I66hide");
	var I67p = $("#I67");
	var I67phide = $("#I67hide");
	var I68p = $("#I68");
	var I68phide = $("#I68hide");
	var I74p = $("#I74");
	var I74phide = $("#I74hide");
	var I75p = $("#I75");
	var I75phide = $("#I75hide");
	var I76p = $("#I76");
	var I76phide = $("#I76hide");
	var I78p = $("#I78");
	var I78phide = $("#I78hide");
	var I79p = $("#I79");
	var I79phide = $("#I79hide");
	var I80p = $("#I80");
	var I80phide = $("#I80hide");
	var I82p = $("#I82");
	var I82phide = $("#I82hide");
	var I86p = $("#I86");
	var I86phide = $("#I86hide");
	var I87p = $("#I87");
	var I87phide = $("#I87hide");
	var I88p = $("#I88");
	var I88phide = $("#I88hide");



	// =============================================
	// AFLOSSING INTRESTEN EN KAPITAAL
	// =============================================

	var G30hidepmt = $("#G30hide");
	//For 10 Years (jaar)
	G60phide.val(-PMT(parseFloat(F60phide.val())/1200, 10*12, parseFloat(G30hidepmt.val()), 0, 0).toFixed(2)); //PMT function call to above define
	G60p.val(Number(G60phide.val()).regular_to_euro(2, 3, '.', ','));
	$('#I60,#I61,#I62').val('0,00');
	$('#I60hide,#I61hide,#I62hide').val('0.00');
	//For 15 Years (jaar)
	G61phide.val(-PMT(parseFloat(F61phide.val())/1200, 15*12, parseFloat(G30hidepmt.val()), 0, 0).toFixed(2)); //PMT function call to above define
	G61p.val(Number(G61phide.val()).regular_to_euro(2, 3, '.', ','));
	//For 20 Years (jaar)
	G62phide.val(-PMT(parseFloat(F62phide.val())/1200, 20*12, parseFloat(G30hidepmt.val()), 0, 0).toFixed(2)); //PMT function call to above define
	G62p.val(Number(G62phide.val()).regular_to_euro(2, 3, '.', ','));



	// ============================================
	// ============================================
	var A1 = parseFloat(F75phide.val());
	var C2 = parseFloat(D15phide.val());
	var C3 = parseFloat(C2*(1+A1/100)).toFixed(2); //= C2*(1+$A$1/100)
	var C4 = parseFloat(C3*(1+A1/100)).toFixed(2); //= C3*(1+$A$1/100)
	var C5 = parseFloat(C4*(1+A1/100)).toFixed(2); //= C4*(1+$A$1/100)
	var C6 = parseFloat(C5*(1+A1/100)).toFixed(2); //= C5*(1+$A$1/100)
	var C7 = parseFloat(C6*(1+A1/100)).toFixed(2); //= C6*(1+$A$1/100)
	var C8 = parseFloat(C7*(1+A1/100)).toFixed(2); //= C7*(1+$A$1/100)
	var C9 = parseFloat(C8*(1+A1/100)).toFixed(2); //= C8*(1+$A$1/100)
	var C10 = parseFloat(C9*(1+A1/100)).toFixed(2); //= C9*(1+$A$1/100)
	var C11 = parseFloat(C10*(1+A1/100)).toFixed(2); //= C10*(1+$A$1/100)
	var C12 = parseFloat(C11*(1+A1/100)).toFixed(2); //= C11*(1+$A$1/100)  == 10 JAAR
	
	var D12 = (parseFloat(C12)-parseFloat(C2)).toFixed(2); //=C12-C2
	
	var C13 = parseFloat(C12*(1+A1/100)).toFixed(2); //= C12*(1+$A$1/100)
	var C14 = parseFloat(C13*(1+A1/100)).toFixed(2); //= C13*(1+$A$1/100)
	var C15 = parseFloat(C14*(1+A1/100)).toFixed(2); //= C14*(1+$A$1/100)
	var C16 = parseFloat(C15*(1+A1/100)).toFixed(2); //= C15*(1+$A$1/100)
	var C17 = parseFloat(C16*(1+A1/100)).toFixed(2); //= C16*(1+$A$1/100) == 15 JAAR
	
	var D17 = (parseFloat(C17)-parseFloat(C2)).toFixed(2); //=C17-C2

	var C18 = parseFloat(C17*(1+A1/100)).toFixed(2); //= C17*(1+$A$1/100)
	var C19 = parseFloat(C18*(1+A1/100)).toFixed(2); //= C18*(1+$A$1/100)
	var C20 = parseFloat(C19*(1+A1/100)).toFixed(2); //= C19*(1+$A$1/100)
	var C21 = parseFloat(C20*(1+A1/100)).toFixed(2); //= C20*(1+$A$1/100)
	var C22 = parseFloat(C21*(1+A1/100)).toFixed(2); //= C21*(1+$A$1/100) == 20 JAAR
	
	var D22 = (parseFloat(C22)-parseFloat(C2)).toFixed(2); // =C22-C2
	// ============================================
	// ============================================


	var C30 = 9168.00;
	var C34 = parseFloat(I51phide.val());

	// =TRUNC(PROJECTIE!I51+C$30)
	var D34 = (Math.trunc(parseFloat(I51phide.val()) + parseFloat(C30))).toFixed(2);

	var E34;
	var E37;

	// =(980.14*(D34-C$30)/10000+1400)*(D34-C$30)/10000
	var H34 = ((980.14*(D34-C30)/10000+1400)*(D34-C30)/10000).toFixed(2);

	//=(216.16*((D34-14254)/10000)+2397)*((D34-14254)/10000)+965.58
	var I34 = ((216.6*((D34-14254)/10000)+2397)*((D34-14254)/10000)+965.58).toFixed(2); 

	//=0.42*D34-8780.9
	var J34 = (0.42*D34-8780.9).toFixed(2);

	//=TRUNC(IF(D34<14255,H34,IF(D34>55960,J34,I34)))
	if (D34<14255) {
		E34 = (Math.trunc(H34)).toFixed(2);
	}
	else if (D34>55960) {
		E34 = (Math.trunc((J34))).toFixed(2);
	}
	else{
		E34 = (Math.trunc((I34))).toFixed(2);
	}
	
	



	// ==================================
	// ==================================
	// ==================================
	var G30g  = $('#G30hide').val();
	// var taeg = 0.017/12;
	var taeg = (F60phide.val()/100)/12;
	var rate = 10*12;
	var multi = taeg / (1 - (1 / Math.pow((1+taeg), rate)));
	var pmt_constant = G30g * multi;

	// console.log("pmt_constant "+ pmt_constant);

	var H19 = parseFloat(G30g * taeg).toFixed(3);
	var G19 = parseFloat(pmt_constant - H19).toFixed(3);

	var G30_0 = parseFloat(G30g - G19).toFixed(3);
	var H20 = parseFloat(G30_0 * taeg).toFixed(3);
	var G20 = parseFloat(pmt_constant - H20).toFixed(3);

	var G30_1 = parseFloat(G30_0 - G20).toFixed(3);
	var H21 = parseFloat(G30_1 * taeg).toFixed(3);
	var G21 = parseFloat(pmt_constant - H21).toFixed(3);

	var G30_2 = parseFloat(G30_1 - G21).toFixed(3);
	var H22 = parseFloat(G30_2 * taeg).toFixed(3);
	var G22 = parseFloat(pmt_constant - H22).toFixed(3);

	var G30_3 = parseFloat(G30_2 - G22).toFixed(3);
	var H23 = parseFloat(G30_3 * taeg).toFixed(3);
	var G23 = parseFloat(pmt_constant - H23).toFixed(3);

	var G30_4 = parseFloat(G30_3 - G23).toFixed(3);
	var H24 = parseFloat(G30_4 * taeg).toFixed(3);
	var G24 = parseFloat(pmt_constant - H24).toFixed(3);

	var G30_5 = parseFloat(G30_4 - G24).toFixed(3);
	var H25 = parseFloat(G30_5 * taeg).toFixed(3);
	var G25 = parseFloat(pmt_constant - H25).toFixed(3);

	var G30_6 = parseFloat(G30_5 - G25).toFixed(3);
	var H26 = parseFloat(G30_6 * taeg).toFixed(3);
	var G26 = parseFloat(pmt_constant - H26).toFixed(3);

	var G30_7 = parseFloat(G30_6 - G26).toFixed(3);
	var H27 = parseFloat(G30_7 * taeg).toFixed(3);
	var G27 = parseFloat(pmt_constant - H27).toFixed(3);

	var G30_8 = parseFloat(G30_7 - G27).toFixed(3);
	var H28 = parseFloat(G30_8 * taeg).toFixed(3);
	var G28 = parseFloat(pmt_constant - H28).toFixed(3);

	var G30_9 = parseFloat(G30_8 - G27).toFixed(3);
	var H29 = parseFloat(G30_9 * taeg).toFixed(3);
	var G29 = parseFloat(pmt_constant - H29).toFixed(3);

	var G30_10 = parseFloat(G30_9 - G29).toFixed(3);
	var H30 = parseFloat(G30_10 * taeg).toFixed(3);
	var G30 = parseFloat(pmt_constant - H30).toFixed(3);
	
	// H19-H30
	var B37 = (parseFloat(H19)+parseFloat(H20)+parseFloat(H21)+parseFloat(H22)+parseFloat(H23)+parseFloat(H24)+parseFloat(H25)+parseFloat(H26)+parseFloat(H27)+parseFloat(H28)+parseFloat(H29)+parseFloat(H30)).toFixed(2);

	// = PROJECTIE!G$15-B37-SUM(PROJECTIE!G$40:G$45)
	var C37 = (parseFloat(G15phide.val()) - parseFloat(B37) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	// =TRUNC(C37+C$30)
	var D37 = (Math.trunc(parseFloat(C37) + C30)).toFixed(2);

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1  #1
	//Formula = (980.14*(D37-C$30)/10000+1400)*(D37-C$30)/10000
	var H37 = ((980.14*(D37 - C30)/10000 + 1400) * (D37 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	//Formula = (216.16*((D37-14254)/10000)+2397)*((D37-14254)/10000)+965.58
	var I37 = ((216.16*((D37 - 14254)/10000) + 2397) * ((D37 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	//Formula = 0.42*D37-8780.9
	var J37 = (0.42*D37-8780.9).toFixed(2);

	//Formula = =TRUNC(IF(D37<14255,H37,IF(D37>55960,J37,I37)))
	if (D37<14255) {
		E37 = Math.trunc(H37).toFixed(2); //Valur of E37
	}
	else if (D37>55960) {
		E37 = Math.trunc(J37).toFixed(2); //Valur of E37
	}
	else{
		E37 = Math.trunc(I37).toFixed(2); //Valur of E37
	}
	//=PROJECTIE!D$51-E37-SUM(PROJECTIE!G$40:G$43)
	var F37 = (parseFloat(D51phide.val())-parseFloat(E37)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	// =====>>>>>>>>>>>>>>
	var G30_11 = parseFloat(G30_10 - G30).toFixed(3);
	var H31 = parseFloat(G30_11 * taeg).toFixed(3);
	var G31 = parseFloat(pmt_constant - H31).toFixed(3);

	var G30_12 = parseFloat(G30_11 - G31).toFixed(3);
	var H32 = parseFloat(G30_12 * taeg).toFixed(3);
	var G32 = parseFloat(pmt_constant - H32).toFixed(3);

	var G30_13 = parseFloat(G30_12 - G32).toFixed(3);
	var H33 = parseFloat(G30_13 * taeg).toFixed(3);
	var G33 = parseFloat(pmt_constant - H33).toFixed(3);

	var G30_14 = parseFloat(G30_13 - G33).toFixed(3);
	var H34 = parseFloat(G30_14 * taeg).toFixed(3);
	var G34 = parseFloat(pmt_constant - H34).toFixed(3);

	var G30_15 = parseFloat(G30_14 - G34).toFixed(3);
	var H35 = parseFloat(G30_15 * taeg).toFixed(3);
	var G35 = parseFloat(pmt_constant - H35).toFixed(3);

	var G30_16 = parseFloat(G30_15 - G35).toFixed(3);
	var H36 = parseFloat(G30_16 * taeg).toFixed(3);
	var G36 = parseFloat(pmt_constant - H36).toFixed(3);

	var G30_17 = parseFloat(G30_16 - G36).toFixed(3);
	var H37 = parseFloat(G30_17 * taeg).toFixed(3);
	var G37 = parseFloat(pmt_constant - H37).toFixed(3);

	var G30_18 = parseFloat(G30_17 - G37).toFixed(3);
	var H38 = parseFloat(G30_18 * taeg).toFixed(3);
	var G38 = parseFloat(pmt_constant - H38).toFixed(3);

	var G30_19 = parseFloat(G30_18 - G38).toFixed(3);
	var H39 = parseFloat(G30_19 * taeg).toFixed(3);
	var G39 = parseFloat(pmt_constant - H39).toFixed(3);

	var G30_20 = parseFloat(G30_19 - G39).toFixed(3);
	var H40 = parseFloat(G30_20 * taeg).toFixed(3);
	var G40 = parseFloat(pmt_constant - H40).toFixed(3);

	var G30_21 = parseFloat(G30_20 - G40).toFixed(3);
	var H41 = parseFloat(G30_21 * taeg).toFixed(3);
	var G41 = parseFloat(pmt_constant - H41).toFixed(3);

	var G30_22 = parseFloat(G30_21 - G41).toFixed(3);
	var H42 = parseFloat(G30_22 * taeg).toFixed(3);
	var G42 = parseFloat(pmt_constant - H42).toFixed(3);

	// H31-H42
	var B38 = (parseFloat(H31)+parseFloat(H32)+parseFloat(H33)+parseFloat(H34)+parseFloat(H35)+parseFloat(H36)+parseFloat(H37)+parseFloat(H38)+parseFloat(H39)+parseFloat(H40)+parseFloat(H41)+parseFloat(H42)).toFixed(2);

	// = PROJECTIE!G$15-B38-SUM(PROJECTIE!G$40:G$45)
	var C38 = (parseFloat(G15phide.val()) - parseFloat(B38) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	// =TRUNC(C38+C$30)
	var D38 = (Math.trunc(parseFloat(C38) + C30)).toFixed(2);

	var E38;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #2
	// =(980.14*(D38-C$30)/10000+1400)*(D38-C$30)/10000
	var H38 = ((980.14*(D38 - C30)/10000 + 1400) * (D38 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #2
	//=(216.16*((D38-14254)/10000)+2397)*((D38-14254)/10000)+965.58
	var I38 = ((216.16*((D38 - 14254)/10000) + 2397) * ((D38 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #2
	//Formula = 0.42*D38-8780.9
	var J38 = (0.42*D38-8780.9).toFixed(2);

	// =TRUNC(IF(D38<14255,H38,IF(D38>55960,J38,I38)))
	if (D38<14255) {
		E38 = Math.trunc(H38).toFixed(2); //Valur of E38
	}
	else if (D38>55960) {
		E38 = Math.trunc(J38).toFixed(2); //Valur of E38
	}
	else{
		E38 = Math.trunc(I38).toFixed(2); //Valur of E38
	}
	//=PROJECTIE!D$51-E38-SUM(PROJECTIE!G$40:G$43)
	var F38 = (parseFloat(D51phide.val())-parseFloat(E38)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_23 = parseFloat(G30_22 - G42).toFixed(3);
	var H43 = parseFloat(G30_23 * taeg).toFixed(3);
	var G43 = parseFloat(pmt_constant - H43).toFixed(3);

	var G30_24 = parseFloat(G30_23 - G43).toFixed(3);
	var H44 = parseFloat(G30_24 * taeg).toFixed(3);
	var G44 = parseFloat(pmt_constant - H44).toFixed(3);

	var G30_25 = parseFloat(G30_24 - G44).toFixed(3);
	var H45 = parseFloat(G30_25 * taeg).toFixed(3);
	var G45 = parseFloat(pmt_constant - H45).toFixed(3);

	var G30_26 = parseFloat(G30_25 - G45).toFixed(3);
	var H46 = parseFloat(G30_26 * taeg).toFixed(3);
	var G46 = parseFloat(pmt_constant - H46).toFixed(3);

	var G30_27 = parseFloat(G30_26 - G46).toFixed(3);
	var H47 = parseFloat(G30_27 * taeg).toFixed(3);
	var G47 = parseFloat(pmt_constant - H47).toFixed(3);

	var G30_28 = parseFloat(G30_27 - G47).toFixed(3);
	var H48 = parseFloat(G30_28 * taeg).toFixed(3);
	var G48 = parseFloat(pmt_constant - H48).toFixed(3);

	var G30_29 = parseFloat(G30_28 - G48).toFixed(3);
	var H49 = parseFloat(G30_29 * taeg).toFixed(3);
	var G49 = parseFloat(pmt_constant - H49).toFixed(3);

	var G30_30 = parseFloat(G30_29 - G49).toFixed(3);
	var H50 = parseFloat(G30_30 * taeg).toFixed(3);
	var G50 = parseFloat(pmt_constant - H50).toFixed(3);

	var G30_31 = parseFloat(G30_30 - G50).toFixed(3);
	var H51 = parseFloat(G30_31 * taeg).toFixed(3);
	var G51 = parseFloat(pmt_constant - H51).toFixed(3);

	var G30_32 = parseFloat(G30_31 - G51).toFixed(3);
	var H52 = parseFloat(G30_32 * taeg).toFixed(3);
	var G52 = parseFloat(pmt_constant - H52).toFixed(3);

	var G30_33 = parseFloat(G30_32 - G52).toFixed(3);
	var H53 = parseFloat(G30_33 * taeg).toFixed(3);
	var G53 = parseFloat(pmt_constant - H53).toFixed(3);

	var G30_34 = parseFloat(G30_33 - G53).toFixed(3);
	var H54 = parseFloat(G30_34 * taeg).toFixed(3);
	var G54 = parseFloat(pmt_constant - H54).toFixed(3);

	// H43-H54
	var B39 = (parseFloat(H43)+parseFloat(H44)+parseFloat(H45)+parseFloat(H46)+parseFloat(H47)+parseFloat(H48)+parseFloat(H49)+parseFloat(H50)+parseFloat(H51)+parseFloat(H52)+parseFloat(H53)+parseFloat(H54)).toFixed(2);
	
	// = =PROJECTIE!G$15-B39-SUM(PROJECTIE!G$40:G$45)
	var C39 = (parseFloat(G15phide.val()) - parseFloat(B39) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C39+C$30)
	var D39 = (Math.trunc(parseFloat(C39) + C30)).toFixed(2);

	var E39;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #3
	// =(980.14*(D39-C$30)/10000+1400)*(D39-C$30)/10000
	var H39 = ((980.14*(D39 - C30)/10000 + 1400) * (D39 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #3
	//=(216.16*((D39-14254)/10000)+2397)*((D39-14254)/10000)+965.58
	var I39 = ((216.16*((D39 - 14254)/10000) + 2397) * ((D39 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #3
	//Formula = 0.42*D39-8780.9
	var J39 = (0.42*D39-8780.9).toFixed(2);

	// =TRUNC(IF(D39<14255,H39,IF(D38>55960,J39,I39)))
	if (D39<14255) {
		E39 = Math.trunc(H39).toFixed(2); //Valur of E39
	}
	else if (D39>55960) {
		E39 = Math.trunc(J39).toFixed(2); //Valur of E39
	}
	else{
		E39 = Math.trunc(I39).toFixed(2); //Valur of E39
	}
	//=PROJECTIE!D$51-E39-SUM(PROJECTIE!G$40:G$43)
	var F39 = (parseFloat(D51phide.val())-parseFloat(E39)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_35 = parseFloat(G30_34 - G54).toFixed(3);
	var H55 = parseFloat(G30_35 * taeg).toFixed(3);
	var G55 = parseFloat(pmt_constant - H55).toFixed(3);

	var G30_36 = parseFloat(G30_35 - G55).toFixed(3);
	var H56 = parseFloat(G30_36 * taeg).toFixed(3);
	var G56 = parseFloat(pmt_constant - H56).toFixed(3);

	var G30_37 = parseFloat(G30_36 - G56).toFixed(3);
	var H57 = parseFloat(G30_37 * taeg).toFixed(3);
	var G57 = parseFloat(pmt_constant - H57).toFixed(3);

	var G30_38 = parseFloat(G30_37 - G57).toFixed(3);
	var H58 = parseFloat(G30_38 * taeg).toFixed(3);
	var G58 = parseFloat(pmt_constant - H58).toFixed(3);

	var G30_39 = parseFloat(G30_38 - G58).toFixed(3);
	var H59 = parseFloat(G30_39 * taeg).toFixed(3);
	var G59 = parseFloat(pmt_constant - H59).toFixed(3);

	var G30_40 = parseFloat(G30_39 - G59).toFixed(3);
	var H60 = parseFloat(G30_40 * taeg).toFixed(3);
	var G60 = parseFloat(pmt_constant - H60).toFixed(3);

	var G30_41 = parseFloat(G30_40 - G60).toFixed(3);
	var H61 = parseFloat(G30_41 * taeg).toFixed(3);
	var G61 = parseFloat(pmt_constant - H61).toFixed(3);

	var G30_42 = parseFloat(G30_41 - G61).toFixed(3);
	var H62 = parseFloat(G30_42 * taeg).toFixed(3);
	var G62 = parseFloat(pmt_constant - H62).toFixed(3);

	var G30_43 = parseFloat(G30_42 - G62).toFixed(3);
	var H63 = parseFloat(G30_43 * taeg).toFixed(3);
	var G63 = parseFloat(pmt_constant - H63).toFixed(3);

	var G30_44 = parseFloat(G30_43 - G59).toFixed(3);
	var H64 = parseFloat(G30_44 * taeg).toFixed(3);
	var G64 = parseFloat(pmt_constant - H64).toFixed(3);

	var G30_45 = parseFloat(G30_44 - G64).toFixed(3);
	var H65 = parseFloat(G30_45 * taeg).toFixed(3);
	var G65 = parseFloat(pmt_constant - H65).toFixed(3);

	var G30_46 = parseFloat(G30_45 - G65).toFixed(3);
	var H66 = parseFloat(G30_46 * taeg).toFixed(3);
	var G66 = parseFloat(pmt_constant - H66).toFixed(3);

	// H55-H66
	var B40 = (parseFloat(H55)+parseFloat(H56)+parseFloat(H57)+parseFloat(H58)+parseFloat(H59)+parseFloat(H60)+parseFloat(H61)+parseFloat(H62)+parseFloat(H63)+parseFloat(H64)+parseFloat(H65)+parseFloat(H66)).toFixed(2);
	
	// =PROJECTIE!G$15-B40-SUM(PROJECTIE!G$40:G$45)
	var C40 = (parseFloat(G15phide.val()) - parseFloat(B40) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C40+C$30)
	var D40 = (Math.trunc(parseFloat(C40) + C30)).toFixed(2);

	var E40;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #4
	// =(980.14*(D40-C$30)/10000+1400)*(D40-C$30)/10000
	var H40 = ((980.14*(D40 - C30)/10000 + 1400) * (D40 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #4
	//=(216.16*((D40-14254)/10000)+2397)*((D40-14254)/10000)+965.58
	var I40 = ((216.16*((D40 - 14254)/10000) + 2397) * ((D40 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #4
	//Formula = 0.42*D40-8780.9
	var J40 = (0.42*D40-8780.9).toFixed(2);

	// =TRUNC(IF(D40<14255,H38,IF(D38>55960,J38,I38)))
	if (D40<14255) {
		E40 = Math.trunc(H40).toFixed(2); //Valur of E40
	}
	else if (D40>55960) {
		E40 = Math.trunc(J40).toFixed(2); //Valur of E40
	}
	else{
		E40 = Math.trunc(I40).toFixed(2); //Valur of E40
	}
	//=PROJECTIE!D$51-E40-SUM(PROJECTIE!G$40:G$43)
	var F40 = (parseFloat(D51phide.val())-parseFloat(E40)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_47 = parseFloat(G30_46 - G66).toFixed(3);
	var H67 = parseFloat(G30_47 * taeg).toFixed(3);
	var G67 = parseFloat(pmt_constant - H67).toFixed(3);

	var G30_48 = parseFloat(G30_47 - G67).toFixed(3);
	var H68 = parseFloat(G30_48 * taeg).toFixed(3);
	var G68 = parseFloat(pmt_constant - H68).toFixed(3);

	var G30_49 = parseFloat(G30_48 - G68).toFixed(3);
	var H69 = parseFloat(G30_49 * taeg).toFixed(3);
	var G69 = parseFloat(pmt_constant - H69).toFixed(3);

	var G30_50 = parseFloat(G30_49 - G69).toFixed(3);
	var H70 = parseFloat(G30_50 * taeg).toFixed(3);
	var G70 = parseFloat(pmt_constant - H70).toFixed(3);

	var G30_51 = parseFloat(G30_50 - G70).toFixed(3);
	var H71 = parseFloat(G30_51 * taeg).toFixed(3);
	var G71 = parseFloat(pmt_constant - H71).toFixed(3);

	var G30_52 = parseFloat(G30_51 - G71).toFixed(3);
	var H72 = parseFloat(G30_52 * taeg).toFixed(3);
	var G72 = parseFloat(pmt_constant - H72).toFixed(3);

	var G30_53 = parseFloat(G30_52 - G72).toFixed(3);
	var H73 = parseFloat(G30_53 * taeg).toFixed(3);
	var G73 = parseFloat(pmt_constant - H73).toFixed(3);

	var G30_54 = parseFloat(G30_53 - G73).toFixed(3);
	var H74 = parseFloat(G30_54 * taeg).toFixed(3);
	var G74 = parseFloat(pmt_constant - H74).toFixed(3);

	var G30_55 = parseFloat(G30_54 - G74).toFixed(3);
	var H75 = parseFloat(G30_55 * taeg).toFixed(3);
	var G75 = parseFloat(pmt_constant - H75).toFixed(3);

	var G30_56 = parseFloat(G30_55 - G75).toFixed(3);
	var H76 = parseFloat(G30_56 * taeg).toFixed(3);
	var G76 = parseFloat(pmt_constant - H76).toFixed(3);

	var G30_57 = parseFloat(G30_56 - G76).toFixed(3);
	var H77 = parseFloat(G30_57 * taeg).toFixed(3);
	var G77 = parseFloat(pmt_constant - H77).toFixed(3);
	
	var G30_58 = parseFloat(G30_57 - G77).toFixed(3);
	var H78 = parseFloat(G30_58 * taeg).toFixed(3);
	var G78 = parseFloat(pmt_constant - H78).toFixed(3);

	// H67-H78
	var B41 = (parseFloat(H67)+parseFloat(H68)+parseFloat(H69)+parseFloat(H70)+parseFloat(H71)+parseFloat(H72)+parseFloat(H73)+parseFloat(H74)+parseFloat(H75)+parseFloat(H76)+parseFloat(H77)+parseFloat(H78)).toFixed(2);
	
	// =PROJECTIE!G$15-B41-SUM(PROJECTIE!G$40:G$45)
	var C41 = (parseFloat(G15phide.val()) - parseFloat(B41) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C41+C$30)
	var D41 = (Math.trunc(parseFloat(C41) + C30)).toFixed(2);

	var E41;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #5
	// =(980.14*(D40-C$30)/10000+1400)*(D40-C$30)/10000
	var H41 = ((980.14*(D41 - C30)/10000 + 1400) * (D41 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	//=(216.16*((D41-14254)/10000)+2397)*((D41-14254)/10000)+965.58
	var I41 = ((216.16*((D41 - 14254)/10000) + 2397) * ((D41 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D41-8780.9
	var J41 = (0.42*D41-8780.9).toFixed(2);

	// =TRUNC(IF(D41<14255,H38,IF(D41>55960,J38,I38)))
	if (D41<14255) {
		E41 = Math.trunc(H41).toFixed(2); //Valur of E41
	}
	else if (D41>55960) {
		E41 = Math.trunc(J41).toFixed(2); //Valur of E41
	}
	else{
		E41 = Math.trunc(I41).toFixed(2); //Valur of E41
	}

	//=PROJECTIE!D$51-E41-SUM(PROJECTIE!G$40:G$43)
	var F41 = (parseFloat(D51phide.val())-parseFloat(E41)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_59 = parseFloat(G30_58 - G78).toFixed(3);
	var H79 = parseFloat(G30_59 * taeg).toFixed(3);
	var G79 = parseFloat(pmt_constant - H79).toFixed(3);

	var G30_60 = parseFloat(G30_59 - G79).toFixed(3);
	var H80 = parseFloat(G30_60 * taeg).toFixed(3);
	var G80 = parseFloat(pmt_constant - H80).toFixed(3);

	var G30_61 = parseFloat(G30_60 - G80).toFixed(3);
	var H81 = parseFloat(G30_61 * taeg).toFixed(3);
	var G81 = parseFloat(pmt_constant - H81).toFixed(3);

	var G30_62 = parseFloat(G30_61 - G81).toFixed(3);
	var H82 = parseFloat(G30_62 * taeg).toFixed(3);
	var G82 = parseFloat(pmt_constant - H82).toFixed(3);

	var G30_63 = parseFloat(G30_62 - G82).toFixed(3);
	var H83 = parseFloat(G30_63 * taeg).toFixed(3);
	var G83 = parseFloat(pmt_constant - H83).toFixed(3);

	var G30_64 = parseFloat(G30_63 - G83).toFixed(3);
	var H84 = parseFloat(G30_64 * taeg).toFixed(3);
	var G84 = parseFloat(pmt_constant - H84).toFixed(3);

	var G30_65 = parseFloat(G30_64 - G84).toFixed(3);
	var H85 = parseFloat(G30_65 * taeg).toFixed(3);
	var G85 = parseFloat(pmt_constant - H85).toFixed(3);

	var G30_66 = parseFloat(G30_65 - G85).toFixed(3);
	var H86 = parseFloat(G30_66 * taeg).toFixed(3);
	var G86 = parseFloat(pmt_constant - H86).toFixed(3);

	var G30_67 = parseFloat(G30_66 - G86).toFixed(3);
	var H87 = parseFloat(G30_67 * taeg).toFixed(3);
	var G87 = parseFloat(pmt_constant - H87).toFixed(3);

	var G30_68 = parseFloat(G30_67 - G87).toFixed(3);
	var H88 = parseFloat(G30_68 * taeg).toFixed(3);
	var G88 = parseFloat(pmt_constant - H88).toFixed(3);

	var G30_69 = parseFloat(G30_68 - G88).toFixed(3);
	var H89 = parseFloat(G30_69 * taeg).toFixed(3);
	var G89 = parseFloat(pmt_constant - H89).toFixed(3);

	var G30_70 = parseFloat(G30_69 - G89).toFixed(3);
	var H90 = parseFloat(G30_70 * taeg).toFixed(3);
	var G90 = parseFloat(pmt_constant - H90).toFixed(3);	
	// H79-H90
	var B42 = (parseFloat(H79)+parseFloat(H80)+parseFloat(H81)+parseFloat(H82)+parseFloat(H83)+parseFloat(H84)+parseFloat(H85)+parseFloat(H86)+parseFloat(H87)+parseFloat(H88)+parseFloat(H89)+parseFloat(H90)).toFixed(2);
	
	// =PROJECTIE!G$15-B41-SUM(PROJECTIE!G$40:G$45)
	var C42 = (parseFloat(G15phide.val()) - parseFloat(B42) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C42+C$30)
	var D42 = (Math.trunc(parseFloat(C42) + C30)).toFixed(2);

	var E42;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #6
	// =(980.14*(D42-C$30)/10000+1400)*(D42-C$30)/10000
	var H42 = ((980.14*(D42 - C30)/10000 + 1400) * (D42 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #6
	//=(216.16*((D42-14254)/10000)+2397)*((D42-14254)/10000)+965.58
	var I42 = ((216.16*((D42 - 14254)/10000) + 2397) * ((D42 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #6
	//Formula = 0.42*D42-8780.9
	var J42 = (0.42*D42-8780.9).toFixed(2);

	// =TRUNC(IF(D42<14255,H42,IF(D42>55960,J38,I38)))
	if (D42<14255) {
		E42 = Math.trunc(H42).toFixed(2); //Valur of E42
	}
	else if (D42>55960) {
		E42 = Math.trunc(J42).toFixed(2); //Valur of E42
	}
	else{
		E42 = Math.trunc(I42).toFixed(2); //Valur of E42
	}
	//=PROJECTIE!D$51-E42-SUM(PROJECTIE!G$40:G$43)
	var F42 = (parseFloat(D51phide.val())-parseFloat(E42)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_71 = parseFloat(G30_70 - G90).toFixed(3);
	var H91 = parseFloat(G30_71 * taeg).toFixed(3);
	var G91 = parseFloat(pmt_constant - H91).toFixed(3);

	var G30_72 = parseFloat(G30_71 - G91).toFixed(3);
	var H92 = parseFloat(G30_72 * taeg).toFixed(3);
	var G92 = parseFloat(pmt_constant - H92).toFixed(3);

	var G30_73 = parseFloat(G30_72 - G92).toFixed(3);
	var H93 = parseFloat(G30_73 * taeg).toFixed(3);
	var G93 = parseFloat(pmt_constant - H93).toFixed(3);

	var G30_74 = parseFloat(G30_73 - G93).toFixed(3);
	var H94 = parseFloat(G30_74 * taeg).toFixed(3);
	var G94 = parseFloat(pmt_constant - H94).toFixed(3);

	var G30_75 = parseFloat(G30_74 - G94).toFixed(3);
	var H95 = parseFloat(G30_75 * taeg).toFixed(3);
	var G95 = parseFloat(pmt_constant - H95).toFixed(3);

	var G30_76 = parseFloat(G30_75 - G95).toFixed(3);
	var H96 = parseFloat(G30_76 * taeg).toFixed(3);
	var G96 = parseFloat(pmt_constant - H96).toFixed(3);

	var G30_77 = parseFloat(G30_76 - G96).toFixed(3);
	var H97 = parseFloat(G30_77 * taeg).toFixed(3);
	var G97 = parseFloat(pmt_constant - H97).toFixed(3);

	var G30_78 = parseFloat(G30_77 - G97).toFixed(3);
	var H98 = parseFloat(G30_78 * taeg).toFixed(3);
	var G98 = parseFloat(pmt_constant - H98).toFixed(3);

	var G30_79 = parseFloat(G30_78 - G98).toFixed(3);
	var H99 = parseFloat(G30_79 * taeg).toFixed(3);
	var G99 = parseFloat(pmt_constant - H99).toFixed(3);

	var G30_80 = parseFloat(G30_79 - G99).toFixed(3);
	var H100 = parseFloat(G30_80 * taeg).toFixed(3);
	var G100 = parseFloat(pmt_constant - H100).toFixed(3);

	var G30_81 = parseFloat(G30_80 - G100).toFixed(3);
	var H101 = parseFloat(G30_81 * taeg).toFixed(3);
	var G101 = parseFloat(pmt_constant - H101).toFixed(3);

	var G30_82 = parseFloat(G30_81 - G101).toFixed(3);
	var H102 = parseFloat(G30_82 * taeg).toFixed(3);
	var G102 = parseFloat(pmt_constant - H102).toFixed(3);	
	// H91-H102
	var B43 = (parseFloat(H91)+parseFloat(H92)+parseFloat(H93)+parseFloat(H94)+parseFloat(H95)+parseFloat(H96)+parseFloat(H97)+parseFloat(H98)+parseFloat(H99)+parseFloat(H100)+parseFloat(H101)+parseFloat(H102)).toFixed(2);
	
	// =PROJECTIE!G$15-B43-SUM(PROJECTIE!G$40:G$45)
	var C43 = (parseFloat(G15phide.val()) - parseFloat(B43) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C43+C$30)
	var D43 = (Math.trunc(parseFloat(C43) + C30)).toFixed(2);

	var E43;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #7
	// =(980.14*(D43-C$30)/10000+1400)*(D43-C$30)/10000
	var H43 = ((980.14*(D43 - C30)/10000 + 1400) * (D43 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #7
	//=(216.16*((D43-14254)/10000)+2397)*((D43-14254)/10000)+965.58
	var I43 = ((216.16*((D43 - 14254)/10000) + 2397) * ((D43 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #7
	//Formula = 0.42*D43-8780.9
	var J43 = (0.42*D43-8780.9).toFixed(2);

	// =TRUNC(IF(D43<14255,H43,IF(D43>55960,J43,I43)))
	if (D43<14255) {
		E43 = Math.trunc(H43).toFixed(2); //Valur of E43
	}
	else if (D43>55960) {
		E43 = Math.trunc(J43).toFixed(2); //Valur of E43
	}
	else{
		E43 = Math.trunc(I43).toFixed(2); //Valur of E43
	}
	//=PROJECTIE!D$51-E43-SUM(PROJECTIE!G$40:G$43)
	var F43 = (parseFloat(D51phide.val())-parseFloat(E43)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_83 = parseFloat(G30_82 - G102).toFixed(3);
	var H103 = parseFloat(G30_83 * taeg).toFixed(3);
	var G103 = parseFloat(pmt_constant - H103).toFixed(3);

	var G30_84 = parseFloat(G30_83 - G103).toFixed(3);
	var H104 = parseFloat(G30_84 * taeg).toFixed(3);
	var G104 = parseFloat(pmt_constant - H104).toFixed(3);

	var G30_85 = parseFloat(G30_84 - G104).toFixed(3);
	var H105 = parseFloat(G30_85 * taeg).toFixed(3);
	var G105 = parseFloat(pmt_constant - H105).toFixed(3);

	var G30_86 = parseFloat(G30_85 - G105).toFixed(3);
	var H106 = parseFloat(G30_86 * taeg).toFixed(3);
	var G106 = parseFloat(pmt_constant - H106).toFixed(3);

	var G30_87 = parseFloat(G30_86 - G106).toFixed(3);
	var H107 = parseFloat(G30_87 * taeg).toFixed(3);
	var G107 = parseFloat(pmt_constant - H107).toFixed(3);	

	var G30_88 = parseFloat(G30_87 - G107).toFixed(3);
	var H108 = parseFloat(G30_88 * taeg).toFixed(3);
	var G108 = parseFloat(pmt_constant - H108).toFixed(3);	

	var G30_89 = parseFloat(G30_88 - G108).toFixed(3);
	var H109 = parseFloat(G30_89 * taeg).toFixed(3);
	var G109 = parseFloat(pmt_constant - H109).toFixed(3);	

	var G30_90 = parseFloat(G30_89 - G109).toFixed(3);
	var H110 = parseFloat(G30_90 * taeg).toFixed(3);
	var G110 = parseFloat(pmt_constant - H110).toFixed(3);

	var G30_91 = parseFloat(G30_90 - G110).toFixed(3);
	var H111 = parseFloat(G30_91 * taeg).toFixed(3);
	var G111 = parseFloat(pmt_constant - H111).toFixed(3);

	var G30_92 = parseFloat(G30_91 - G111).toFixed(3);
	var H112 = parseFloat(G30_92 * taeg).toFixed(3);
	var G112 = parseFloat(pmt_constant - H112).toFixed(3);	

	var G30_93 = parseFloat(G30_92 - G112).toFixed(3);
	var H113 = parseFloat(G30_93 * taeg).toFixed(3);
	var G113 = parseFloat(pmt_constant - H113).toFixed(3);

	var G30_94 = parseFloat(G30_93 - G113).toFixed(3);
	var H114 = parseFloat(G30_94 * taeg).toFixed(3);
	var G114 = parseFloat(pmt_constant - H114).toFixed(3);
	// H103-H114
	var B44 = (parseFloat(H103)+parseFloat(H104)+parseFloat(H105)+parseFloat(H106)+parseFloat(H107)+parseFloat(H108)+parseFloat(H109)+parseFloat(H110)+parseFloat(H111)+parseFloat(H112)+parseFloat(H113)+parseFloat(H114)).toFixed(2);

	// =PROJECTIE!G$15-B44-SUM(PROJECTIE!G$40:G$45)
	var C44 = (parseFloat(G15phide.val()) - parseFloat(B44) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C44+C$30)
	var D44 = (Math.trunc(parseFloat(C44) + C30)).toFixed(2);

	var E44;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #8
	// =(980.14*(D44-C$30)/10000+1400)*(D44-C$30)/10000
	var H44 = ((980.14*(D44 - C30)/10000 + 1400) * (D44 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #8
	//=(216.16*((D44-14254)/10000)+2397)*((D44-14254)/10000)+965.58
	var I44 = ((216.16*((D44 - 14254)/10000) + 2397) * ((D44 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #8
	//Formula = 0.42*D44-8780.9
	var J44 = (0.42*D44-8780.9).toFixed(2);

	// =TRUNC(IF(D44<14255,H44,IF(D44>55960,J38,I38)))
	if (D44<14255) {
		E44 = Math.trunc(H44).toFixed(2); //Valur of E44
	}
	else if (D44>55960) {
		E44 = Math.trunc(J44).toFixed(2); //Valur of E44
	}
	else{
		E44 = Math.trunc(I44).toFixed(2); //Valur of E44
	}

	//=PROJECTIE!D$51-E44-SUM(PROJECTIE!G$40:G$43)
	var F44 = (parseFloat(D51phide.val())-parseFloat(E44)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_95 = parseFloat(G30_94 - G114).toFixed(3);
	var H115 = parseFloat(G30_95 * taeg).toFixed(3);
	var G115 = parseFloat(pmt_constant - H115).toFixed(3);

	var G30_96 = parseFloat(G30_95 - G115).toFixed(3);
	var H116 = parseFloat(G30_96 * taeg).toFixed(3);
	var G116 = parseFloat(pmt_constant - H116).toFixed(3);

	var G30_97 = parseFloat(G30_96 - G116).toFixed(3);
	var H117 = parseFloat(G30_97 * taeg).toFixed(3);
	var G117 = parseFloat(pmt_constant - H117).toFixed(3);

	var G30_98 = parseFloat(G30_97 - G117).toFixed(3);
	var H118 = parseFloat(G30_98 * taeg).toFixed(3);
	var G118 = parseFloat(pmt_constant - H118).toFixed(3);

	var G30_99 = parseFloat(G30_98 - G118).toFixed(3);
	var H119 = parseFloat(G30_99 * taeg).toFixed(3);
	var G119 = parseFloat(pmt_constant - H119).toFixed(3);

	var G30_100 = parseFloat(G30_99 - G119).toFixed(3);
	var H120 = parseFloat(G30_100 * taeg).toFixed(3);
	var G120 = parseFloat(pmt_constant - H120).toFixed(3);

	var G30_101 = parseFloat(G30_100 - G120).toFixed(3);
	var H121 = parseFloat(G30_101 * taeg).toFixed(3);
	var G121 = parseFloat(pmt_constant - H121).toFixed(3);

	var G30_102 = parseFloat(G30_101 - G121).toFixed(3);
	var H122 = parseFloat(G30_102 * taeg).toFixed(3);
	var G122 = parseFloat(pmt_constant - H122).toFixed(3);

	var G30_103 = parseFloat(G30_102 - G122).toFixed(3);
	var H123 = parseFloat(G30_103 * taeg).toFixed(3);
	var G123 = parseFloat(pmt_constant - H123).toFixed(3);

	var G30_104 = parseFloat(G30_103 - G123).toFixed(3);
	var H124 = parseFloat(G30_104 * taeg).toFixed(3);
	var G124 = parseFloat(pmt_constant - H124).toFixed(3);

	var G30_105 = parseFloat(G30_104 - G124).toFixed(3);
	var H125 = parseFloat(G30_105 * taeg).toFixed(3);
	var G125 = parseFloat(pmt_constant - H125).toFixed(3);

	var G30_106 = parseFloat(G30_105 - G125).toFixed(3);
	var H126 = parseFloat(G30_106 * taeg).toFixed(3);
	var G126 = parseFloat(pmt_constant - H126).toFixed(3);
	// H115-H126
	var B45 = (parseFloat(H115)+parseFloat(H116)+parseFloat(H117)+parseFloat(H118)+parseFloat(H119)+parseFloat(H120)+parseFloat(H121)+parseFloat(H122)+parseFloat(H123)+parseFloat(H124)+parseFloat(H125)+parseFloat(H126)).toFixed(2);

	// =PROJECTIE!G$15-B45-SUM(PROJECTIE!G$40:G$45)
	var C45 = (parseFloat(G15phide.val()) - parseFloat(B45) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C45+C$30)
	var D45 = (Math.trunc(parseFloat(C45) + C30)).toFixed(2);

	var E45;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #9
	// =(980.14*(D45-C$30)/10000+1400)*(D45-C$30)/10000
	var H45 = ((980.14*(D45 - C30)/10000 + 1400) * (D45 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #9
	//=(216.16*((D45-14254)/10000)+2397)*((D45-14254)/10000)+965.58
	var I45 = ((216.16*((D45 - 14254)/10000) + 2397) * ((D45 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #9
	//Formula = 0.42*D45-8780.9
	var J45 = (0.42*D45-8780.9).toFixed(2);

	// =TRUNC(IF(D45<14255,H45,IF(D45>55960,J38,I38)))
	if (D45<14255) {
		E45 = Math.trunc(H45).toFixed(2); //Valur of E45
	}
	else if (D45>55960) {
		E45 = Math.trunc(J45).toFixed(2); //Valur of E45
	}
	else{
		E45 = Math.trunc(I45).toFixed(2); //Valur of E45
	}
	//=PROJECTIE!D$51-E45-SUM(PROJECTIE!G$40:G$43)
	var F45 = (parseFloat(D51phide.val())-parseFloat(E45)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_107 = parseFloat(G30_106 - G126).toFixed(3);
	var H127 = parseFloat(G30_107 * taeg).toFixed(3);
	var G127 = parseFloat(pmt_constant - H127).toFixed(3);

	var G30_108 = parseFloat(G30_107 - G127).toFixed(3);
	var H128 = parseFloat(G30_108 * taeg).toFixed(3);
	var G128 = parseFloat(pmt_constant - H128).toFixed(3);

	var G30_109 = parseFloat(G30_108 - G128).toFixed(3);
	var H129 = parseFloat(G30_109 * taeg).toFixed(3);
	var G129 = parseFloat(pmt_constant - H129).toFixed(3);

	var G30_110 = parseFloat(G30_109 - G129).toFixed(3);
	var H130 = parseFloat(G30_110 * taeg).toFixed(3);
	var G130 = parseFloat(pmt_constant - H130).toFixed(3);

	var G30_111 = parseFloat(G30_110 - G130).toFixed(3);
	var H131 = parseFloat(G30_111 * taeg).toFixed(3);
	var G131 = parseFloat(pmt_constant - H131).toFixed(3);

	var G30_112 = parseFloat(G30_111 - G131).toFixed(3);
	var H132 = parseFloat(G30_112 * taeg).toFixed(3);
	var G132 = parseFloat(pmt_constant - H132).toFixed(3);

	var G30_113 = parseFloat(G30_112 - G132).toFixed(3);
	var H133 = parseFloat(G30_113 * taeg).toFixed(3);
	var G133 = parseFloat(pmt_constant - H133).toFixed(3);

	var G30_114 = parseFloat(G30_113 - G133).toFixed(3);
	var H134 = parseFloat(G30_114 * taeg).toFixed(3);
	var G134 = parseFloat(pmt_constant - H134).toFixed(3);

	var G30_115 = parseFloat(G30_114 - G134).toFixed(3);
	var H135 = parseFloat(G30_115 * taeg).toFixed(3);
	var G135 = parseFloat(pmt_constant - H135).toFixed(3);

	var G30_116 = parseFloat(G30_115 - G135).toFixed(3);
	var H136 = parseFloat(G30_116 * taeg).toFixed(3);
	var G136 = parseFloat(pmt_constant - H136).toFixed(3);

	var G30_117 = parseFloat(G30_116 - G136).toFixed(3);
	var H137 = parseFloat(G30_117 * taeg).toFixed(3);
	var G137 = parseFloat(pmt_constant - H137).toFixed(3);

	var G30_118 = parseFloat(G30_117 - G137).toFixed(3);
	var H138 = parseFloat(G30_118 * taeg).toFixed(3);
	var G138 = parseFloat(pmt_constant - H138).toFixed(3);
	// H127-H138
	var B46 = (parseFloat(H127)+parseFloat(H128)+parseFloat(H129)+parseFloat(H130)+parseFloat(H131)+parseFloat(H132)+parseFloat(H133)+parseFloat(H134)+parseFloat(H135)+parseFloat(H136)+parseFloat(H137)+parseFloat(H138)).toFixed(2);
	
	//=PROJECTIE!G$15-B46-SUM(PROJECTIE!G$40:G$45)
	var C46 = (parseFloat(G15phide.val()) - parseFloat(B46) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C46+C$30)
	var D46 = (Math.trunc(parseFloat(C46) + C30)).toFixed(2);

	var E46;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #10
	// =(980.14*(D46-C$30)/10000+1400)*(D46-C$30)/10000
	var H46 = ((980.14*(D46 - C30)/10000 + 1400) * (D46 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #10
	//=(216.16*((D46-14254)/10000)+2397)*((D46-14254)/10000)+965.58
	var I46 = ((216.16*((D46 - 14254)/10000) + 2397) * ((D46 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #10
	//Formula = 0.42*D46-8780.9
	var J46 = (0.42*D46-8780.9).toFixed(2);

	// =TRUNC(IF(D46<14255,H46,IF(D46>55960,J38,I38)))
	if (D46<14255) {
		E46 = Math.trunc(H46).toFixed(2); //Valur of E46
	}
	else if (D46>55960) {
		E46 = Math.trunc(J46).toFixed(2); //Valur of E46
	}
	else{
		E46 = Math.trunc(I46).toFixed(2); //Valur of E46
	}

	//=PROJECTIE!D$51-E45-SUM(PROJECTIE!G$40:G$43)
	var F46 = (parseFloat(D51phide.val())-parseFloat(E46)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);

	//===========>>>>>>>>>>>>>>>>>
	var B47 = parseFloat(B37)+parseFloat(B38)+parseFloat(B39)+parseFloat(B40)+parseFloat(B41)+parseFloat(B42)+parseFloat(B43)+parseFloat(B44)+parseFloat(B45)+parseFloat(B46);
	
	// =SUM(E37:E46)
	var E47 = (parseFloat(E37)+parseFloat(E38)+parseFloat(E39)+parseFloat(E40)+parseFloat(E41)+parseFloat(E42)+parseFloat(E43)+parseFloat(E44)+parseFloat(E45)+parseFloat(E46)).toFixed(2);
	
	// =SUM(F37:F46)
	var F47 = (parseFloat(F37)+parseFloat(F38)+parseFloat(F39)+parseFloat(F40)+parseFloat(F41)+parseFloat(F42)+parseFloat(F43)+parseFloat(F44)+parseFloat(F45)+parseFloat(F46)).toFixed(2);
	





	// ==========================================================================================
	// ==========================================================================================
	// For 15 JAR
	// ==========================================================================================
	// ==========================================================================================
	// =Berekeningsblad!F67/180-G61
	var G30_JR15  = $('#G30hide').val();
	// var taeg_JR15 = 0.019/12;
	var taeg_JR15 = (F61phide.val()/100)/12;
	var rate_JR15 = 15*12;
	var multi_JR15 = taeg_JR15 / (1 - (1 / Math.pow((1+taeg_JR15), rate_JR15)));
	var pmt_constant_JR15 = G30_JR15 * multi_JR15;
	// console.log("pmt_constant "+ pmt_constant_JR15);

	var H19_JR15 = parseFloat(G30_JR15 * taeg_JR15).toFixed(3);
	var G19_JR15 = parseFloat(pmt_constant_JR15 - H19_JR15).toFixed(3);

	var G30_JR15_0 = parseFloat(G30_JR15 - G19_JR15).toFixed(3);
	var H20_JR15 = parseFloat(G30_JR15_0 * taeg_JR15).toFixed(3);
	var G20_JR15 = parseFloat(pmt_constant_JR15 - H20_JR15).toFixed(3);

	var G30_JR15_1 = parseFloat(G30_JR15_0 - G20_JR15).toFixed(3);
	var H21_JR15 = parseFloat(G30_JR15_1 * taeg_JR15).toFixed(3);
	var G21_JR15 = parseFloat(pmt_constant_JR15 - H21_JR15).toFixed(3);

	var G30_JR15_2 = parseFloat(G30_JR15_1 - G21_JR15).toFixed(3);
	var H22_JR15 = parseFloat(G30_JR15_2 * taeg_JR15).toFixed(3);
	var G22_JR15 = parseFloat(pmt_constant_JR15 - H22_JR15).toFixed(3);

	var G30_JR15_3 = parseFloat(G30_JR15_2 - G22_JR15).toFixed(3);
	var H23_JR15 = parseFloat(G30_JR15_3 * taeg_JR15).toFixed(3);
	var G23_JR15 = parseFloat(pmt_constant_JR15 - H23_JR15).toFixed(3);

	var G30_JR15_4 = parseFloat(G30_JR15_3 - G23_JR15).toFixed(3);
	var H24_JR15 = parseFloat(G30_JR15_4 * taeg_JR15).toFixed(3);
	var G24_JR15 = parseFloat(pmt_constant_JR15 - H24_JR15).toFixed(3);

	var G30_JR15_5 = parseFloat(G30_JR15_4 - G24_JR15).toFixed(3);
	var H25_JR15 = parseFloat(G30_JR15_5 * taeg_JR15).toFixed(3);
	var G25_JR15 = parseFloat(pmt_constant_JR15 - H25_JR15).toFixed(3);

	var G30_JR15_6 = parseFloat(G30_JR15_5 - G25_JR15).toFixed(3);
	var H26_JR15 = parseFloat(G30_JR15_6 * taeg_JR15).toFixed(3);
	var G26_JR15 = parseFloat(pmt_constant_JR15 - H26_JR15).toFixed(3);

	var G30_JR15_7 = parseFloat(G30_JR15_6 - G26_JR15).toFixed(3);
	var H27_JR15 = parseFloat(G30_JR15_7 * taeg_JR15).toFixed(3);
	var G27_JR15 = parseFloat(pmt_constant_JR15 - H27_JR15).toFixed(3);

	var G30_JR15_8 = parseFloat(G30_JR15_7 - G27_JR15).toFixed(3);
	var H28_JR15 = parseFloat(G30_JR15_8 * taeg_JR15).toFixed(3);
	var G28_JR15 = parseFloat(pmt_constant_JR15 - H28_JR15).toFixed(3);

	var G30_JR15_9 = parseFloat(G30_JR15_8 - G28_JR15).toFixed(3);
	var H29_JR15 = parseFloat(G30_JR15_9 * taeg_JR15).toFixed(3);
	var G29_JR15 = parseFloat(pmt_constant_JR15 - H29_JR15).toFixed(3);

	var G30_JR15_10 = parseFloat(G30_JR15_9 - G29_JR15).toFixed(3);
	var H30_JR15 = parseFloat(G30_JR15_10 * taeg_JR15).toFixed(3);
	var G30_JR15 = parseFloat(pmt_constant_JR15 - H30_JR15).toFixed(3);

	// H19-H30 --> = SUM('Amortiss 15 ans'!H19:H30)
	var B52 = (parseFloat(H19_JR15)+parseFloat(H20_JR15)+parseFloat(H21_JR15)+parseFloat(H22_JR15)+parseFloat(H23_JR15)+parseFloat(H24_JR15)+parseFloat(H25_JR15)+parseFloat(H26_JR15)+parseFloat(H27_JR15)+parseFloat(H28_JR15)+parseFloat(H29_JR15)+parseFloat(H30_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B52-SUM(PROJECTIE!G$40:G$45)
	var C52 = (parseFloat(G15phide.val()) - parseFloat(B52) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C52+C$30)
	var D52 = (Math.trunc(parseFloat(C52) + C30)).toFixed(2);

	var E52;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #1
	// =(980.14*(D52-C$30)/10000+1400)*(D52-C$30)/10000
	var H52 = ((980.14*(D52 - C30)/10000 + 1400) * (D52 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	//=(216.16*((D52-14254)/10000)+2397)*((D45-14254)/10000)+965.58
	var I52 = ((216.16*((D52 - 14254)/10000) + 2397) * ((D52 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	//Formula = 0.42*D52-8780.9
	var J52 = (0.42*D52-8780.9).toFixed(2);

	//=TRUNC(IF(D52<14255,H52,IF(D52>55960,J52,I52)))
	if (D52<14255) {
		E52 = Math.trunc(H52).toFixed(2); //Valur of E52
	}
	else if (D52>55960) {
		E52 = Math.trunc(J52).toFixed(2); //Valur of E52
	}
	else{
		E52 = Math.trunc(I52).toFixed(2); //Valur of E52
	}
	//=PROJECTIE!D$51-E52-SUM(PROJECTIE!G$40:G$43)
	var F52 = (parseFloat(D51phide.val())-parseFloat(E52)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);


	// =====>>>>>>>>>>>>>>
	var G30_JR15_11 = parseFloat(G30_JR15_10 - G30_JR15).toFixed(3);
	var H31_JR15 = parseFloat(G30_JR15_11 * taeg_JR15).toFixed(3);
	var G31_JR15 = parseFloat(pmt_constant_JR15 - H31_JR15).toFixed(3);

	var G30_JR15_12 = parseFloat(G30_JR15_11 - G31_JR15).toFixed(3);
	var H32_JR15 = parseFloat(G30_JR15_12 * taeg_JR15).toFixed(3);
	var G32_JR15 = parseFloat(pmt_constant_JR15 - H32_JR15).toFixed(3);

	var G30_JR15_13 = parseFloat(G30_JR15_12 - G32_JR15).toFixed(3);
	var H33_JR15 = parseFloat(G30_JR15_13 * taeg_JR15).toFixed(3);
	var G33_JR15 = parseFloat(pmt_constant_JR15 - H33_JR15).toFixed(3);

	var G30_JR15_14 = parseFloat(G30_JR15_13 - G33_JR15).toFixed(3);
	var H34_JR15 = parseFloat(G30_JR15_14 * taeg_JR15).toFixed(3);
	var G34_JR15 = parseFloat(pmt_constant_JR15 - H34_JR15).toFixed(3);

	var G30_JR15_15 = parseFloat(G30_JR15_14 - G34_JR15).toFixed(3);
	var H35_JR15 = parseFloat(G30_JR15_15 * taeg_JR15).toFixed(3);
	var G35_JR15 = parseFloat(pmt_constant_JR15 - H35_JR15).toFixed(3);

	var G30_JR15_16 = parseFloat(G30_JR15_15 - G35_JR15).toFixed(3);
	var H36_JR15 = parseFloat(G30_JR15_16 * taeg_JR15).toFixed(3);
	var G36_JR15 = parseFloat(pmt_constant_JR15 - H36_JR15).toFixed(3);

	var G30_JR15_17 = parseFloat(G30_JR15_16 - G36_JR15).toFixed(3);
	var H37_JR15 = parseFloat(G30_JR15_17 * taeg_JR15).toFixed(3);
	var G37_JR15 = parseFloat(pmt_constant_JR15 - H37_JR15).toFixed(3);

	var G30_JR15_18 = parseFloat(G30_JR15_17 - G37_JR15).toFixed(3);
	var H38_JR15 = parseFloat(G30_JR15_18 * taeg_JR15).toFixed(3);
	var G38_JR15 = parseFloat(pmt_constant_JR15 - H38_JR15).toFixed(3);

	var G30_JR15_19 = parseFloat(G30_JR15_18 - G38_JR15).toFixed(3);
	var H39_JR15 = parseFloat(G30_JR15_19 * taeg_JR15).toFixed(3);
	var G39_JR15 = parseFloat(pmt_constant_JR15 - H39_JR15).toFixed(3);

	var G30_JR15_20 = parseFloat(G30_JR15_19 - G39_JR15).toFixed(3);
	var H40_JR15 = parseFloat(G30_JR15_20 * taeg_JR15).toFixed(3);
	var G40_JR15 = parseFloat(pmt_constant_JR15 - H40_JR15).toFixed(3);

	var G30_JR15_21 = parseFloat(G30_JR15_20 - G40_JR15).toFixed(3);
	var H41_JR15 = parseFloat(G30_JR15_21 * taeg_JR15).toFixed(3);
	var G41_JR15 = parseFloat(pmt_constant_JR15 - H41_JR15).toFixed(3);

	var G30_JR15_22 = parseFloat(G30_JR15_21 - G41_JR15).toFixed(3);
	var H42_JR15 = parseFloat(G30_JR15_22 * taeg_JR15).toFixed(3);
	var G42_JR15 = parseFloat(pmt_constant_JR15 - H42_JR15).toFixed(3);

	// =SUM('Amortiss 15 ans'!H31:H42)
	var B53 = (parseFloat(H31_JR15)+parseFloat(H32_JR15)+parseFloat(H33_JR15)+parseFloat(H34_JR15)+parseFloat(H35_JR15)+parseFloat(H36_JR15)+parseFloat(H37_JR15)+parseFloat(H38_JR15)+parseFloat(H39_JR15)+parseFloat(H40_JR15)+parseFloat(H41_JR15)+parseFloat(H42_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B53-SUM(PROJECTIE!G$40:G$45)
	var C53 = (parseFloat(G15phide.val()) - parseFloat(B53) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C53+C$30)
	var D53 = (Math.trunc(parseFloat(C53) + C30)).toFixed(2);

	var E53;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #2
	// =(980.14*(D53-C$30)/10000+1400)*(D53-C$30)/10000
	var H53 = ((980.14*(D53 - C30)/10000 + 1400) * (D53 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #2
	//=(216.16*((D53-14254)/10000)+2397)*((D53-14254)/10000)+965.58
	var I53 = ((216.16*((D53 - 14254)/10000) + 2397) * ((D53 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #2
	//Formula = 0.42*D53-8780.9
	var J53 = (0.42*D53-8780.9).toFixed(2);

	//=TRUNC(IF(D53<14255,H53,IF(D53>55960,J52,I52)))
	if (D53<14255) {
		E53 = Math.trunc(H53).toFixed(2); //Valur of E53
	}
	else if (D53>55960) {
		E53 = Math.trunc(J53).toFixed(2); //Valur of E53
	}
	else{
		E53 = Math.trunc(I53).toFixed(2); //Valur of E53
	}
	//=PROJECTIE!D$51-E53-SUM(PROJECTIE!G$40:G$43)
	var F53 = (parseFloat(D51phide.val())-parseFloat(E53)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);


	// =====>>>>>>>>>>>>>>
	var G30_JR15_23 = parseFloat(G30_JR15_22 - G42_JR15).toFixed(3);
	var H43_JR15 = parseFloat(G30_JR15_23 * taeg_JR15).toFixed(3);
	var G43_JR15 = parseFloat(pmt_constant_JR15 - H43_JR15).toFixed(3);

	var G30_JR15_24 = parseFloat(G30_JR15_23 - G43_JR15).toFixed(3);
	var H44_JR15 = parseFloat(G30_JR15_24 * taeg_JR15).toFixed(3);
	var G44_JR15 = parseFloat(pmt_constant_JR15 - H44_JR15).toFixed(3);

	var G30_JR15_25 = parseFloat(G30_JR15_24 - G44_JR15).toFixed(3);
	var H45_JR15 = parseFloat(G30_JR15_25 * taeg_JR15).toFixed(3);
	var G45_JR15 = parseFloat(pmt_constant_JR15 - H45_JR15).toFixed(3);

	var G30_JR15_26 = parseFloat(G30_JR15_25 - G45_JR15).toFixed(3);
	var H46_JR15 = parseFloat(G30_JR15_26 * taeg_JR15).toFixed(3);
	var G46_JR15 = parseFloat(pmt_constant_JR15 - H46_JR15).toFixed(3);

	var G30_JR15_27 = parseFloat(G30_JR15_26 - G46_JR15).toFixed(3);
	var H47_JR15 = parseFloat(G30_JR15_27 * taeg_JR15).toFixed(3);
	var G47_JR15 = parseFloat(pmt_constant_JR15 - H47_JR15).toFixed(3);

	var G30_JR15_28 = parseFloat(G30_JR15_27 - G47_JR15).toFixed(3);
	var H48_JR15 = parseFloat(G30_JR15_28 * taeg_JR15).toFixed(3);
	var G48_JR15 = parseFloat(pmt_constant_JR15 - H48_JR15).toFixed(3);

	var G30_JR15_29 = parseFloat(G30_JR15_28 - G48_JR15).toFixed(3);
	var H49_JR15 = parseFloat(G30_JR15_29 * taeg_JR15).toFixed(3);
	var G49_JR15 = parseFloat(pmt_constant_JR15 - H49_JR15).toFixed(3);

	var G30_JR15_30 = parseFloat(G30_JR15_29 - G49_JR15).toFixed(3);
	var H50_JR15 = parseFloat(G30_JR15_30 * taeg_JR15).toFixed(3);
	var G50_JR15 = parseFloat(pmt_constant_JR15 - H50_JR15).toFixed(3);

	var G30_JR15_31 = parseFloat(G30_JR15_30 - G50_JR15).toFixed(3);
	var H51_JR15 = parseFloat(G30_JR15_31 * taeg_JR15).toFixed(3);
	var G51_JR15 = parseFloat(pmt_constant_JR15 - H51_JR15).toFixed(3);

	var G30_JR15_32 = parseFloat(G30_JR15_31 - G51_JR15).toFixed(3);
	var H52_JR15 = parseFloat(G30_JR15_32 * taeg_JR15).toFixed(3);
	var G52_JR15 = parseFloat(pmt_constant_JR15 - H52_JR15).toFixed(3);

	var G30_JR15_33 = parseFloat(G30_JR15_32 - G52_JR15).toFixed(3);
	var H53_JR15 = parseFloat(G30_JR15_33 * taeg_JR15).toFixed(3);
	var G53_JR15 = parseFloat(pmt_constant_JR15 - H53_JR15).toFixed(3);

	var G30_JR15_34 = parseFloat(G30_JR15_33 - G53_JR15).toFixed(3);
	var H54_JR15 = parseFloat(G30_JR15_34 * taeg_JR15).toFixed(3);
	var G54_JR15 = parseFloat(pmt_constant_JR15 - H54_JR15).toFixed(3);

	//=SUM('Amortiss 15 ans'!H43:H54)
	var B54 = (parseFloat(H43_JR15)+parseFloat(H44_JR15)+parseFloat(H45_JR15)+parseFloat(H46_JR15)+parseFloat(H47_JR15)+parseFloat(H48_JR15)+parseFloat(H49_JR15)+parseFloat(H50_JR15)+parseFloat(H51_JR15)+parseFloat(H52_JR15)+parseFloat(H53_JR15)+parseFloat(H54_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B53-SUM(PROJECTIE!G$40:G$45)
	var C54 = (parseFloat(G15phide.val()) - parseFloat(B54) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C54+C$30)
	var D54 = (Math.trunc(parseFloat(C54) + C30)).toFixed(2);

	var E54;

	//Von 9.169 â‚¬ tot 14.254 â‚¬: #1 #3
	// =(980.14*(D54-C$30)/10000+1400)*(D54-C$30)/10000
	var H54 = ((980.14*(D54 - C30)/10000 + 1400) * (D54 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #3
	//=(216.16*((D54-14254)/10000)+2397)*((D54-14254)/10000)+965.58
	var I54 = ((216.16*((D54 - 14254)/10000) + 2397) * ((D54 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #3
	//Formula = 0.42*D54-8780.9
	var J54 = (0.42*D54-8780.9).toFixed(2);

	//=TRUNC(IF(D54<14255,H54,IF(D54>55960,J52,I52)))
	if (D54<14255) {
		E54 = Math.trunc(H54).toFixed(2); //Valur of E54
	}
	else if (D54>55960) {
		E54 = Math.trunc(J54).toFixed(2); //Valur of E54
	}
	else{
		E54 = Math.trunc(I54).toFixed(2); //Valur of E54
	}

	//=PROJECTIE!D$51-E54-SUM(PROJECTIE!G$40:G$43)
	var F54 = (parseFloat(D51phide.val())-parseFloat(E54)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);




	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_35 = parseFloat(G30_JR15_34 - G54_JR15).toFixed(3);
	var H55_JR15 = parseFloat(G30_JR15_35 * taeg_JR15).toFixed(3);
	var G55_JR15 = parseFloat(pmt_constant_JR15 - H55_JR15).toFixed(3);

	var G30_JR15_36 = parseFloat(G30_JR15_35 - G55_JR15).toFixed(3);
	var H56_JR15 = parseFloat(G30_JR15_36 * taeg_JR15).toFixed(3);
	var G56_JR15 = parseFloat(pmt_constant_JR15 - H56_JR15).toFixed(3);

	var G30_JR15_37 = parseFloat(G30_JR15_36 - G56_JR15).toFixed(3);
	var H57_JR15 = parseFloat(G30_JR15_37 * taeg_JR15).toFixed(3);
	var G57_JR15 = parseFloat(pmt_constant_JR15 - H57_JR15).toFixed(3);

	var G30_JR15_38 = parseFloat(G30_JR15_37 - G57_JR15).toFixed(3);
	var H58_JR15 = parseFloat(G30_JR15_38 * taeg_JR15).toFixed(3);
	var G58_JR15 = parseFloat(pmt_constant_JR15 - H58_JR15).toFixed(3);

	var G30_JR15_39 = parseFloat(G30_JR15_38 - G58_JR15).toFixed(3);
	var H59_JR15 = parseFloat(G30_JR15_39 * taeg_JR15).toFixed(3);
	var G59_JR15 = parseFloat(pmt_constant_JR15 - H59_JR15).toFixed(3);

	var G30_JR15_40 = parseFloat(G30_JR15_39 - G59_JR15).toFixed(3);
	var H60_JR15 = parseFloat(G30_JR15_40 * taeg_JR15).toFixed(3);
	var G60_JR15 = parseFloat(pmt_constant_JR15 - H60_JR15).toFixed(3);

	var G30_JR15_41 = parseFloat(G30_JR15_40 - G60_JR15).toFixed(3);
	var H61_JR15 = parseFloat(G30_JR15_41 * taeg_JR15).toFixed(3);
	var G61_JR15 = parseFloat(pmt_constant_JR15 - H61_JR15).toFixed(3);

	var G30_JR15_42 = parseFloat(G30_JR15_41 - G61_JR15).toFixed(3);
	var H62_JR15 = parseFloat(G30_JR15_42 * taeg_JR15).toFixed(3);
	var G62_JR15 = parseFloat(pmt_constant_JR15 - H62_JR15).toFixed(3);

	var G30_JR15_43 = parseFloat(G30_JR15_42 - G62_JR15).toFixed(3);
	var H63_JR15 = parseFloat(G30_JR15_43 * taeg_JR15).toFixed(3);
	var G63_JR15 = parseFloat(pmt_constant_JR15 - H63_JR15).toFixed(3);

	var G30_JR15_44 = parseFloat(G30_JR15_43 - G59_JR15).toFixed(3);
	var H64_JR15 = parseFloat(G30_JR15_44 * taeg_JR15).toFixed(3);
	var G64_JR15 = parseFloat(pmt_constant_JR15 - H64_JR15).toFixed(3);

	var G30_JR15_45 = parseFloat(G30_JR15_44 - G64_JR15).toFixed(3);
	var H65_JR15 = parseFloat(G30_JR15_45 * taeg_JR15).toFixed(3);
	var G65_JR15 = parseFloat(pmt_constant_JR15 - H65_JR15).toFixed(3);

	var G30_JR15_46 = parseFloat(G30_JR15_45 - G65_JR15).toFixed(3);
	var H66_JR15 = parseFloat(G30_JR15_46 * taeg_JR15).toFixed(3);
	var G66_JR15 = parseFloat(pmt_constant_JR15 - H66_JR15).toFixed(3);

	//=SUM('Amortiss 15 ans'!H55:H66)
	var B55 = (parseFloat(H55_JR15)+parseFloat(H56_JR15)+parseFloat(H57_JR15)+parseFloat(H58_JR15)+parseFloat(H59_JR15)+parseFloat(H60_JR15)+parseFloat(H61_JR15)+parseFloat(H62_JR15)+parseFloat(H63_JR15)+parseFloat(H64_JR15)+parseFloat(H65_JR15)+parseFloat(H66_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B55-SUM(PROJECTIE!G$40:G$45)
	var C55 = (parseFloat(G15phide.val()) - parseFloat(B55) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C55+C$30)
	var D55 = (Math.trunc(parseFloat(C55) + C30)).toFixed(2);

	var E55;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #4
	// =(980.14*(D55-C$30)/10000+1400)*(D55-C$30)/10000
	var H55 = ((980.14*(D55 - C30)/10000 + 1400) * (D55 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #4
	// =(216.16*((D55-14254)/10000)+2397)*((D55-14254)/10000)+965.58
	var I55 = ((216.16*((D55 - 14254)/10000) + 2397) * ((D55 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #4
	//Formula = 0.42*D55-8780.9
	var J55 = (0.42*D55-8780.9).toFixed(2);

	//=TRUNC(IF(D55<14255,H55,IF(D55>55960,J52,I52)))
	if (D55<14255) {
		E55 = Math.trunc(H55).toFixed(2); //Valur of E55
	}
	else if (D55>55960) {
		E55 = Math.trunc(J55).toFixed(2); //Valur of E55
	}
	else{
		E55 = Math.trunc(I55).toFixed(2); //Valur of E55
	}
	//=PROJECTIE!D$51-E55-SUM(PROJECTIE!G$40:G$43)
	var F55 = (parseFloat(D51phide.val())-parseFloat(E55)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_47 = parseFloat(G30_JR15_46 - G66_JR15).toFixed(3);
	var H67_JR15 = parseFloat(G30_JR15_47 * taeg_JR15).toFixed(3);
	var G67_JR15 = parseFloat(pmt_constant_JR15 - H67_JR15).toFixed(3);

	var G30_JR15_48 = parseFloat(G30_JR15_47 - G67_JR15).toFixed(3);
	var H68_JR15 = parseFloat(G30_JR15_48 * taeg_JR15).toFixed(3);
	var G68_JR15 = parseFloat(pmt_constant_JR15 - H68_JR15).toFixed(3);

	var G30_JR15_49 = parseFloat(G30_JR15_48 - G68_JR15).toFixed(3);
	var H69_JR15 = parseFloat(G30_JR15_49 * taeg_JR15).toFixed(3);
	var G69_JR15 = parseFloat(pmt_constant_JR15 - H69_JR15).toFixed(3);

	var G30_JR15_50 = parseFloat(G30_JR15_49 - G69_JR15).toFixed(3);
	var H70_JR15 = parseFloat(G30_JR15_50 * taeg_JR15).toFixed(3);
	var G70_JR15 = parseFloat(pmt_constant_JR15 - H70_JR15).toFixed(3);

	var G30_JR15_51 = parseFloat(G30_JR15_50 - G70_JR15).toFixed(3);
	var H71_JR15 = parseFloat(G30_JR15_51 * taeg_JR15).toFixed(3);
	var G71_JR15 = parseFloat(pmt_constant_JR15 - H71_JR15).toFixed(3);

	var G30_JR15_52 = parseFloat(G30_JR15_51 - G71_JR15).toFixed(3);
	var H72_JR15 = parseFloat(G30_JR15_52 * taeg_JR15).toFixed(3);
	var G72_JR15 = parseFloat(pmt_constant_JR15 - H72_JR15).toFixed(3);

	var G30_JR15_53 = parseFloat(G30_JR15_52 - G72_JR15).toFixed(3);
	var H73_JR15 = parseFloat(G30_JR15_53 * taeg_JR15).toFixed(3);
	var G73_JR15 = parseFloat(pmt_constant_JR15 - H73_JR15).toFixed(3);

	var G30_JR15_54 = parseFloat(G30_JR15_53 - G73_JR15).toFixed(3);
	var H74_JR15 = parseFloat(G30_JR15_54 * taeg_JR15).toFixed(3);
	var G74_JR15 = parseFloat(pmt_constant_JR15 - H74_JR15).toFixed(3);

	var G30_JR15_55 = parseFloat(G30_JR15_54 - G74_JR15).toFixed(3);
	var H75_JR15 = parseFloat(G30_JR15_55 * taeg_JR15).toFixed(3);
	var G75_JR15 = parseFloat(pmt_constant_JR15 - H75_JR15).toFixed(3);

	var G30_JR15_56 = parseFloat(G30_JR15_55 - G75_JR15).toFixed(3);
	var H76_JR15 = parseFloat(G30_JR15_56 * taeg_JR15).toFixed(3);
	var G76_JR15 = parseFloat(pmt_constant_JR15 - H76_JR15).toFixed(3);

	var G30_JR15_57 = parseFloat(G30_JR15_56 - G76_JR15).toFixed(3);
	var H77_JR15 = parseFloat(G30_JR15_57 * taeg_JR15).toFixed(3);
	var G77_JR15 = parseFloat(pmt_constant_JR15 - H77_JR15).toFixed(3);
	
	var G30_JR15_58 = parseFloat(G30_JR15_57 - G77_JR15).toFixed(3);
	var H78_JR15 = parseFloat(G30_JR15_58 * taeg_JR15).toFixed(3);
	var G78_JR15 = parseFloat(pmt_constant_JR15 - H78_JR15).toFixed(3);

	// =SUM('Amortiss 15 ans'!H67:H78)
	var B56 = (parseFloat(H67_JR15)+parseFloat(H68_JR15)+parseFloat(H69_JR15)+parseFloat(H70_JR15)+parseFloat(H71_JR15)+parseFloat(H72_JR15)+parseFloat(H73_JR15)+parseFloat(H74_JR15)+parseFloat(H75_JR15)+parseFloat(H76_JR15)+parseFloat(H77_JR15)+parseFloat(H78_JR15)).toFixed(2);
	
	// =PROJECTIE!G$15-B56-SUM(PROJECTIE!G$40:G$45)
	var C56 = (parseFloat(G15phide.val()) - parseFloat(B56) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C56+C$30)
	var D56 = (Math.trunc(parseFloat(C56) + C30)).toFixed(2);

	var E56;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D56-C$30)/10000+1400)*(D56-C$30)/10000
	var H56 = ((980.14*(D56 - C30)/10000 + 1400) * (D56 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D56-14254)/10000)+2397)*((D56-14254)/10000)+965.58
	var I56 = ((216.16*((D56 - 14254)/10000) + 2397) * ((D56 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D56-8780.9
	var J56 = (0.42*D56-8780.9).toFixed(2);

	//=TRUNC(IF(D56<14255,H56,IF(D55>55960,J52,I52)))
	if (D56<14255) {
		E56 = Math.trunc(H56).toFixed(2); //Valur of E56
	}
	else if (D56>55960) {
		E56 = Math.trunc(J56).toFixed(2); //Valur of E56
	}
	else{
		E56 = Math.trunc(I56).toFixed(2); //Valur of E56
	}
	//=PROJECTIE!D$51-E56-SUM(PROJECTIE!G$40:G$43)
	var F56 = (parseFloat(D51phide.val())-parseFloat(E56)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_59 = parseFloat(G30_JR15_58 - G78_JR15).toFixed(3);
	var H79_JR15 = parseFloat(G30_JR15_59 * taeg_JR15).toFixed(3);
	var G79_JR15 = parseFloat(pmt_constant_JR15 - H79_JR15).toFixed(3);

	var G30_JR15_60 = parseFloat(G30_JR15_59 - G79_JR15).toFixed(3);
	var H80_JR15 = parseFloat(G30_JR15_60 * taeg_JR15).toFixed(3);
	var G80_JR15 = parseFloat(pmt_constant_JR15 - H80_JR15).toFixed(3);

	var G30_JR15_61 = parseFloat(G30_JR15_60 - G80_JR15).toFixed(3);
	var H81_JR15 = parseFloat(G30_JR15_61 * taeg_JR15).toFixed(3);
	var G81_JR15 = parseFloat(pmt_constant_JR15 - H81_JR15).toFixed(3);

	var G30_JR15_62 = parseFloat(G30_JR15_61 - G81_JR15).toFixed(3);
	var H82_JR15 = parseFloat(G30_JR15_62 * taeg_JR15).toFixed(3);
	var G82_JR15 = parseFloat(pmt_constant_JR15 - H82_JR15).toFixed(3);

	var G30_JR15_63 = parseFloat(G30_JR15_62 - G82_JR15).toFixed(3);
	var H83_JR15 = parseFloat(G30_JR15_63 * taeg_JR15).toFixed(3);
	var G83_JR15 = parseFloat(pmt_constant_JR15 - H83_JR15).toFixed(3);

	var G30_JR15_64 = parseFloat(G30_JR15_63 - G83_JR15).toFixed(3);
	var H84_JR15 = parseFloat(G30_JR15_64 * taeg_JR15).toFixed(3);
	var G84_JR15 = parseFloat(pmt_constant_JR15 - H84_JR15).toFixed(3);

	var G30_JR15_65 = parseFloat(G30_JR15_64 - G84_JR15).toFixed(3);
	var H85_JR15 = parseFloat(G30_JR15_65 * taeg_JR15).toFixed(3);
	var G85_JR15 = parseFloat(pmt_constant_JR15 - H85_JR15).toFixed(3);

	var G30_JR15_66 = parseFloat(G30_JR15_65 - G85_JR15).toFixed(3);
	var H86_JR15 = parseFloat(G30_JR15_66 * taeg_JR15).toFixed(3);
	var G86_JR15 = parseFloat(pmt_constant_JR15 - H86_JR15).toFixed(3);

	var G30_JR15_67 = parseFloat(G30_JR15_66 - G86_JR15).toFixed(3);
	var H87_JR15 = parseFloat(G30_JR15_67 * taeg_JR15).toFixed(3);
	var G87_JR15 = parseFloat(pmt_constant_JR15 - H87_JR15).toFixed(3);

	var G30_JR15_68 = parseFloat(G30_JR15_67 - G87_JR15).toFixed(3);
	var H88_JR15 = parseFloat(G30_JR15_68 * taeg_JR15).toFixed(3);
	var G88_JR15 = parseFloat(pmt_constant_JR15 - H88_JR15).toFixed(3);

	var G30_JR15_69 = parseFloat(G30_JR15_68 - G88_JR15).toFixed(3);
	var H89_JR15 = parseFloat(G30_JR15_69 * taeg_JR15).toFixed(3);
	var G89_JR15 = parseFloat(pmt_constant_JR15 - H89_JR15).toFixed(3);

	var G30_JR15_70 = parseFloat(G30_JR15_69 - G89_JR15).toFixed(3);
	var H90_JR15 = parseFloat(G30_JR15_70 * taeg_JR15).toFixed(3);
	var G90_JR15 = parseFloat(pmt_constant_JR15 - H90_JR15).toFixed(3);

	// =SUM('Amortiss 15 ans'!H79:H90)
	var B57 = (parseFloat(H79_JR15)+parseFloat(H80_JR15)+parseFloat(H81_JR15)+parseFloat(H82_JR15)+parseFloat(H83_JR15)+parseFloat(H84_JR15)+parseFloat(H85_JR15)+parseFloat(H86_JR15)+parseFloat(H87_JR15)+parseFloat(H88_JR15)+parseFloat(H89_JR15)+parseFloat(H90_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B57-SUM(PROJECTIE!G$40:G$45)
	var C57 = (parseFloat(G15phide.val()) - parseFloat(B57) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C57+C$30)
	var D57 = (Math.trunc(parseFloat(C57) + C30)).toFixed(2);

	var E57;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D57-C$30)/10000+1400)*(D57-C$30)/10000
	var H57 = ((980.14*(D57 - C30)/10000 + 1400) * (D57 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D57-14254)/10000)+2397)*((D57-14254)/10000)+965.58
	var I57 = ((216.16*((D57 - 14254)/10000) + 2397) * ((D57 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D57-8780.9
	var J57 = (0.42*D57-8780.9).toFixed(2);

	//=TRUNC(IF(D57<14255,H57,IF(D55>55960,J52,I52)))
	if (D57<14255) {
		E57 = Math.trunc(H57).toFixed(2); //Valur of E57
	}
	else if (D57>55960) {
		E57 = Math.trunc(J57).toFixed(2); //Valur of E57
	}
	else{
		E57 = Math.trunc(I57).toFixed(2); //Valur of E57
	}
	//=PROJECTIE!D$51-E57-SUM(PROJECTIE!G$40:G$43)
	var F57 = (parseFloat(D51phide.val())-parseFloat(E57)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_71 = parseFloat(G30_JR15_70 - G90_JR15).toFixed(3);
	var H91_JR15 = parseFloat(G30_JR15_71 * taeg_JR15).toFixed(3);
	var G91_JR15 = parseFloat(pmt_constant_JR15 - H91_JR15).toFixed(3);

	var G30_JR15_72 = parseFloat(G30_JR15_71 - G91_JR15).toFixed(3);
	var H92_JR15 = parseFloat(G30_JR15_72 * taeg_JR15).toFixed(3);
	var G92_JR15 = parseFloat(pmt_constant_JR15 - H92_JR15).toFixed(3);

	var G30_JR15_73 = parseFloat(G30_JR15_72 - G92_JR15).toFixed(3);
	var H93_JR15 = parseFloat(G30_JR15_73 * taeg_JR15).toFixed(3);
	var G93_JR15 = parseFloat(pmt_constant_JR15 - H93_JR15).toFixed(3);

	var G30_JR15_74 = parseFloat(G30_JR15_73 - G93_JR15).toFixed(3);
	var H94_JR15 = parseFloat(G30_JR15_74 * taeg_JR15).toFixed(3);
	var G94_JR15 = parseFloat(pmt_constant_JR15 - H94_JR15).toFixed(3);

	var G30_JR15_75 = parseFloat(G30_JR15_74 - G94_JR15).toFixed(3);
	var H95_JR15 = parseFloat(G30_JR15_75 * taeg_JR15).toFixed(3);
	var G95_JR15 = parseFloat(pmt_constant_JR15 - H95_JR15).toFixed(3);

	var G30_JR15_76 = parseFloat(G30_JR15_75 - G95_JR15).toFixed(3);
	var H96_JR15 = parseFloat(G30_JR15_76 * taeg_JR15).toFixed(3);
	var G96_JR15 = parseFloat(pmt_constant_JR15 - H96_JR15).toFixed(3);

	var G30_JR15_77 = parseFloat(G30_JR15_76 - G96_JR15).toFixed(3);
	var H97_JR15 = parseFloat(G30_JR15_77 * taeg_JR15).toFixed(3);
	var G97_JR15 = parseFloat(pmt_constant_JR15 - H97_JR15).toFixed(3);

	var G30_JR15_78 = parseFloat(G30_JR15_77 - G97_JR15).toFixed(3);
	var H98_JR15 = parseFloat(G30_JR15_78 * taeg_JR15).toFixed(3);
	var G98_JR15 = parseFloat(pmt_constant_JR15 - H98_JR15).toFixed(3);

	var G30_JR15_79 = parseFloat(G30_JR15_78 - G98_JR15).toFixed(3);
	var H99_JR15 = parseFloat(G30_JR15_79 * taeg_JR15).toFixed(3);
	var G99_JR15 = parseFloat(pmt_constant_JR15 - H99_JR15).toFixed(3);

	var G30_JR15_80 = parseFloat(G30_JR15_79 - G99_JR15).toFixed(3);
	var H100_JR15 = parseFloat(G30_JR15_80 * taeg_JR15).toFixed(3);
	var G100_JR15 = parseFloat(pmt_constant_JR15 - H100_JR15).toFixed(3);

	var G30_JR15_81 = parseFloat(G30_JR15_80 - G100_JR15).toFixed(3);
	var H101_JR15 = parseFloat(G30_JR15_81 * taeg_JR15).toFixed(3);
	var G101_JR15 = parseFloat(pmt_constant_JR15 - H101_JR15).toFixed(3);

	var G30_JR15_82 = parseFloat(G30_JR15_81 - G101_JR15).toFixed(3);
	var H102_JR15 = parseFloat(G30_JR15_82 * taeg_JR15).toFixed(3);
	var G102_JR15 = parseFloat(pmt_constant_JR15 - H102_JR15).toFixed(3);

	// =SUM('Amortiss 15 ans'!H91:H102)
	var B58 = (parseFloat(H91_JR15)+parseFloat(H92_JR15)+parseFloat(H93_JR15)+parseFloat(H94_JR15)+parseFloat(H95_JR15)+parseFloat(H96_JR15)+parseFloat(H97_JR15)+parseFloat(H98_JR15)+parseFloat(H99_JR15)+parseFloat(H100_JR15)+parseFloat(H101_JR15)+parseFloat(H102_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B57-SUM(PROJECTIE!G$40:G$45)
	var C58 = (parseFloat(G15phide.val()) - parseFloat(B58) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C57+C$30)
	var D58 = (Math.trunc(parseFloat(C58) + C30)).toFixed(2);

	var E58;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D58-C$30)/10000+1400)*(D58-C$30)/10000
	var H58 = ((980.14*(D58 - C30)/10000 + 1400) * (D58 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D58-14254)/10000)+2397)*((D58-14254)/10000)+965.58
	var I58 = ((216.16*((D58 - 14254)/10000) + 2397) * ((D58 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D58-8780.9
	var J58 = (0.42*D58-8780.9).toFixed(2);

	//=TRUNC(IF(D58<14255,H58,IF(D55>55960,J52,I52)))
	if (D58<14255) {
		E58 = Math.trunc(H58).toFixed(2); //Valur of E58
	}
	else if (D58>55960) {
		E58 = Math.trunc(J58).toFixed(2); //Valur of E58
	}
	else{
		E58 = Math.trunc(I58).toFixed(2); //Valur of E58
	}
	//=PROJECTIE!D$51-E58-SUM(PROJECTIE!G$40:G$43)
	var F58 = (parseFloat(D51phide.val())-parseFloat(E58)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_83 = parseFloat(G30_JR15_82 - G102_JR15).toFixed(3);
	var H103_JR15 = parseFloat(G30_JR15_83 * taeg_JR15).toFixed(3);
	var G103_JR15 = parseFloat(pmt_constant_JR15 - H103_JR15).toFixed(3);

	var G30_JR15_84 = parseFloat(G30_JR15_83 - G103_JR15).toFixed(3);
	var H104_JR15 = parseFloat(G30_JR15_84 * taeg_JR15).toFixed(3);
	var G104_JR15 = parseFloat(pmt_constant_JR15 - H104_JR15).toFixed(3);

	var G30_JR15_85 = parseFloat(G30_JR15_84 - G104_JR15).toFixed(3);
	var H105_JR15 = parseFloat(G30_JR15_85 * taeg_JR15).toFixed(3);
	var G105_JR15 = parseFloat(pmt_constant_JR15 - H105_JR15).toFixed(3);

	var G30_JR15_86 = parseFloat(G30_JR15_85 - G105_JR15).toFixed(3);
	var H106_JR15 = parseFloat(G30_JR15_86 * taeg_JR15).toFixed(3);
	var G106_JR15 = parseFloat(pmt_constant_JR15 - H106_JR15).toFixed(3);

	var G30_JR15_87 = parseFloat(G30_JR15_86 - G106_JR15).toFixed(3);
	var H107_JR15 = parseFloat(G30_JR15_87 * taeg_JR15).toFixed(3);
	var G107_JR15 = parseFloat(pmt_constant_JR15 - H107_JR15).toFixed(3);	

	var G30_JR15_88 = parseFloat(G30_JR15_87 - G107_JR15).toFixed(3);
	var H108_JR15 = parseFloat(G30_JR15_88 * taeg_JR15).toFixed(3);
	var G108_JR15 = parseFloat(pmt_constant_JR15 - H108_JR15).toFixed(3);	

	var G30_JR15_89 = parseFloat(G30_JR15_88 - G108_JR15).toFixed(3);
	var H109_JR15 = parseFloat(G30_JR15_89 * taeg_JR15).toFixed(3);
	var G109_JR15 = parseFloat(pmt_constant_JR15 - H109_JR15).toFixed(3);	

	var G30_JR15_90 = parseFloat(G30_JR15_89 - G109_JR15).toFixed(3);
	var H110_JR15 = parseFloat(G30_JR15_90 * taeg_JR15).toFixed(3);
	var G110_JR15 = parseFloat(pmt_constant_JR15 - H110_JR15).toFixed(3);

	var G30_JR15_91 = parseFloat(G30_JR15_90 - G110_JR15).toFixed(3);
	var H111_JR15 = parseFloat(G30_JR15_91 * taeg_JR15).toFixed(3);
	var G111_JR15 = parseFloat(pmt_constant_JR15 - H111_JR15).toFixed(3);

	var G30_JR15_92 = parseFloat(G30_JR15_91 - G111_JR15).toFixed(3);
	var H112_JR15 = parseFloat(G30_JR15_92 * taeg_JR15).toFixed(3);
	var G112_JR15 = parseFloat(pmt_constant_JR15 - H112_JR15).toFixed(3);	

	var G30_JR15_93 = parseFloat(G30_JR15_92 - G112_JR15).toFixed(3);
	var H113_JR15 = parseFloat(G30_JR15_93 * taeg_JR15).toFixed(3);
	var G113_JR15 = parseFloat(pmt_constant_JR15 - H113_JR15).toFixed(3);

	var G30_JR15_94 = parseFloat(G30_JR15_93 - G113_JR15).toFixed(3);
	var H114_JR15 = parseFloat(G30_JR15_94 * taeg_JR15).toFixed(3);
	var G114_JR15 = parseFloat(pmt_constant_JR15 - H114_JR15).toFixed(3);
	//=SUM('Amortiss 15 ans'!H103:H114)
	var B59 = (parseFloat(H103_JR15)+parseFloat(H104_JR15)+parseFloat(H105_JR15)+parseFloat(H106_JR15)+parseFloat(H107_JR15)+parseFloat(H108_JR15)+parseFloat(H109_JR15)+parseFloat(H110_JR15)+parseFloat(H111_JR15)+parseFloat(H112_JR15)+parseFloat(H113_JR15)+parseFloat(H114_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B59-SUM(PROJECTIE!G$40:G$45)
	var C59 = (parseFloat(G15phide.val()) - parseFloat(B59) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C57+C$30)
	var D59 = (Math.trunc(parseFloat(C59) + C30)).toFixed(2);

	var E59;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D59-C$30)/10000+1400)*(D59-C$30)/10000
	var H59 = ((980.14*(D59 - C30)/10000 + 1400) * (D59 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D59-14254)/10000)+2397)*((D59-14254)/10000)+965.58
	var I59 = ((216.16*((D59 - 14254)/10000) + 2397) * ((D59 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D59-8780.9
	var J59 = (0.42*D59-8780.9).toFixed(2);

	//=TRUNC(IF(D59<14255,H59,IF(D55>55960,J52,I52)))
	if (D59<14255) {
		E59 = Math.trunc(H59).toFixed(2); //Valur of E59
	}
	else if (D59>55960) {
		E59 = Math.trunc(J59).toFixed(2); //Valur of E59
	}
	else{
		E59 = Math.trunc(I59).toFixed(2); //Valur of E59
	}
	//=PROJECTIE!D$51-E57-SUM(PROJECTIE!G$40:G$43)
	var F59 = (parseFloat(D51phide.val())-parseFloat(E59)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_95 = parseFloat(G30_JR15_94 - G114_JR15).toFixed(3);
	var H115_JR15 = parseFloat(G30_JR15_95 * taeg_JR15).toFixed(3);
	var G115_JR15 = parseFloat(pmt_constant_JR15 - H115_JR15).toFixed(3);

	var G30_JR15_96 = parseFloat(G30_JR15_95 - G115_JR15).toFixed(3);
	var H116_JR15 = parseFloat(G30_JR15_96 * taeg_JR15).toFixed(3);
	var G116_JR15 = parseFloat(pmt_constant_JR15 - H116_JR15).toFixed(3);

	var G30_JR15_97 = parseFloat(G30_JR15_96 - G116_JR15).toFixed(3);
	var H117_JR15 = parseFloat(G30_JR15_97 * taeg_JR15).toFixed(3);
	var G117_JR15 = parseFloat(pmt_constant_JR15 - H117_JR15).toFixed(3);

	var G30_JR15_98 = parseFloat(G30_JR15_97 - G117_JR15).toFixed(3);
	var H118_JR15 = parseFloat(G30_JR15_98 * taeg_JR15).toFixed(3);
	var G118_JR15 = parseFloat(pmt_constant_JR15 - H118_JR15).toFixed(3);

	var G30_JR15_99 = parseFloat(G30_JR15_98 - G118_JR15).toFixed(3);
	var H119_JR15 = parseFloat(G30_JR15_99 * taeg_JR15).toFixed(3);
	var G119_JR15 = parseFloat(pmt_constant_JR15 - H119_JR15).toFixed(3);

	var G30_JR15_100 = parseFloat(G30_JR15_99 - G119_JR15).toFixed(3);
	var H120_JR15 = parseFloat(G30_JR15_100 * taeg_JR15).toFixed(3);
	var G120_JR15 = parseFloat(pmt_constant_JR15 - H120_JR15).toFixed(3);

	var G30_JR15_101 = parseFloat(G30_JR15_100 - G120_JR15).toFixed(3);
	var H121_JR15 = parseFloat(G30_JR15_101 * taeg_JR15).toFixed(3);
	var G121_JR15 = parseFloat(pmt_constant_JR15 - H121_JR15).toFixed(3);

	var G30_JR15_102 = parseFloat(G30_JR15_101 - G121_JR15).toFixed(3);
	var H122_JR15 = parseFloat(G30_JR15_102 * taeg_JR15).toFixed(3);
	var G122_JR15 = parseFloat(pmt_constant_JR15 - H122_JR15).toFixed(3);

	var G30_JR15_103 = parseFloat(G30_JR15_102 - G122_JR15).toFixed(3);
	var H123_JR15 = parseFloat(G30_JR15_103 * taeg_JR15).toFixed(3);
	var G123_JR15 = parseFloat(pmt_constant_JR15 - H123_JR15).toFixed(3);

	var G30_JR15_104 = parseFloat(G30_JR15_103 - G123_JR15).toFixed(3);
	var H124_JR15 = parseFloat(G30_JR15_104 * taeg_JR15).toFixed(3);
	var G124_JR15 = parseFloat(pmt_constant_JR15 - H124_JR15).toFixed(3);

	var G30_JR15_105 = parseFloat(G30_JR15_104 - G124_JR15).toFixed(3);
	var H125_JR15 = parseFloat(G30_JR15_105 * taeg_JR15).toFixed(3);
	var G125_JR15 = parseFloat(pmt_constant_JR15 - H125_JR15).toFixed(3);

	var G30_JR15_106 = parseFloat(G30_JR15_105 - G125_JR15).toFixed(3);
	var H126_JR15 = parseFloat(G30_JR15_106 * taeg_JR15).toFixed(3);
	var G126_JR15 = parseFloat(pmt_constant_JR15 - H126_JR15).toFixed(3);
	// =SUM('Amortiss 15 ans'!H115:H126)
	var B60 = (parseFloat(H115_JR15)+parseFloat(H116_JR15)+parseFloat(H117_JR15)+parseFloat(H118_JR15)+parseFloat(H119_JR15)+parseFloat(H120_JR15)+parseFloat(H121_JR15)+parseFloat(H122_JR15)+parseFloat(H123_JR15)+parseFloat(H124_JR15)+parseFloat(H125_JR15)+parseFloat(H126_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B60-SUM(PROJECTIE!G$40:G$45)
	var C60 = (parseFloat(G15phide.val()) - parseFloat(B60) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C60+C$30)
	var D60 = (Math.trunc(parseFloat(C60) + C30)).toFixed(2);

	var E60;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D60-C$30)/10000+1400)*(D60-C$30)/10000
	var H60 = ((980.14*(D60 - C30)/10000 + 1400) * (D60 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D60-14254)/10000)+2397)*((D60-14254)/10000)+965.58
	var I60 = ((216.16*((D60 - 14254)/10000) + 2397) * ((D60 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D60-8780.9
	var J60 = (0.42*D60-8780.9).toFixed(2);

	//=TRUNC(IF(D60<14255,H60,IF(D55>55960,J52,I52)))
	if (D60<14255) {
		E60 = Math.trunc(H60).toFixed(2); //Valur of E60
	}
	else if (D60>55960) {
		E60 = Math.trunc(J60).toFixed(2); //Valur of E60
	}
	else{
		E60 = Math.trunc(I60).toFixed(2); //Valur of E60
	}
	//=PROJECTIE!D$51-E57-SUM(PROJECTIE!G$40:G$43)
	var F60 = (parseFloat(D51phide.val())-parseFloat(E60)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_107 = parseFloat(G30_JR15_106 - G126_JR15).toFixed(3);
	var H127_JR15 = parseFloat(G30_JR15_107 * taeg_JR15).toFixed(3);
	var G127_JR15 = parseFloat(pmt_constant_JR15 - H127_JR15).toFixed(3);

	var G30_JR15_108 = parseFloat(G30_JR15_107 - G127_JR15).toFixed(3);
	var H128_JR15 = parseFloat(G30_JR15_108 * taeg_JR15).toFixed(3);
	var G128_JR15 = parseFloat(pmt_constant_JR15 - H128_JR15).toFixed(3);

	var G30_JR15_109 = parseFloat(G30_JR15_108 - G128_JR15).toFixed(3);
	var H129_JR15 = parseFloat(G30_JR15_109 * taeg_JR15).toFixed(3);
	var G129_JR15 = parseFloat(pmt_constant_JR15 - H129_JR15).toFixed(3);

	var G30_JR15_110 = parseFloat(G30_JR15_109 - G129_JR15).toFixed(3);
	var H130_JR15 = parseFloat(G30_JR15_110 * taeg_JR15).toFixed(3);
	var G130_JR15 = parseFloat(pmt_constant_JR15 - H130_JR15).toFixed(3);

	var G30_JR15_111 = parseFloat(G30_JR15_110 - G130_JR15).toFixed(3);
	var H131_JR15 = parseFloat(G30_JR15_111 * taeg_JR15).toFixed(3);
	var G131_JR15 = parseFloat(pmt_constant_JR15 - H131_JR15).toFixed(3);

	var G30_JR15_112 = parseFloat(G30_JR15_111 - G131_JR15).toFixed(3);
	var H132_JR15 = parseFloat(G30_JR15_112 * taeg_JR15).toFixed(3);
	var G132_JR15 = parseFloat(pmt_constant_JR15 - H132_JR15).toFixed(3);

	var G30_JR15_113 = parseFloat(G30_JR15_112 - G132_JR15).toFixed(3);
	var H133_JR15 = parseFloat(G30_JR15_113 * taeg_JR15).toFixed(3);
	var G133_JR15 = parseFloat(pmt_constant_JR15 - H133_JR15).toFixed(3);

	var G30_JR15_114 = parseFloat(G30_JR15_113 - G133_JR15).toFixed(3);
	var H134_JR15 = parseFloat(G30_JR15_114 * taeg_JR15).toFixed(3);
	var G134_JR15 = parseFloat(pmt_constant_JR15 - H134_JR15).toFixed(3);

	var G30_JR15_115 = parseFloat(G30_JR15_114 - G134_JR15).toFixed(3);
	var H135_JR15 = parseFloat(G30_JR15_115 * taeg_JR15).toFixed(3);
	var G135_JR15 = parseFloat(pmt_constant_JR15 - H135_JR15).toFixed(3);

	var G30_JR15_116 = parseFloat(G30_JR15_115 - G135_JR15).toFixed(3);
	var H136_JR15 = parseFloat(G30_JR15_116 * taeg_JR15).toFixed(3);
	var G136_JR15 = parseFloat(pmt_constant_JR15 - H136_JR15).toFixed(3);

	var G30_JR15_117 = parseFloat(G30_JR15_116 - G136_JR15).toFixed(3);
	var H137_JR15 = parseFloat(G30_JR15_117 * taeg_JR15).toFixed(3);
	var G137_JR15 = parseFloat(pmt_constant_JR15 - H137_JR15).toFixed(3);

	var G30_JR15_118 = parseFloat(G30_JR15_117 - G137_JR15).toFixed(3);
	var H138_JR15 = parseFloat(G30_JR15_118 * taeg_JR15).toFixed(3);
	var G138_JR15 = parseFloat(pmt_constant_JR15 - H138_JR15).toFixed(3);
	// =SUM('Amortiss 15 ans'!H127:H138)
	var B61 = (parseFloat(H127_JR15)+parseFloat(H128_JR15)+parseFloat(H129_JR15)+parseFloat(H130_JR15)+parseFloat(H131_JR15)+parseFloat(H132_JR15)+parseFloat(H133_JR15)+parseFloat(H134_JR15)+parseFloat(H135_JR15)+parseFloat(H136_JR15)+parseFloat(H137_JR15)+parseFloat(H138_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B61-SUM(PROJECTIE!G$40:G$45)
	var C61 = (parseFloat(G15phide.val()) - parseFloat(B61) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C61+C$30)
	var D61 = (Math.trunc(parseFloat(C61) + C30)).toFixed(2);

	var E61;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D61-C$30)/10000+1400)*(D61-C$30)/10000
	var H61 = ((980.14*(D61- C30)/10000 + 1400) * (D61 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D61-14254)/10000)+2397)*((D61-14254)/10000)+965.58
	var I61 = ((216.16*((D61 - 14254)/10000) + 2397) * ((D61 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D61-8780.9
	var J61 = (0.42*D61-8780.9).toFixed(2);

	//=TRUNC(IF(D61<14255,H61,IF(D55>55960,J52,I52)))
	if (D61<14255) {
		E61 = Math.trunc(H61).toFixed(2); //Valur of E61
	}
	else if (D61>55960) {
		E61 = Math.trunc(J61).toFixed(2); //Valur of E61
	}
	else{
		E61 = Math.trunc(I61).toFixed(2); //Valur of E61
	}
	//=PROJECTIE!D$51-E61-SUM(PROJECTIE!G$40:G$43)
	var F61 = (parseFloat(D51phide.val())-parseFloat(E61)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_119 = parseFloat(G30_JR15_118 - G138_JR15).toFixed(3);
	var H139_JR15 = parseFloat(G30_JR15_119 * taeg_JR15).toFixed(3);
	var G139_JR15 = parseFloat(pmt_constant_JR15 - H139_JR15).toFixed(3);

	var G30_JR15_120 = parseFloat(G30_JR15_119 - G139_JR15).toFixed(3);
	var H140_JR15 = parseFloat(G30_JR15_120 * taeg_JR15).toFixed(3);
	var G140_JR15 = parseFloat(pmt_constant_JR15 - H140_JR15).toFixed(3);

	var G30_JR15_121 = parseFloat(G30_JR15_120 - G140_JR15).toFixed(3);
	var H141_JR15 = parseFloat(G30_JR15_121 * taeg_JR15).toFixed(3);
	var G141_JR15 = parseFloat(pmt_constant_JR15 - H141_JR15).toFixed(3);

	var G30_JR15_122 = parseFloat(G30_JR15_121 - G141_JR15).toFixed(3);
	var H142_JR15 = parseFloat(G30_JR15_122 * taeg_JR15).toFixed(3);
	var G142_JR15 = parseFloat(pmt_constant_JR15 - H142_JR15).toFixed(3);

	var G30_JR15_123 = parseFloat(G30_JR15_122 - G142_JR15).toFixed(3);
	var H143_JR15 = parseFloat(G30_JR15_123 * taeg_JR15).toFixed(3);
	var G143_JR15 = parseFloat(pmt_constant_JR15 - H143_JR15).toFixed(3);

	var G30_JR15_124 = parseFloat(G30_JR15_123 - G143_JR15).toFixed(3);
	var H144_JR15 = parseFloat(G30_JR15_124 * taeg_JR15).toFixed(3);
	var G144_JR15 = parseFloat(pmt_constant_JR15 - H144_JR15).toFixed(3);

	var G30_JR15_125 = parseFloat(G30_JR15_124 - G144_JR15).toFixed(3);
	var H145_JR15 = parseFloat(G30_JR15_125 * taeg_JR15).toFixed(3);
	var G145_JR15 = parseFloat(pmt_constant_JR15 - H145_JR15).toFixed(3);

	var G30_JR15_126 = parseFloat(G30_JR15_125 - G145_JR15).toFixed(3);
	var H146_JR15 = parseFloat(G30_JR15_126 * taeg_JR15).toFixed(3);
	var G146_JR15 = parseFloat(pmt_constant_JR15 - H146_JR15).toFixed(3);

	var G30_JR15_127 = parseFloat(G30_JR15_126 - G146_JR15).toFixed(3);
	var H147_JR15 = parseFloat(G30_JR15_127 * taeg_JR15).toFixed(3);
	var G147_JR15 = parseFloat(pmt_constant_JR15 - H147_JR15).toFixed(3);

	var G30_JR15_128 = parseFloat(G30_JR15_127 - G147_JR15).toFixed(3);
	var H148_JR15 = parseFloat(G30_JR15_128 * taeg_JR15).toFixed(3);
	var G148_JR15 = parseFloat(pmt_constant_JR15 - H148_JR15).toFixed(3);

	var G30_JR15_129 = parseFloat(G30_JR15_128 - G148_JR15).toFixed(3);
	var H149_JR15 = parseFloat(G30_JR15_129 * taeg_JR15).toFixed(3);
	var G149_JR15 = parseFloat(pmt_constant_JR15 - H149_JR15).toFixed(3);

	var G30_JR15_130 = parseFloat(G30_JR15_129 - G149_JR15).toFixed(3);
	var H150_JR15 = parseFloat(G30_JR15_130 * taeg_JR15).toFixed(3);
	var G150_JR15 = parseFloat(pmt_constant_JR15 - H150_JR15).toFixed(3);
	// =SUM('Amortiss 15 ans'!H139:H150)
	var B62 = (parseFloat(H139_JR15)+parseFloat(H140_JR15)+parseFloat(H141_JR15)+parseFloat(H142_JR15)+parseFloat(H143_JR15)+parseFloat(H144_JR15)+parseFloat(H145_JR15)+parseFloat(H146_JR15)+parseFloat(H147_JR15)+parseFloat(H148_JR15)+parseFloat(H149_JR15)+parseFloat(H150_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B61-SUM(PROJECTIE!G$40:G$45)
	var C62 = (parseFloat(G15phide.val()) - parseFloat(B62) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C62+C$30)
	var D62 = (Math.trunc(parseFloat(C62) + C30)).toFixed(2);

	var E62;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D62-C$30)/10000+1400)*(D62-C$30)/10000
	var H62 = ((980.14*(D62- C30)/10000 + 1400) * (D62 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D62-14254)/10000)+2397)*((D62-14254)/10000)+965.58
	var I62 = ((216.16*((D62 - 14254)/10000) + 2397) * ((D62 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D62-8780.9
	var J62 = (0.42*D62-8780.9).toFixed(2);

	//=TRUNC(IF(D62<14255,H62,IF(D55>55960,J62,I62)))
	if (D62<14255) {
		E62 = Math.trunc(H62).toFixed(2); //Valur of E62
	}
	else if (D62>55960) {
		E62 = Math.trunc(J62).toFixed(2); //Valur of E62
	}
	else{
		E62 = Math.trunc(I62).toFixed(2); //Valur of E62
	}
	//=PROJECTIE!D$51-E62-SUM(PROJECTIE!G$40:G$43)
	var F62 = (parseFloat(D51phide.val())-parseFloat(E62)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_131 = parseFloat(G30_JR15_130 - G150_JR15).toFixed(3);
	var H151_JR15 = parseFloat(G30_JR15_131 * taeg_JR15).toFixed(3);
	var G151_JR15 = parseFloat(pmt_constant_JR15 - H151_JR15).toFixed(3);

	var G30_JR15_132 = parseFloat(G30_JR15_131 - G151_JR15).toFixed(3);
	var H152_JR15 = parseFloat(G30_JR15_132 * taeg_JR15).toFixed(3);
	var G152_JR15 = parseFloat(pmt_constant_JR15 - H152_JR15).toFixed(3);

	var G30_JR15_133 = parseFloat(G30_JR15_132 - G152_JR15).toFixed(3);
	var H153_JR15 = parseFloat(G30_JR15_133 * taeg_JR15).toFixed(3);
	var G153_JR15 = parseFloat(pmt_constant_JR15 - H153_JR15).toFixed(3);

	var G30_JR15_134 = parseFloat(G30_JR15_133 - G153_JR15).toFixed(3);
	var H154_JR15 = parseFloat(G30_JR15_134 * taeg_JR15).toFixed(3);
	var G154_JR15 = parseFloat(pmt_constant_JR15 - H154_JR15).toFixed(3);

	var G30_JR15_135 = parseFloat(G30_JR15_134 - G154_JR15).toFixed(3);
	var H155_JR15 = parseFloat(G30_JR15_135 * taeg_JR15).toFixed(3);
	var G155_JR15 = parseFloat(pmt_constant_JR15 - H155_JR15).toFixed(3);

	var G30_JR15_136 = parseFloat(G30_JR15_135 - G155_JR15).toFixed(3);
	var H156_JR15 = parseFloat(G30_JR15_136 * taeg_JR15).toFixed(3);
	var G156_JR15 = parseFloat(pmt_constant_JR15 - H156_JR15).toFixed(3);

	var G30_JR15_137 = parseFloat(G30_JR15_136 - G156_JR15).toFixed(3);
	var H157_JR15 = parseFloat(G30_JR15_137 * taeg_JR15).toFixed(3);
	var G157_JR15 = parseFloat(pmt_constant_JR15 - H157_JR15).toFixed(3);

	var G30_JR15_138 = parseFloat(G30_JR15_137 - G157_JR15).toFixed(3);
	var H158_JR15 = parseFloat(G30_JR15_138 * taeg_JR15).toFixed(3);
	var G158_JR15 = parseFloat(pmt_constant_JR15 - H158_JR15).toFixed(3);

	var G30_JR15_139 = parseFloat(G30_JR15_138 - G158_JR15).toFixed(3);
	var H159_JR15 = parseFloat(G30_JR15_139 * taeg_JR15).toFixed(3);
	var G159_JR15 = parseFloat(pmt_constant_JR15 - H159_JR15).toFixed(3);

	var G30_JR15_140 = parseFloat(G30_JR15_139 - G159_JR15).toFixed(3);
	var H160_JR15 = parseFloat(G30_JR15_140 * taeg_JR15).toFixed(3);
	var G160_JR15 = parseFloat(pmt_constant_JR15 - H160_JR15).toFixed(3);

	var G30_JR15_141 = parseFloat(G30_JR15_140 - G160_JR15).toFixed(3);
	var H161_JR15 = parseFloat(G30_JR15_141 * taeg_JR15).toFixed(3);
	var G161_JR15 = parseFloat(pmt_constant_JR15 - H161_JR15).toFixed(3);

	var G30_JR15_142 = parseFloat(G30_JR15_141 - G161_JR15).toFixed(3);
	var H162_JR15 = parseFloat(G30_JR15_142 * taeg_JR15).toFixed(3);
	var G162_JR15 = parseFloat(pmt_constant_JR15 - H162_JR15).toFixed(3);
	// =SUM('Amortiss 15 ans'!H151:H162)
	var B63 = (parseFloat(H151_JR15)+parseFloat(H152_JR15)+parseFloat(H153_JR15)+parseFloat(H154_JR15)+parseFloat(H155_JR15)+parseFloat(H156_JR15)+parseFloat(H157_JR15)+parseFloat(H158_JR15)+parseFloat(H159_JR15)+parseFloat(H160_JR15)+parseFloat(H161_JR15)+parseFloat(H162_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B63-SUM(PROJECTIE!G$40:G$45)
	var C63 = (parseFloat(G15phide.val()) - parseFloat(B63) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C63+C$30)
	var D63 = (Math.trunc(parseFloat(C63) + C30)).toFixed(2);

	var E63;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D63-C$30)/10000+1400)*(D63-C$30)/10000
	var H63 = ((980.14*(D63- C30)/10000 + 1400) * (D63 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D63-14254)/10000)+2397)*((D63-14254)/10000)+965.58
	var I63 = ((216.16*((D63 - 14254)/10000) + 2397) * ((D63 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D63-8780.9
	var J63 = (0.42*D63-8780.9).toFixed(2);

	//=TRUNC(IF(D63<14255,H63,IF(D55>55960,J52,I52)))
	if (D63<14255) {
		E63 = Math.trunc(H63).toFixed(2); //Valur of E63
	}
	else if (D63>55960) {
		E63 = Math.trunc(J63).toFixed(2); //Valur of E63
	}
	else{
		E63 = Math.trunc(I63).toFixed(2); //Valur of E63
	}
	//=PROJECTIE!D$51-E63-SUM(PROJECTIE!G$40:G$43)
	var F63 = (parseFloat(D51phide.val())-parseFloat(E63)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_143 = parseFloat(G30_JR15_142 - G162_JR15).toFixed(3);
	var H163_JR15 = parseFloat(G30_JR15_143 * taeg_JR15).toFixed(3);
	var G163_JR15 = parseFloat(pmt_constant_JR15 - H163_JR15).toFixed(3);

	var G30_JR15_144 = parseFloat(G30_JR15_143 - G163_JR15).toFixed(3);
	var H164_JR15 = parseFloat(G30_JR15_144 * taeg_JR15).toFixed(3);
	var G164_JR15 = parseFloat(pmt_constant_JR15 - H164_JR15).toFixed(3);

	var G30_JR15_145 = parseFloat(G30_JR15_144 - G164_JR15).toFixed(3);
	var H165_JR15 = parseFloat(G30_JR15_145 * taeg_JR15).toFixed(3);
	var G165_JR15 = parseFloat(pmt_constant_JR15 - H165_JR15).toFixed(3);

	var G30_JR15_146 = parseFloat(G30_JR15_145 - G165_JR15).toFixed(3);
	var H166_JR15 = parseFloat(G30_JR15_146 * taeg_JR15).toFixed(3);
	var G166_JR15 = parseFloat(pmt_constant_JR15 - H166_JR15).toFixed(3);

	var G30_JR15_147 = parseFloat(G30_JR15_146 - G166_JR15).toFixed(3);
	var H167_JR15 = parseFloat(G30_JR15_147 * taeg_JR15).toFixed(3);
	var G167_JR15 = parseFloat(pmt_constant_JR15 - H167_JR15).toFixed(3);

	var G30_JR15_148 = parseFloat(G30_JR15_147 - G167_JR15).toFixed(3);
	var H168_JR15 = parseFloat(G30_JR15_148 * taeg_JR15).toFixed(3);
	var G168_JR15 = parseFloat(pmt_constant_JR15 - H168_JR15).toFixed(3);

	var G30_JR15_149 = parseFloat(G30_JR15_148 - G168_JR15).toFixed(3);
	var H169_JR15 = parseFloat(G30_JR15_149 * taeg_JR15).toFixed(3);
	var G169_JR15 = parseFloat(pmt_constant_JR15 - H169_JR15).toFixed(3);

	var G30_JR15_150 = parseFloat(G30_JR15_149 - G169_JR15).toFixed(3);
	var H170_JR15 = parseFloat(G30_JR15_150 * taeg_JR15).toFixed(3);
	var G170_JR15 = parseFloat(pmt_constant_JR15 - H170_JR15).toFixed(3);

	var G30_JR15_151 = parseFloat(G30_JR15_150 - G170_JR15).toFixed(3);
	var H171_JR15 = parseFloat(G30_JR15_151 * taeg_JR15).toFixed(3);
	var G171_JR15 = parseFloat(pmt_constant_JR15 - H171_JR15).toFixed(3);

	var G30_JR15_152 = parseFloat(G30_JR15_151 - G171_JR15).toFixed(3);
	var H172_JR15 = parseFloat(G30_JR15_152 * taeg_JR15).toFixed(3);
	var G172_JR15 = parseFloat(pmt_constant_JR15 - H172_JR15).toFixed(3);

	var G30_JR15_153 = parseFloat(G30_JR15_152 - G172_JR15).toFixed(3);
	var H173_JR15 = parseFloat(G30_JR15_153 * taeg_JR15).toFixed(3);
	var G173_JR15 = parseFloat(pmt_constant_JR15 - H173_JR15).toFixed(3);

	var G30_JR15_154 = parseFloat(G30_JR15_153 - G173_JR15).toFixed(3);
	var H174_JR15 = parseFloat(G30_JR15_154 * taeg_JR15).toFixed(3);
	var G174_JR15 = parseFloat(pmt_constant_JR15 - H174_JR15).toFixed(3);
	//=SUM('Amortiss 15 ans'!H163:H174)
	var B64 = (parseFloat(H163_JR15)+parseFloat(H164_JR15)+parseFloat(H165_JR15)+parseFloat(H166_JR15)+parseFloat(H167_JR15)+parseFloat(H168_JR15)+parseFloat(H169_JR15)+parseFloat(H170_JR15)+parseFloat(H171_JR15)+parseFloat(H172_JR15)+parseFloat(H173_JR15)+parseFloat(H174_JR15)).toFixed(2);
	
	// =PROJECTIE!G$15-B64-SUM(PROJECTIE!G$40:G$45)
	var C64 = (parseFloat(G15phide.val()) - parseFloat(B64) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C64+C$30)
	var D64 = (Math.trunc(parseFloat(C64) + C30)).toFixed(2);

	var E64;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D64-C$30)/10000+1400)*(D64-C$30)/10000
	var H64 = ((980.14*(D64- C30)/10000 + 1400) * (D64 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D64-14254)/10000)+2397)*((D64-14254)/10000)+965.58
	var I64 = ((216.16*((D64 - 14254)/10000) + 2397) * ((D64 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D64-8780.9
	var J64 = (0.42*D64-8780.9).toFixed(2);

	//=TRUNC(IF(D64<14255,H64,IF(D55>55960,J64,I64)))
	if (D64<14255) {
		E64 = Math.trunc(H64).toFixed(2); //Valur of E64
	}
	else if (D64>55960) {
		E64 = Math.trunc(J64).toFixed(2); //Valur of E64
	}
	else{
		E64 = Math.trunc(I64).toFixed(2); //Valur of E64
	}
	//=PROJECTIE!D$51-E64-SUM(PROJECTIE!G$40:G$43)
	var F64 = (parseFloat(D51phide.val())-parseFloat(E64)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);
	


	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_155 = parseFloat(G30_JR15_154 - G174_JR15).toFixed(3);
	var H175_JR15 = parseFloat(G30_JR15_155 * taeg_JR15).toFixed(3);
	var G175_JR15 = parseFloat(pmt_constant_JR15 - H175_JR15).toFixed(3);

	var G30_JR15_156 = parseFloat(G30_JR15_155 - G175_JR15).toFixed(3);
	var H176_JR15 = parseFloat(G30_JR15_156 * taeg_JR15).toFixed(3);
	var G176_JR15 = parseFloat(pmt_constant_JR15 - H176_JR15).toFixed(3);

	var G30_JR15_157 = parseFloat(G30_JR15_156 - G176_JR15).toFixed(3);
	var H177_JR15 = parseFloat(G30_JR15_157 * taeg_JR15).toFixed(3);
	var G177_JR15 = parseFloat(pmt_constant_JR15 - H177_JR15).toFixed(3);

	var G30_JR15_158 = parseFloat(G30_JR15_157 - G177_JR15).toFixed(3);
	var H178_JR15 = parseFloat(G30_JR15_158 * taeg_JR15).toFixed(3);
	var G178_JR15 = parseFloat(pmt_constant_JR15 - H178_JR15).toFixed(3);

	var G30_JR15_159 = parseFloat(G30_JR15_158 - G178_JR15).toFixed(3);
	var H179_JR15 = parseFloat(G30_JR15_159 * taeg_JR15).toFixed(3);
	var G179_JR15 = parseFloat(pmt_constant_JR15 - H179_JR15).toFixed(3);

	var G30_JR15_160 = parseFloat(G30_JR15_159 - G179_JR15).toFixed(3);
	var H180_JR15 = parseFloat(G30_JR15_160 * taeg_JR15).toFixed(3);
	var G180_JR15 = parseFloat(pmt_constant_JR15 - H180_JR15).toFixed(3);

	var G30_JR15_161 = parseFloat(G30_JR15_160 - G180_JR15).toFixed(3);
	var H181_JR15 = parseFloat(G30_JR15_161 * taeg_JR15).toFixed(3);
	var G181_JR15 = parseFloat(pmt_constant_JR15 - H181_JR15).toFixed(3);

	var G30_JR15_162 = parseFloat(G30_JR15_161 - G181_JR15).toFixed(3);
	var H182_JR15 = parseFloat(G30_JR15_162 * taeg_JR15).toFixed(3);
	var G182_JR15 = parseFloat(pmt_constant_JR15 - H182_JR15).toFixed(3);

	var G30_JR15_163 = parseFloat(G30_JR15_162 - G182_JR15).toFixed(3);
	var H183_JR15 = parseFloat(G30_JR15_163 * taeg_JR15).toFixed(3);
	var G183_JR15 = parseFloat(pmt_constant_JR15 - H183_JR15).toFixed(3);

	var G30_JR15_164 = parseFloat(G30_JR15_163 - G183_JR15).toFixed(3);
	var H184_JR15 = parseFloat(G30_JR15_164 * taeg_JR15).toFixed(3);
	var G184_JR15 = parseFloat(pmt_constant_JR15 - H184_JR15).toFixed(3);

	var G30_JR15_165 = parseFloat(G30_JR15_164 - G184_JR15).toFixed(3);
	var H185_JR15 = parseFloat(G30_JR15_165 * taeg_JR15).toFixed(3);
	var G185_JR15 = parseFloat(pmt_constant_JR15 - H185_JR15).toFixed(3);

	var G30_JR15_166 = parseFloat(G30_JR15_165 - G185_JR15).toFixed(3);
	var H186_JR15 = parseFloat(G30_JR15_166 * taeg_JR15).toFixed(3);
	var G186_JR15 = parseFloat(pmt_constant_JR15 - H186_JR15).toFixed(3);
	//=SUM('Amortiss 15 ans'!H175:H186)
	var B65 = (parseFloat(H175_JR15)+parseFloat(H176_JR15)+parseFloat(H177_JR15)+parseFloat(H178_JR15)+parseFloat(H179_JR15)+parseFloat(H180_JR15)+parseFloat(H181_JR15)+parseFloat(H182_JR15)+parseFloat(H183_JR15)+parseFloat(H184_JR15)+parseFloat(H185_JR15)+parseFloat(H186_JR15)).toFixed(2);

	// =PROJECTIE!G$15-B65-SUM(PROJECTIE!G$40:G$45)
	var C65 = (parseFloat(G15phide.val()) - parseFloat(B65) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C65+C$30)
	var D65 = (Math.trunc(parseFloat(C65) + C30)).toFixed(2);

	var E65;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D65-C$30)/10000+1400)*(D65-C$30)/10000
	var H65 = ((980.14*(D65- C30)/10000 + 1400) * (D65 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D65-14254)/10000)+2397)*((D65-14254)/10000)+965.58
	var I65 = ((216.16*((D65 - 14254)/10000) + 2397) * ((D65 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D65-8780.9
	var J65 = (0.42*D65-8780.9).toFixed(2);

	//=TRUNC(IF(D65<14255,H65,IF(D55>55960,J52,I52)))
	if (D65<14255) {
		E65 = Math.trunc(H65).toFixed(2); //Valur of E65
	}
	else if (D65>55960) {
		E65 = Math.trunc(J65).toFixed(2); //Valur of E65
	}
	else{
		E65 = Math.trunc(I65).toFixed(2); //Valur of E65
	}
	//=PROJECTIE!D$51-E65-SUM(PROJECTIE!G$40:G$43)
	var F65 = (parseFloat(D51phide.val())-parseFloat(E65)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR15_167 = parseFloat(G30_JR15_166 - G186_JR15).toFixed(3);
	var H187_JR15 = parseFloat(G30_JR15_167 * taeg_JR15).toFixed(3);
	var G187_JR15 = parseFloat(pmt_constant_JR15 - H187_JR15).toFixed(3);

	var G30_JR15_168 = parseFloat(G30_JR15_167 - G187_JR15).toFixed(3);
	var H188_JR15 = parseFloat(G30_JR15_168 * taeg_JR15).toFixed(3);
	var G188_JR15 = parseFloat(pmt_constant_JR15 - H188_JR15).toFixed(3);

	var G30_JR15_169 = parseFloat(G30_JR15_168 - G188_JR15).toFixed(3);
	var H189_JR15 = parseFloat(G30_JR15_169 * taeg_JR15).toFixed(3);
	var G189_JR15 = parseFloat(pmt_constant_JR15 - H189_JR15).toFixed(3);

	var G30_JR15_170 = parseFloat(G30_JR15_169 - G189_JR15).toFixed(3);
	var H190_JR15 = parseFloat(G30_JR15_170 * taeg_JR15).toFixed(3);
	var G190_JR15 = parseFloat(pmt_constant_JR15 - H190_JR15).toFixed(3);

	var G30_JR15_171 = parseFloat(G30_JR15_170 - G190_JR15).toFixed(3);
	var H191_JR15 = parseFloat(G30_JR15_171 * taeg_JR15).toFixed(3);
	var G191_JR15 = parseFloat(pmt_constant_JR15 - H191_JR15).toFixed(3);

	var G30_JR15_172 = parseFloat(G30_JR15_171 - G191_JR15).toFixed(3);
	var H192_JR15 = parseFloat(G30_JR15_172 * taeg_JR15).toFixed(3);
	var G192_JR15 = parseFloat(pmt_constant_JR15 - H192_JR15).toFixed(3);

	var G30_JR15_173 = parseFloat(G30_JR15_172 - G192_JR15).toFixed(3);
	var H193_JR15 = parseFloat(G30_JR15_173 * taeg_JR15).toFixed(3);
	var G193_JR15 = parseFloat(pmt_constant_JR15 - H193_JR15).toFixed(3);

	var G30_JR15_174 = parseFloat(G30_JR15_173 - G193_JR15).toFixed(3);
	var H194_JR15 = parseFloat(G30_JR15_174 * taeg_JR15).toFixed(3);
	var G194_JR15 = parseFloat(pmt_constant_JR15 - H194_JR15).toFixed(3);

	var G30_JR15_175 = parseFloat(G30_JR15_174 - G194_JR15).toFixed(3);
	var H195_JR15 = parseFloat(G30_JR15_175 * taeg_JR15).toFixed(3);
	var G195_JR15 = parseFloat(pmt_constant_JR15 - H195_JR15).toFixed(3);

	var G30_JR15_176 = parseFloat(G30_JR15_175 - G195_JR15).toFixed(3);
	var H196_JR15 = parseFloat(G30_JR15_176 * taeg_JR15).toFixed(3);
	var G196_JR15 = parseFloat(pmt_constant_JR15 - H196_JR15).toFixed(3);

	var G30_JR15_177 = parseFloat(G30_JR15_176 - G196_JR15).toFixed(3);
	var H197_JR15 = parseFloat(G30_JR15_177 * taeg_JR15).toFixed(3);
	var G197_JR15 = parseFloat(pmt_constant_JR15 - H197_JR15).toFixed(3);

	var G30_JR15_178 = parseFloat(G30_JR15_177 - G197_JR15).toFixed(3);
	var H198_JR15 = parseFloat(G30_JR15_178 * taeg_JR15).toFixed(3);
	var G198_JR15 = parseFloat(pmt_constant_JR15 - H198_JR15).toFixed(3);
	//=SUM('Amortiss 15 ans'!H187:H198)
	var B66 = (parseFloat(H187_JR15)+parseFloat(H188_JR15)+parseFloat(H189_JR15)+parseFloat(H190_JR15)+parseFloat(H191_JR15)+parseFloat(H192_JR15)+parseFloat(H193_JR15)+parseFloat(H194_JR15)+parseFloat(H195_JR15)+parseFloat(H196_JR15)+parseFloat(H197_JR15)+parseFloat(H198_JR15)).toFixed(2);
	
	// =PROJECTIE!G$15-B66-SUM(PROJECTIE!G$40:G$45)
	var C66 = (parseFloat(G15phide.val()) - parseFloat(B66) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C66+C$30)
	var D66 = (Math.trunc(parseFloat(C66) + C30)).toFixed(2);

	var E66;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #5
	// =(980.14*(D66-C$30)/10000+1400)*(D66-C$30)/10000
	var H66 = ((980.14*(D66- C30)/10000 + 1400) * (D66 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #5
	// =(216.16*((D66-14254)/10000)+2397)*((D66-14254)/10000)+965.58
	var I66 = ((216.16*((D66 - 14254)/10000) + 2397) * ((D66 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #5
	//Formula = 0.42*D66-8780.9
	var J66 = (0.42*D66-8780.9).toFixed(2);

	//=TRUNC(IF(D66<14255,H66,IF(D55>55960,J52,I52)))
	if (D66<14255) {
		E66 = Math.trunc(H66).toFixed(2); //Valur of E66
	}
	else if (D65>55960) {
		E66 = Math.trunc(J66).toFixed(2); //Valur of E66
	}
	else{
		E66 = Math.trunc(I66).toFixed(2); //Valur of E66
	}

	//=PROJECTIE!D$51-E66-SUM(PROJECTIE!G$40:G$43)
	var F66 = (parseFloat(D51phide.val())-parseFloat(E66)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);

	// =SUM(B52:B66)
	var B67 = (parseFloat(B52)+parseFloat(B53)+parseFloat(B54)+parseFloat(B55)+parseFloat(B56)+parseFloat(B57)+parseFloat(B58)+parseFloat(B59)+parseFloat(B60)+parseFloat(B61)+parseFloat(B62)+parseFloat(B63)+parseFloat(B64)+parseFloat(B65)+parseFloat(B66)).toFixed(2);

	// =SUM(E52:E66)
	var E67 = (parseFloat(E52)+parseFloat(E53)+parseFloat(E54)+parseFloat(E55)+parseFloat(E56)+parseFloat(E57)+parseFloat(E58)+parseFloat(E59)+parseFloat(E60)+parseFloat(E61)+parseFloat(E62)+parseFloat(E63)+parseFloat(E64)+parseFloat(E65)+parseFloat(E66)).toFixed(2);

	// =SUM(F52:F66)
	var F67 = (parseFloat(F52)+parseFloat(F53)+parseFloat(F54)+parseFloat(F55)+parseFloat(F56)+parseFloat(F57)+parseFloat(F58)+parseFloat(F59)+parseFloat(F60)+parseFloat(F61)+parseFloat(F62)+parseFloat(F63)+parseFloat(F64)+parseFloat(F65)+parseFloat(F66)).toFixed(2);





	// ============================================================================================================================
	// ============================================================================================================================
	// ============================================================================================================================
	// For 20 JAAR (year)
	// ============================================================================================================================
	// ============================================================================================================================
	// ============================================================================================================================
	// =Berekeningsblad!F92/240-G62
	var G30_JR20  = $('#G30hide').val();
	// var taeg_JR20 = 0.021/12;
	var taeg_JR20 = (F62phide.val()/100)/12;
	var rate_JR20 = 20*12;
	var multi_JR20 = taeg_JR20 / (1 - (1 / Math.pow((1+taeg_JR20), rate_JR20)));
	var pmt_constant_JR20 = G30_JR20 * multi_JR20;
	// console.log("pmt_constant "+ pmt_constant_JR20);

	var H19_JR20 = parseFloat(G30_JR20 * taeg_JR20).toFixed(3);
	var G19_JR20 = parseFloat(pmt_constant_JR20 - H19_JR20).toFixed(3);

	var G30_JR20_0 = parseFloat(G30_JR20 - G19_JR20).toFixed(3);
	var H20_JR20 = parseFloat(G30_JR20_0 * taeg_JR20).toFixed(3);
	var G20_JR20 = parseFloat(pmt_constant_JR20 - H20_JR20).toFixed(3);

	var G30_JR20_1 = parseFloat(G30_JR20_0 - G20_JR20).toFixed(3);
	var H21_JR20 = parseFloat(G30_JR20_1 * taeg_JR20).toFixed(3);
	var G21_JR20 = parseFloat(pmt_constant_JR20 - H21_JR20).toFixed(3);

	var G30_JR20_2 = parseFloat(G30_JR20_1 - G21_JR20).toFixed(3);
	var H22_JR20 = parseFloat(G30_JR20_2 * taeg_JR20).toFixed(3);
	var G22_JR20 = parseFloat(pmt_constant_JR20 - H22_JR20).toFixed(3);

	var G30_JR20_3 = parseFloat(G30_JR20_2 - G22_JR20).toFixed(3);
	var H23_JR20 = parseFloat(G30_JR20_3 * taeg_JR20).toFixed(3);
	var G23_JR20 = parseFloat(pmt_constant_JR20 - H23_JR20).toFixed(3);

	var G30_JR20_4 = parseFloat(G30_JR20_3 - G23_JR20).toFixed(3);
	var H24_JR20 = parseFloat(G30_JR20_4 * taeg_JR20).toFixed(3);
	var G24_JR20 = parseFloat(pmt_constant_JR20 - H24_JR20).toFixed(3);

	var G30_JR20_5 = parseFloat(G30_JR20_4 - G24_JR20).toFixed(3);
	var H25_JR20 = parseFloat(G30_JR20_5 * taeg_JR20).toFixed(3);
	var G25_JR20 = parseFloat(pmt_constant_JR20 - H25_JR20).toFixed(3);

	var G30_JR20_6 = parseFloat(G30_JR20_5 - G25_JR20).toFixed(3);
	var H26_JR20 = parseFloat(G30_JR20_6 * taeg_JR20).toFixed(3);
	var G26_JR20 = parseFloat(pmt_constant_JR20 - H26_JR20).toFixed(3);

	var G30_JR20_7 = parseFloat(G30_JR20_6 - G26_JR20).toFixed(3);
	var H27_JR20 = parseFloat(G30_JR20_7 * taeg_JR20).toFixed(3);
	var G27_JR20 = parseFloat(pmt_constant_JR20 - H27_JR20).toFixed(3);

	var G30_JR20_8 = parseFloat(G30_JR20_7 - G27_JR20).toFixed(3);
	var H28_JR20 = parseFloat(G30_JR20_8 * taeg_JR20).toFixed(3);
	var G28_JR20 = parseFloat(pmt_constant_JR20 - H28_JR20).toFixed(3);

	var G30_JR20_9 = parseFloat(G30_JR20_8 - G28_JR20).toFixed(3);
	var H29_JR20 = parseFloat(G30_JR20_9 * taeg_JR20).toFixed(3);
	var G29_JR20 = parseFloat(pmt_constant_JR20 - H29_JR20).toFixed(3);

	var G30_JR20_10 = parseFloat(G30_JR20_9 - G29_JR20).toFixed(3);
	var H30_JR20 = parseFloat(G30_JR20_10 * taeg_JR20).toFixed(3);
	var G30_JR20 = parseFloat(pmt_constant_JR20 - H30_JR20).toFixed(3);

	// = SUM('Amortiss 20 ans'!H19:H30)
	var B72 = (parseFloat(H19_JR20)+parseFloat(H20_JR20)+parseFloat(H21_JR20)+parseFloat(H22_JR20)+parseFloat(H23_JR20)+parseFloat(H24_JR20)+parseFloat(H25_JR20)+parseFloat(H26_JR20)+parseFloat(H27_JR20)+parseFloat(H28_JR20)+parseFloat(H29_JR20)+parseFloat(H30_JR20)).toFixed(2);

	// =PROJECTIE!G$15-B72-SUM(PROJECTIE!G$40:G$45)
	var C72 = (parseFloat(G15phide.val()) - parseFloat(B72) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C72+C$30)
	var D72 = (Math.trunc(parseFloat(C72) + C30)).toFixed(2);

	var E72;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H72 = ((980.14*(D72- C30)/10000 + 1400) * (D72 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I72 = ((216.16*((D72 - 14254)/10000) + 2397) * ((D72 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J72 = (0.42*D72-8780.9).toFixed(2);

	//=TRUNC(IF(D72<14255,H72,IF(D72>55960,J72,I72)))
	if (D72<14255) {
		E72 = Math.trunc(H72).toFixed(2); //Valur of E72
	}
	else if (D72>55960) {
		E72 = Math.trunc(J72).toFixed(2); //Valur of E72
	}
	else{
		E72 = Math.trunc(I72).toFixed(2); //Valur of E72
	}
	//=PROJECTIE!D$51-E72-SUM(PROJECTIE!G$40:G$43)
	var F72 = (parseFloat(D51phide.val())-parseFloat(E72)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	// =====>>>>>>>>>>>>>>
	var G30_JR20_11 = parseFloat(G30_JR20_10 - G30_JR20).toFixed(3);
	var H31_JR20 = parseFloat(G30_JR20_11 * taeg_JR20).toFixed(3);
	var G31_JR20 = parseFloat(pmt_constant_JR20 - H31_JR20).toFixed(3);

	var G30_JR20_12 = parseFloat(G30_JR20_11 - G31_JR20).toFixed(3);
	var H32_JR20 = parseFloat(G30_JR20_12 * taeg_JR20).toFixed(3);
	var G32_JR20 = parseFloat(pmt_constant_JR20 - H32_JR20).toFixed(3);

	var G30_JR20_13 = parseFloat(G30_JR20_12 - G32_JR20).toFixed(3);
	var H33_JR20 = parseFloat(G30_JR20_13 * taeg_JR20).toFixed(3);
	var G33_JR20 = parseFloat(pmt_constant_JR20 - H33_JR20).toFixed(3);

	var G30_JR20_14 = parseFloat(G30_JR20_13 - G33_JR20).toFixed(3);
	var H34_JR20 = parseFloat(G30_JR20_14 * taeg_JR20).toFixed(3);
	var G34_JR20 = parseFloat(pmt_constant_JR20 - H34_JR20).toFixed(3);

	var G30_JR20_15 = parseFloat(G30_JR20_14 - G34_JR20).toFixed(3);
	var H35_JR20 = parseFloat(G30_JR20_15 * taeg_JR20).toFixed(3);
	var G35_JR20 = parseFloat(pmt_constant_JR20 - H35_JR20).toFixed(3);

	var G30_JR20_16 = parseFloat(G30_JR20_15 - G35_JR20).toFixed(3);
	var H36_JR20 = parseFloat(G30_JR20_16 * taeg_JR20).toFixed(3);
	var G36_JR20 = parseFloat(pmt_constant_JR20 - H36_JR20).toFixed(3);

	var G30_JR20_17 = parseFloat(G30_JR20_16 - G36_JR20).toFixed(3);
	var H37_JR20 = parseFloat(G30_JR20_17 * taeg_JR20).toFixed(3);
	var G37_JR20 = parseFloat(pmt_constant_JR20 - H37_JR20).toFixed(3);

	var G30_JR20_18 = parseFloat(G30_JR20_17 - G37_JR20).toFixed(3);
	var H38_JR20 = parseFloat(G30_JR20_18 * taeg_JR20).toFixed(3);
	var G38_JR20 = parseFloat(pmt_constant_JR20 - H38_JR20).toFixed(3);

	var G30_JR20_19 = parseFloat(G30_JR20_18 - G38_JR20).toFixed(3);
	var H39_JR20 = parseFloat(G30_JR20_19 * taeg_JR20).toFixed(3);
	var G39_JR20 = parseFloat(pmt_constant_JR20 - H39_JR20).toFixed(3);

	var G30_JR20_20 = parseFloat(G30_JR20_19 - G39_JR20).toFixed(3);
	var H40_JR20 = parseFloat(G30_JR20_20 * taeg_JR20).toFixed(3);
	var G40_JR20 = parseFloat(pmt_constant_JR20 - H40_JR20).toFixed(3);

	var G30_JR20_21 = parseFloat(G30_JR20_20 - G40_JR20).toFixed(3);
	var H41_JR20 = parseFloat(G30_JR20_21 * taeg_JR20).toFixed(3);
	var G41_JR20 = parseFloat(pmt_constant_JR20 - H41_JR20).toFixed(3);

	var G30_JR20_22 = parseFloat(G30_JR20_21 - G41_JR20).toFixed(3);
	var H42_JR20 = parseFloat(G30_JR20_22 * taeg_JR20).toFixed(3);
	var G42_JR20 = parseFloat(pmt_constant_JR20 - H42_JR20).toFixed(3);

	//=SUM('Amortiss 20 ans'!H31:H42)
	var B73 = (parseFloat(H31_JR20)+parseFloat(H32_JR20)+parseFloat(H33_JR20)+parseFloat(H34_JR20)+parseFloat(H35_JR20)+parseFloat(H36_JR20)+parseFloat(H37_JR20)+parseFloat(H38_JR20)+parseFloat(H39_JR20)+parseFloat(H40_JR20)+parseFloat(H41_JR20)+parseFloat(H42_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B73-SUM(PROJECTIE!G$40:G$45)
	var C73 = (parseFloat(G15phide.val()) - parseFloat(B73) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C73+C$30)
	var D73 = (Math.trunc(parseFloat(C73) + C30)).toFixed(2);

	var E73;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H73 = ((980.14*(D73- C30)/10000 + 1400) * (D73 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I73 = ((216.16*((D73 - 14254)/10000) + 2397) * ((D73 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J73 = (0.42*D73-8780.9).toFixed(2);

	//=TRUNC(IF(D73<14255,H72,IF(D72>55960,J72,I72)))
	if (D73<14255) {
		E73 = Math.trunc(H73).toFixed(2); //Valur of E73
	}
	else if (D73>55960) {
		E73 = Math.trunc(J73).toFixed(2); //Valur of E73
	}
	else{
		E73 = Math.trunc(I73).toFixed(2); //Valur of E73
	}

	//=PROJECTIE!D$51-E73-SUM(PROJECTIE!G$40:G$43)
	var F73 = (parseFloat(D51phide.val())-parseFloat(E73)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	// =====>>>>>>>>>>>>>>
	var G30_JR20_23 = parseFloat(G30_JR20_22 - G42_JR20).toFixed(3);
	var H43_JR20 = parseFloat(G30_JR20_23 * taeg_JR20).toFixed(3);
	var G43_JR20 = parseFloat(pmt_constant_JR20 - H43_JR20).toFixed(3);

	var G30_JR20_24 = parseFloat(G30_JR20_23 - G43_JR20).toFixed(3);
	var H44_JR20 = parseFloat(G30_JR20_24 * taeg_JR20).toFixed(3);
	var G44_JR20 = parseFloat(pmt_constant_JR20 - H44_JR20).toFixed(3);

	var G30_JR20_25 = parseFloat(G30_JR20_24 - G44_JR20).toFixed(3);
	var H45_JR20 = parseFloat(G30_JR20_25 * taeg_JR20).toFixed(3);
	var G45_JR20 = parseFloat(pmt_constant_JR20 - H45_JR20).toFixed(3);

	var G30_JR20_26 = parseFloat(G30_JR20_25 - G45_JR20).toFixed(3);
	var H46_JR20 = parseFloat(G30_JR20_26 * taeg_JR20).toFixed(3);
	var G46_JR20 = parseFloat(pmt_constant_JR20 - H46_JR20).toFixed(3);

	var G30_JR20_27 = parseFloat(G30_JR20_26 - G46_JR20).toFixed(3);
	var H47_JR20 = parseFloat(G30_JR20_27 * taeg_JR20).toFixed(3);
	var G47_JR20 = parseFloat(pmt_constant_JR20 - H47_JR20).toFixed(3);

	var G30_JR20_28 = parseFloat(G30_JR20_27 - G47_JR20).toFixed(3);
	var H48_JR20 = parseFloat(G30_JR20_28 * taeg_JR20).toFixed(3);
	var G48_JR20 = parseFloat(pmt_constant_JR20 - H48_JR20).toFixed(3);

	var G30_JR20_29 = parseFloat(G30_JR20_28 - G48_JR20).toFixed(3);
	var H49_JR20 = parseFloat(G30_JR20_29 * taeg_JR20).toFixed(3);
	var G49_JR20 = parseFloat(pmt_constant_JR20 - H49_JR20).toFixed(3);

	var G30_JR20_30 = parseFloat(G30_JR20_29 - G49_JR20).toFixed(3);
	var H50_JR20 = parseFloat(G30_JR20_30 * taeg_JR20).toFixed(3);
	var G50_JR20 = parseFloat(pmt_constant_JR20 - H50_JR20).toFixed(3);

	var G30_JR20_31 = parseFloat(G30_JR20_30 - G50_JR20).toFixed(3);
	var H51_JR20 = parseFloat(G30_JR20_31 * taeg_JR20).toFixed(3);
	var G51_JR20 = parseFloat(pmt_constant_JR20 - H51_JR20).toFixed(3);

	var G30_JR20_32 = parseFloat(G30_JR20_31 - G51_JR20).toFixed(3);
	var H52_JR20 = parseFloat(G30_JR20_32 * taeg_JR20).toFixed(3);
	var G52_JR20 = parseFloat(pmt_constant_JR20 - H52_JR20).toFixed(3);

	var G30_JR20_33 = parseFloat(G30_JR20_32 - G52_JR20).toFixed(3);
	var H53_JR20 = parseFloat(G30_JR20_33 * taeg_JR20).toFixed(3);
	var G53_JR20 = parseFloat(pmt_constant_JR20 - H53_JR20).toFixed(3);

	var G30_JR20_34 = parseFloat(G30_JR20_33 - G53_JR20).toFixed(3);
	var H54_JR20 = parseFloat(G30_JR20_34 * taeg_JR20).toFixed(3);
	var G54_JR20 = parseFloat(pmt_constant_JR20 - H54_JR20).toFixed(3);

	//=SUM('Amortiss 20 ans'!H43:H54)
	var B74 = (parseFloat(H43_JR20)+parseFloat(H44_JR20)+parseFloat(H45_JR20)+parseFloat(H46_JR20)+parseFloat(H47_JR20)+parseFloat(H48_JR20)+parseFloat(H49_JR20)+parseFloat(H50_JR20)+parseFloat(H51_JR20)+parseFloat(H52_JR20)+parseFloat(H53_JR20)+parseFloat(H54_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B74-SUM(PROJECTIE!G$40:G$45)
	var C74 = (parseFloat(G15phide.val()) - parseFloat(B74) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C74+C$30)
	var D74 = (Math.trunc(parseFloat(C74) + C30)).toFixed(2);

	var E74;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H74 = ((980.14*(D74 - C30)/10000 + 1400) * (D74 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I74 = ((216.16*((D74 - 14254)/10000) + 2397) * ((D74 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J74 = (0.42*D74-8780.9).toFixed(2);

	//=TRUNC(IF(D74<14255,H74,IF(D74>55960,J72,I72)))
	if (D74<14255) {
		E74 = Math.trunc(H74).toFixed(2); //Valur of E74
	}
	else if (D74>55960) {
		E74 = Math.trunc(J74).toFixed(2); //Valur of E74
	}
	else{
		E74 = Math.trunc(I74).toFixed(2); //Valur of E74
	}
	//=PROJECTIE!D$51-E74-SUM(PROJECTIE!G$40:G$43)
	var F74 = (parseFloat(D51phide.val())-parseFloat(E74)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



		//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_35 = parseFloat(G30_JR20_34 - G54_JR20).toFixed(3);
	var H55_JR20 = parseFloat(G30_JR20_35 * taeg_JR20).toFixed(3);
	var G55_JR20 = parseFloat(pmt_constant_JR20 - H55_JR20).toFixed(3);

	var G30_JR20_36 = parseFloat(G30_JR20_35 - G55_JR20).toFixed(3);
	var H56_JR20 = parseFloat(G30_JR20_36 * taeg_JR20).toFixed(3);
	var G56_JR20 = parseFloat(pmt_constant_JR20 - H56_JR20).toFixed(3);

	var G30_JR20_37 = parseFloat(G30_JR20_36 - G56_JR20).toFixed(3);
	var H57_JR20 = parseFloat(G30_JR20_37 * taeg_JR20).toFixed(3);
	var G57_JR20 = parseFloat(pmt_constant_JR20 - H57_JR20).toFixed(3);

	var G30_JR20_38 = parseFloat(G30_JR20_37 - G57_JR20).toFixed(3);
	var H58_JR20 = parseFloat(G30_JR20_38 * taeg_JR20).toFixed(3);
	var G58_JR20 = parseFloat(pmt_constant_JR20 - H58_JR20).toFixed(3);

	var G30_JR20_39 = parseFloat(G30_JR20_38 - G58_JR20).toFixed(3);
	var H59_JR20 = parseFloat(G30_JR20_39 * taeg_JR20).toFixed(3);
	var G59_JR20 = parseFloat(pmt_constant_JR20 - H59_JR20).toFixed(3);

	var G30_JR20_40 = parseFloat(G30_JR20_39 - G59_JR20).toFixed(3);
	var H60_JR20 = parseFloat(G30_JR20_40 * taeg_JR20).toFixed(3);
	var G60_JR20 = parseFloat(pmt_constant_JR20 - H60_JR20).toFixed(3);

	var G30_JR20_41 = parseFloat(G30_JR20_40 - G60_JR20).toFixed(3);
	var H61_JR20 = parseFloat(G30_JR20_41 * taeg_JR20).toFixed(3);
	var G61_JR20 = parseFloat(pmt_constant_JR20 - H61_JR20).toFixed(3);

	var G30_JR20_42 = parseFloat(G30_JR20_41 - G61_JR20).toFixed(3);
	var H62_JR20 = parseFloat(G30_JR20_42 * taeg_JR20).toFixed(3);
	var G62_JR20 = parseFloat(pmt_constant_JR20 - H62_JR20).toFixed(3);

	var G30_JR20_43 = parseFloat(G30_JR20_42 - G62_JR20).toFixed(3);
	var H63_JR20 = parseFloat(G30_JR20_43 * taeg_JR20).toFixed(3);
	var G63_JR20 = parseFloat(pmt_constant_JR20 - H63_JR20).toFixed(3);

	var G30_JR20_44 = parseFloat(G30_JR20_43 - G59_JR20).toFixed(3);
	var H64_JR20 = parseFloat(G30_JR20_44 * taeg_JR20).toFixed(3);
	var G64_JR20 = parseFloat(pmt_constant_JR20 - H64_JR20).toFixed(3);

	var G30_JR20_45 = parseFloat(G30_JR20_44 - G64_JR20).toFixed(3);
	var H65_JR20 = parseFloat(G30_JR20_45 * taeg_JR20).toFixed(3);
	var G65_JR20 = parseFloat(pmt_constant_JR20 - H65_JR20).toFixed(3);

	var G30_JR20_46 = parseFloat(G30_JR20_45 - G65_JR20).toFixed(3);
	var H66_JR20 = parseFloat(G30_JR20_46 * taeg_JR20).toFixed(3);
	var G66_JR20 = parseFloat(pmt_constant_JR20 - H66_JR20).toFixed(3);

	//=SUM('Amortiss 20 ans'!H55:H66)
	var B75 = (parseFloat(H55_JR20)+parseFloat(H56_JR20)+parseFloat(H57_JR20)+parseFloat(H58_JR20)+parseFloat(H59_JR20)+parseFloat(H60_JR20)+parseFloat(H61_JR20)+parseFloat(H62_JR20)+parseFloat(H63_JR20)+parseFloat(H64_JR20)+parseFloat(H65_JR20)+parseFloat(H66_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B75-SUM(PROJECTIE!G$40:G$45)
	var C75 = (parseFloat(G15phide.val()) - parseFloat(B75) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C75+C$30)
	var D75 = (Math.trunc(parseFloat(C75) + C30)).toFixed(2);

	var E75;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H75 = ((980.14*(D75 - C30)/10000 + 1400) * (D75 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I75 = ((216.16*((D75 - 14254)/10000) + 2397) * ((D75 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J75 = (0.42*D75-8780.9).toFixed(2);

	//=TRUNC(IF(D74<14255,H74,IF(D74>55960,J72,I72)))
	if (D75<14255) {
		E75 = Math.trunc(H75).toFixed(2); //Valur of E75
	}
	else if (D75>55960) {
		E75 = Math.trunc(J75).toFixed(2); //Valur of E75
	}
	else{
		E75 = Math.trunc(I75).toFixed(2); //Valur of E75
	}
	//=PROJECTIE!D$51-E75-SUM(PROJECTIE!G$40:G$43)
	var F75 = (parseFloat(D51phide.val())-parseFloat(E75)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_47 = parseFloat(G30_JR20_46 - G66_JR20).toFixed(3);
	var H67_JR20 = parseFloat(G30_JR20_47 * taeg_JR20).toFixed(3);
	var G67_JR20 = parseFloat(pmt_constant_JR20 - H67_JR20).toFixed(3);

	var G30_JR20_48 = parseFloat(G30_JR20_47 - G67_JR20).toFixed(3);
	var H68_JR20 = parseFloat(G30_JR20_48 * taeg_JR20).toFixed(3);
	var G68_JR20 = parseFloat(pmt_constant_JR20 - H68_JR20).toFixed(3);

	var G30_JR20_49 = parseFloat(G30_JR20_48 - G68_JR20).toFixed(3);
	var H69_JR20 = parseFloat(G30_JR20_49 * taeg_JR20).toFixed(3);
	var G69_JR20 = parseFloat(pmt_constant_JR20 - H69_JR20).toFixed(3);

	var G30_JR20_50 = parseFloat(G30_JR20_49 - G69_JR20).toFixed(3);
	var H70_JR20 = parseFloat(G30_JR20_50 * taeg_JR20).toFixed(3);
	var G70_JR20 = parseFloat(pmt_constant_JR20 - H70_JR20).toFixed(3);

	var G30_JR20_51 = parseFloat(G30_JR20_50 - G70_JR20).toFixed(3);
	var H71_JR20 = parseFloat(G30_JR20_51 * taeg_JR20).toFixed(3);
	var G71_JR20 = parseFloat(pmt_constant_JR20 - H71_JR20).toFixed(3);

	var G30_JR20_52 = parseFloat(G30_JR20_51 - G71_JR20).toFixed(3);
	var H72_JR20 = parseFloat(G30_JR20_52 * taeg_JR20).toFixed(3);
	var G72_JR20 = parseFloat(pmt_constant_JR20 - H72_JR20).toFixed(3);

	var G30_JR20_53 = parseFloat(G30_JR20_52 - G72_JR20).toFixed(3);
	var H73_JR20 = parseFloat(G30_JR20_53 * taeg_JR20).toFixed(3);
	var G73_JR20 = parseFloat(pmt_constant_JR20 - H73_JR20).toFixed(3);

	var G30_JR20_54 = parseFloat(G30_JR20_53 - G73_JR20).toFixed(3);
	var H74_JR20 = parseFloat(G30_JR20_54 * taeg_JR20).toFixed(3);
	var G74_JR20 = parseFloat(pmt_constant_JR20 - H74_JR20).toFixed(3);

	var G30_JR20_55 = parseFloat(G30_JR20_54 - G74_JR20).toFixed(3);
	var H75_JR20 = parseFloat(G30_JR20_55 * taeg_JR20).toFixed(3);
	var G75_JR20 = parseFloat(pmt_constant_JR20 - H75_JR20).toFixed(3);

	var G30_JR20_56 = parseFloat(G30_JR20_55 - G75_JR20).toFixed(3);
	var H76_JR20 = parseFloat(G30_JR20_56 * taeg_JR20).toFixed(3);
	var G76_JR20 = parseFloat(pmt_constant_JR20 - H76_JR20).toFixed(3);

	var G30_JR20_57 = parseFloat(G30_JR20_56 - G76_JR20).toFixed(3);
	var H77_JR20 = parseFloat(G30_JR20_57 * taeg_JR20).toFixed(3);
	var G77_JR20 = parseFloat(pmt_constant_JR20 - H77_JR20).toFixed(3);
	
	var G30_JR20_58 = parseFloat(G30_JR20_57 - G77_JR20).toFixed(3);
	var H78_JR20 = parseFloat(G30_JR20_58 * taeg_JR20).toFixed(3);
	var G78_JR20 = parseFloat(pmt_constant_JR20 - H78_JR20).toFixed(3);

	// =SUM('Amortiss 20 ans'!H67:H78)
	var B76 = (parseFloat(H67_JR20)+parseFloat(H68_JR20)+parseFloat(H69_JR20)+parseFloat(H70_JR20)+parseFloat(H71_JR20)+parseFloat(H72_JR20)+parseFloat(H73_JR20)+parseFloat(H74_JR20)+parseFloat(H75_JR20)+parseFloat(H76_JR20)+parseFloat(H77_JR20)+parseFloat(H78_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B76-SUM(PROJECTIE!G$40:G$45)
	var C76 = (parseFloat(G15phide.val()) - parseFloat(B76) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C76+C$30)
	var D76 = (Math.trunc(parseFloat(C76) + C30)).toFixed(2);

	var E76;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H76 = ((980.14*(D76 - C30)/10000 + 1400) * (D76 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I76 = ((216.16*((D76 - 14254)/10000) + 2397) * ((D76 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J76 = (0.42*D76-8780.9).toFixed(2);

	//=TRUNC(IF(D76<14255,H76,IF(D74>55960,J72,I72)))
	if (D76<14255) {
		E76 = Math.trunc(H76).toFixed(2); //Valur of E76
	}
	else if (D76>55960) {
		E76 = Math.trunc(J75).toFixed(2); //Valur of E76
	}
	else{
		E76 = Math.trunc(I75).toFixed(2); //Valur of E76
	}
	//=PROJECTIE!D$51-E76-SUM(PROJECTIE!G$40:G$43)
	var F76 = (parseFloat(D51phide.val())-parseFloat(E76)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_59 = parseFloat(G30_JR20_58 - G78_JR20).toFixed(3);
	var H79_JR20 = parseFloat(G30_JR20_59 * taeg_JR20).toFixed(3);
	var G79_JR20 = parseFloat(pmt_constant_JR20 - H79_JR20).toFixed(3);

	var G30_JR20_60 = parseFloat(G30_JR20_59 - G79_JR20).toFixed(3);
	var H80_JR20 = parseFloat(G30_JR20_60 * taeg_JR20).toFixed(3);
	var G80_JR20 = parseFloat(pmt_constant_JR20 - H80_JR20).toFixed(3);

	var G30_JR20_61 = parseFloat(G30_JR20_60 - G80_JR20).toFixed(3);
	var H81_JR20 = parseFloat(G30_JR20_61 * taeg_JR20).toFixed(3);
	var G81_JR20 = parseFloat(pmt_constant_JR20 - H81_JR20).toFixed(3);

	var G30_JR20_62 = parseFloat(G30_JR20_61 - G81_JR20).toFixed(3);
	var H82_JR20 = parseFloat(G30_JR20_62 * taeg_JR20).toFixed(3);
	var G82_JR20 = parseFloat(pmt_constant_JR20 - H82_JR20).toFixed(3);

	var G30_JR20_63 = parseFloat(G30_JR20_62 - G82_JR20).toFixed(3);
	var H83_JR20 = parseFloat(G30_JR20_63 * taeg_JR20).toFixed(3);
	var G83_JR20 = parseFloat(pmt_constant_JR20 - H83_JR20).toFixed(3);

	var G30_JR20_64 = parseFloat(G30_JR20_63 - G83_JR20).toFixed(3);
	var H84_JR20 = parseFloat(G30_JR20_64 * taeg_JR20).toFixed(3);
	var G84_JR20 = parseFloat(pmt_constant_JR20 - H84_JR20).toFixed(3);

	var G30_JR20_65 = parseFloat(G30_JR20_64 - G84_JR20).toFixed(3);
	var H85_JR20 = parseFloat(G30_JR20_65 * taeg_JR20).toFixed(3);
	var G85_JR20 = parseFloat(pmt_constant_JR20 - H85_JR20).toFixed(3);

	var G30_JR20_66 = parseFloat(G30_JR20_65 - G85_JR20).toFixed(3);
	var H86_JR20 = parseFloat(G30_JR20_66 * taeg_JR20).toFixed(3);
	var G86_JR20 = parseFloat(pmt_constant_JR20 - H86_JR20).toFixed(3);

	var G30_JR20_67 = parseFloat(G30_JR20_66 - G86_JR20).toFixed(3);
	var H87_JR20 = parseFloat(G30_JR20_67 * taeg_JR20).toFixed(3);
	var G87_JR20 = parseFloat(pmt_constant_JR20 - H87_JR20).toFixed(3);

	var G30_JR20_68 = parseFloat(G30_JR20_67 - G87_JR20).toFixed(3);
	var H88_JR20 = parseFloat(G30_JR20_68 * taeg_JR20).toFixed(3);
	var G88_JR20 = parseFloat(pmt_constant_JR20 - H88_JR20).toFixed(3);

	var G30_JR20_69 = parseFloat(G30_JR20_68 - G88_JR20).toFixed(3);
	var H89_JR20 = parseFloat(G30_JR20_69 * taeg_JR20).toFixed(3);
	var G89_JR20 = parseFloat(pmt_constant_JR20 - H89_JR20).toFixed(3);

	var G30_JR20_70 = parseFloat(G30_JR20_69 - G89_JR20).toFixed(3);
	var H90_JR20 = parseFloat(G30_JR20_70 * taeg_JR20).toFixed(3);
	var G90_JR20 = parseFloat(pmt_constant_JR20 - H90_JR20).toFixed(3);

	//=SUM('Amortiss 20 ans'!H79:H90)
	var B77 = (parseFloat(H79_JR20)+parseFloat(H80_JR20)+parseFloat(H81_JR20)+parseFloat(H82_JR20)+parseFloat(H83_JR20)+parseFloat(H84_JR20)+parseFloat(H85_JR20)+parseFloat(H86_JR20)+parseFloat(H87_JR20)+parseFloat(H88_JR20)+parseFloat(H89_JR20)+parseFloat(H90_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B77-SUM(PROJECTIE!G$40:G$45)
	var C77 = (parseFloat(G15phide.val()) - parseFloat(B77) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C77+C$30)
	var D77 = (Math.trunc(parseFloat(C77) + C30)).toFixed(2);

	var E77;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H77 = ((980.14*(D77 - C30)/10000 + 1400) * (D77 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I77 = ((216.16*((D77 - 14254)/10000) + 2397) * ((D77 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J77 = (0.42*D77-8780.9).toFixed(2);

	//=TRUNC(IF(D77<14255,H77,IF(D74>55960,J72,I72)))
	if (D77<14255) {
		E77 = Math.trunc(H77).toFixed(2); //Valur of E77
	}
	else if (D76>55960) {
		E77 = Math.trunc(J77).toFixed(2); //Valur of E77
	}
	else{
		E77 = Math.trunc(I77).toFixed(2); //Valur of E77
	}
	//=PROJECTIE!D$51-E77-SUM(PROJECTIE!G$40:G$43)
	var F77 = (parseFloat(D51phide.val())-parseFloat(E77)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_71 = parseFloat(G30_JR20_70 - G90_JR20).toFixed(3);
	var H91_JR20 = parseFloat(G30_JR20_71 * taeg_JR20).toFixed(3);
	var G91_JR20 = parseFloat(pmt_constant_JR20 - H91_JR20).toFixed(3);

	var G30_JR20_72 = parseFloat(G30_JR20_71 - G91_JR20).toFixed(3);
	var H92_JR20 = parseFloat(G30_JR20_72 * taeg_JR20).toFixed(3);
	var G92_JR20 = parseFloat(pmt_constant_JR20 - H92_JR20).toFixed(3);

	var G30_JR20_73 = parseFloat(G30_JR20_72 - G92_JR20).toFixed(3);
	var H93_JR20 = parseFloat(G30_JR20_73 * taeg_JR20).toFixed(3);
	var G93_JR20 = parseFloat(pmt_constant_JR20 - H93_JR20).toFixed(3);

	var G30_JR20_74 = parseFloat(G30_JR20_73 - G93_JR20).toFixed(3);
	var H94_JR20 = parseFloat(G30_JR20_74 * taeg_JR20).toFixed(3);
	var G94_JR20 = parseFloat(pmt_constant_JR20 - H94_JR20).toFixed(3);

	var G30_JR20_75 = parseFloat(G30_JR20_74 - G94_JR20).toFixed(3);
	var H95_JR20 = parseFloat(G30_JR20_75 * taeg_JR20).toFixed(3);
	var G95_JR20 = parseFloat(pmt_constant_JR20 - H95_JR20).toFixed(3);

	var G30_JR20_76 = parseFloat(G30_JR20_75 - G95_JR20).toFixed(3);
	var H96_JR20 = parseFloat(G30_JR20_76 * taeg_JR20).toFixed(3);
	var G96_JR20 = parseFloat(pmt_constant_JR20 - H96_JR20).toFixed(3);

	var G30_JR20_77 = parseFloat(G30_JR20_76 - G96_JR20).toFixed(3);
	var H97_JR20 = parseFloat(G30_JR20_77 * taeg_JR20).toFixed(3);
	var G97_JR20 = parseFloat(pmt_constant_JR20 - H97_JR20).toFixed(3);

	var G30_JR20_78 = parseFloat(G30_JR20_77 - G97_JR20).toFixed(3);
	var H98_JR20 = parseFloat(G30_JR20_78 * taeg_JR20).toFixed(3);
	var G98_JR20 = parseFloat(pmt_constant_JR20 - H98_JR20).toFixed(3);

	var G30_JR20_79 = parseFloat(G30_JR20_78 - G98_JR20).toFixed(3);
	var H99_JR20 = parseFloat(G30_JR20_79 * taeg_JR20).toFixed(3);
	var G99_JR20 = parseFloat(pmt_constant_JR20 - H99_JR20).toFixed(3);

	var G30_JR20_80 = parseFloat(G30_JR20_79 - G99_JR20).toFixed(3);
	var H100_JR20 = parseFloat(G30_JR20_80 * taeg_JR20).toFixed(3);
	var G100_JR20 = parseFloat(pmt_constant_JR20 - H100_JR20).toFixed(3);

	var G30_JR20_81 = parseFloat(G30_JR20_80 - G100_JR20).toFixed(3);
	var H101_JR20 = parseFloat(G30_JR20_81 * taeg_JR20).toFixed(3);
	var G101_JR20 = parseFloat(pmt_constant_JR20 - H101_JR20).toFixed(3);

	var G30_JR20_82 = parseFloat(G30_JR20_81 - G101_JR20).toFixed(3);
	var H102_JR20 = parseFloat(G30_JR20_82 * taeg_JR20).toFixed(3);
	var G102_JR20 = parseFloat(pmt_constant_JR20 - H102_JR20).toFixed(3);

	// =SUM('Amortiss 20 ans'!H91:H102)
	var B78 = (parseFloat(H91_JR20)+parseFloat(H92_JR20)+parseFloat(H93_JR20)+parseFloat(H94_JR20)+parseFloat(H95_JR20)+parseFloat(H96_JR20)+parseFloat(H97_JR20)+parseFloat(H98_JR20)+parseFloat(H99_JR20)+parseFloat(H100_JR20)+parseFloat(H101_JR20)+parseFloat(H102_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B78-SUM(PROJECTIE!G$40:G$45)
	var C78 = (parseFloat(G15phide.val()) - parseFloat(B78) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C78+C$30)
	var D78 = (Math.trunc(parseFloat(C78) + C30)).toFixed(2);

	var E78;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H78 = ((980.14*(D78 - C30)/10000 + 1400) * (D78 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I78 = ((216.16*((D78 - 14254)/10000) + 2397) * ((D78 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J78 = (0.42*D78-8780.9).toFixed(2);

	//=TRUNC(IF(D78<14255,H78,IF(D74>55960,J72,I72)))
	if (D78<14255) {
		E78 = Math.trunc(H78).toFixed(2); //Valur of E78
	}
	else if (D78>55960) {
		E78 = Math.trunc(J78).toFixed(2); //Valur of E78
	}
	else{
		E78 = Math.trunc(I78).toFixed(2); //Valur of E78
	}
	//=PROJECTIE!D$51-E78-SUM(PROJECTIE!G$40:G$43)
	var F78 = (parseFloat(D51phide.val())-parseFloat(E78)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_83 = parseFloat(G30_JR20_82 - G102_JR20).toFixed(3);
	var H103_JR20 = parseFloat(G30_JR20_83 * taeg_JR20).toFixed(3);
	var G103_JR20 = parseFloat(pmt_constant_JR20 - H103_JR20).toFixed(3);

	var G30_JR20_84 = parseFloat(G30_JR20_83 - G103_JR20).toFixed(3);
	var H104_JR20 = parseFloat(G30_JR20_84 * taeg_JR20).toFixed(3);
	var G104_JR20 = parseFloat(pmt_constant_JR20 - H104_JR20).toFixed(3);

	var G30_JR20_85 = parseFloat(G30_JR20_84 - G104_JR20).toFixed(3);
	var H105_JR20 = parseFloat(G30_JR20_85 * taeg_JR20).toFixed(3);
	var G105_JR20 = parseFloat(pmt_constant_JR20 - H105_JR20).toFixed(3);

	var G30_JR20_86 = parseFloat(G30_JR20_85 - G105_JR20).toFixed(3);
	var H106_JR20 = parseFloat(G30_JR20_86 * taeg_JR20).toFixed(3);
	var G106_JR20 = parseFloat(pmt_constant_JR20 - H106_JR20).toFixed(3);

	var G30_JR20_87 = parseFloat(G30_JR20_86 - G106_JR20).toFixed(3);
	var H107_JR20 = parseFloat(G30_JR20_87 * taeg_JR20).toFixed(3);
	var G107_JR20 = parseFloat(pmt_constant_JR20 - H107_JR20).toFixed(3);	

	var G30_JR20_88 = parseFloat(G30_JR20_87 - G107_JR20).toFixed(3);
	var H108_JR20 = parseFloat(G30_JR20_88 * taeg_JR20).toFixed(3);
	var G108_JR20 = parseFloat(pmt_constant_JR20 - H108_JR20).toFixed(3);	

	var G30_JR20_89 = parseFloat(G30_JR20_88 - G108_JR20).toFixed(3);
	var H109_JR20 = parseFloat(G30_JR20_89 * taeg_JR20).toFixed(3);
	var G109_JR20 = parseFloat(pmt_constant_JR20 - H109_JR20).toFixed(3);	

	var G30_JR20_90 = parseFloat(G30_JR20_89 - G109_JR20).toFixed(3);
	var H110_JR20 = parseFloat(G30_JR20_90 * taeg_JR20).toFixed(3);
	var G110_JR20 = parseFloat(pmt_constant_JR20 - H110_JR20).toFixed(3);

	var G30_JR20_91 = parseFloat(G30_JR20_90 - G110_JR20).toFixed(3);
	var H111_JR20 = parseFloat(G30_JR20_91 * taeg_JR20).toFixed(3);
	var G111_JR20 = parseFloat(pmt_constant_JR20 - H111_JR20).toFixed(3);

	var G30_JR20_92 = parseFloat(G30_JR20_91 - G111_JR20).toFixed(3);
	var H112_JR20 = parseFloat(G30_JR20_92 * taeg_JR20).toFixed(3);
	var G112_JR20 = parseFloat(pmt_constant_JR20 - H112_JR20).toFixed(3);	

	var G30_JR20_93 = parseFloat(G30_JR20_92 - G112_JR20).toFixed(3);
	var H113_JR20 = parseFloat(G30_JR20_93 * taeg_JR20).toFixed(3);
	var G113_JR20 = parseFloat(pmt_constant_JR20 - H113_JR20).toFixed(3);

	var G30_JR20_94 = parseFloat(G30_JR20_93 - G113_JR20).toFixed(3);
	var H114_JR20 = parseFloat(G30_JR20_94 * taeg_JR20).toFixed(3);
	var G114_JR20 = parseFloat(pmt_constant_JR20 - H114_JR20).toFixed(3);
	//=SUM('Amortiss 20 ans'!H103:H114)
	var B79 = (parseFloat(H103_JR20)+parseFloat(H104_JR20)+parseFloat(H105_JR20)+parseFloat(H106_JR20)+parseFloat(H107_JR20)+parseFloat(H108_JR20)+parseFloat(H109_JR20)+parseFloat(H110_JR20)+parseFloat(H111_JR20)+parseFloat(H112_JR20)+parseFloat(H113_JR20)+parseFloat(H114_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B79-SUM(PROJECTIE!G$40:G$45)
	var C79 = (parseFloat(G15phide.val()) - parseFloat(B79) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C78+C$30)
	var D79 = (Math.trunc(parseFloat(C79) + C30)).toFixed(2);

	var E79;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H79 = ((980.14*(D79 - C30)/10000 + 1400) * (D79 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I79 = ((216.16*((D79 - 14254)/10000) + 2397) * ((D79 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J79 = (0.42*D79-8780.9).toFixed(2);

	//=TRUNC(IF(D79<14255,H79,IF(D74>55960,J72,I72)))
	if (D79<14255) {
		E79 = Math.trunc(H79).toFixed(2); //Valur of E79
	}
	else if (D79>55960) {
		E79 = Math.trunc(J79).toFixed(2); //Valur of E79
	}
	else{
		E79 = Math.trunc(I79).toFixed(2); //Valur of E79
	}
	//=PROJECTIE!D$51-E79-SUM(PROJECTIE!G$40:G$43)
	var F79 = (parseFloat(D51phide.val())-parseFloat(E79)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_95 = parseFloat(G30_JR20_94 - G114_JR20).toFixed(3);
	var H115_JR20 = parseFloat(G30_JR20_95 * taeg_JR20).toFixed(3);
	var G115_JR20 = parseFloat(pmt_constant_JR20 - H115_JR20).toFixed(3);

	var G30_JR20_96 = parseFloat(G30_JR20_95 - G115_JR20).toFixed(3);
	var H116_JR20 = parseFloat(G30_JR20_96 * taeg_JR20).toFixed(3);
	var G116_JR20 = parseFloat(pmt_constant_JR20 - H116_JR20).toFixed(3);

	var G30_JR20_97 = parseFloat(G30_JR20_96 - G116_JR20).toFixed(3);
	var H117_JR20 = parseFloat(G30_JR20_97 * taeg_JR20).toFixed(3);
	var G117_JR20 = parseFloat(pmt_constant_JR20 - H117_JR20).toFixed(3);

	var G30_JR20_98 = parseFloat(G30_JR20_97 - G117_JR20).toFixed(3);
	var H118_JR20 = parseFloat(G30_JR20_98 * taeg_JR20).toFixed(3);
	var G118_JR20 = parseFloat(pmt_constant_JR20 - H118_JR20).toFixed(3);

	var G30_JR20_99 = parseFloat(G30_JR20_98 - G118_JR20).toFixed(3);
	var H119_JR20 = parseFloat(G30_JR20_99 * taeg_JR20).toFixed(3);
	var G119_JR20 = parseFloat(pmt_constant_JR20 - H119_JR20).toFixed(3);

	var G30_JR20_100 = parseFloat(G30_JR20_99 - G119_JR20).toFixed(3);
	var H120_JR20 = parseFloat(G30_JR20_100 * taeg_JR20).toFixed(3);
	var G120_JR20 = parseFloat(pmt_constant_JR20 - H120_JR20).toFixed(3);

	var G30_JR20_101 = parseFloat(G30_JR20_100 - G120_JR20).toFixed(3);
	var H121_JR20 = parseFloat(G30_JR20_101 * taeg_JR20).toFixed(3);
	var G121_JR20 = parseFloat(pmt_constant_JR20 - H121_JR20).toFixed(3);

	var G30_JR20_102 = parseFloat(G30_JR20_101 - G121_JR20).toFixed(3);
	var H122_JR20 = parseFloat(G30_JR20_102 * taeg_JR20).toFixed(3);
	var G122_JR20 = parseFloat(pmt_constant_JR20 - H122_JR20).toFixed(3);

	var G30_JR20_103 = parseFloat(G30_JR20_102 - G122_JR20).toFixed(3);
	var H123_JR20 = parseFloat(G30_JR20_103 * taeg_JR20).toFixed(3);
	var G123_JR20 = parseFloat(pmt_constant_JR20 - H123_JR20).toFixed(3);

	var G30_JR20_104 = parseFloat(G30_JR20_103 - G123_JR20).toFixed(3);
	var H124_JR20 = parseFloat(G30_JR20_104 * taeg_JR20).toFixed(3);
	var G124_JR20 = parseFloat(pmt_constant_JR20 - H124_JR20).toFixed(3);

	var G30_JR20_105 = parseFloat(G30_JR20_104 - G124_JR20).toFixed(3);
	var H125_JR20 = parseFloat(G30_JR20_105 * taeg_JR20).toFixed(3);
	var G125_JR20 = parseFloat(pmt_constant_JR20 - H125_JR20).toFixed(3);

	var G30_JR20_106 = parseFloat(G30_JR20_105 - G125_JR20).toFixed(3);
	var H126_JR20 = parseFloat(G30_JR20_106 * taeg_JR20).toFixed(3);
	var G126_JR20 = parseFloat(pmt_constant_JR20 - H126_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H115:H126)
	var B80 = (parseFloat(H115_JR20)+parseFloat(H116_JR20)+parseFloat(H117_JR20)+parseFloat(H118_JR20)+parseFloat(H119_JR20)+parseFloat(H120_JR20)+parseFloat(H121_JR20)+parseFloat(H122_JR20)+parseFloat(H123_JR20)+parseFloat(H124_JR20)+parseFloat(H125_JR20)+parseFloat(H126_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B80-SUM(PROJECTIE!G$40:G$45)
	var C80 = (parseFloat(G15phide.val()) - parseFloat(B80) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C78+C$30)
	var D80 = (Math.trunc(parseFloat(C80) + C30)).toFixed(2);

	var E80;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H80 = ((980.14*(D80 - C30)/10000 + 1400) * (D80 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I80 = ((216.16*((D80 - 14254)/10000) + 2397) * ((D80 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J80 = (0.42*D80-8780.9).toFixed(2);

	//=TRUNC(IF(D80<14255,H80,IF(D74>55960,J72,I72)))
	if (D80<14255) {
		E80 = Math.trunc(H80).toFixed(2); //Valur of E80
	}
	else if (D80>55960) {
		E80 = Math.trunc(J80).toFixed(2); //Valur of E80
	}
	else{
		E80 = Math.trunc(I80).toFixed(2); //Valur of E80
	}

	//=PROJECTIE!D$51-E80-SUM(PROJECTIE!G$40:G$43)
	var F80 = (parseFloat(D51phide.val())-parseFloat(E80)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_107 = parseFloat(G30_JR20_106 - G126_JR20).toFixed(3);
	var H127_JR20 = parseFloat(G30_JR20_107 * taeg_JR20).toFixed(3);
	var G127_JR20 = parseFloat(pmt_constant_JR20 - H127_JR20).toFixed(3);

	var G30_JR20_108 = parseFloat(G30_JR20_107 - G127_JR20).toFixed(3);
	var H128_JR20 = parseFloat(G30_JR20_108 * taeg_JR20).toFixed(3);
	var G128_JR20 = parseFloat(pmt_constant_JR20 - H128_JR20).toFixed(3);

	var G30_JR20_109 = parseFloat(G30_JR20_108 - G128_JR20).toFixed(3);
	var H129_JR20 = parseFloat(G30_JR20_109 * taeg_JR20).toFixed(3);
	var G129_JR20 = parseFloat(pmt_constant_JR20 - H129_JR20).toFixed(3);

	var G30_JR20_110 = parseFloat(G30_JR20_109 - G129_JR20).toFixed(3);
	var H130_JR20 = parseFloat(G30_JR20_110 * taeg_JR20).toFixed(3);
	var G130_JR20 = parseFloat(pmt_constant_JR20 - H130_JR20).toFixed(3);

	var G30_JR20_111 = parseFloat(G30_JR20_110 - G130_JR20).toFixed(3);
	var H131_JR20 = parseFloat(G30_JR20_111 * taeg_JR20).toFixed(3);
	var G131_JR20 = parseFloat(pmt_constant_JR20 - H131_JR20).toFixed(3);

	var G30_JR20_112 = parseFloat(G30_JR20_111 - G131_JR20).toFixed(3);
	var H132_JR20 = parseFloat(G30_JR20_112 * taeg_JR20).toFixed(3);
	var G132_JR20 = parseFloat(pmt_constant_JR20 - H132_JR20).toFixed(3);

	var G30_JR20_113 = parseFloat(G30_JR20_112 - G132_JR20).toFixed(3);
	var H133_JR20 = parseFloat(G30_JR20_113 * taeg_JR20).toFixed(3);
	var G133_JR20 = parseFloat(pmt_constant_JR20 - H133_JR20).toFixed(3);

	var G30_JR20_114 = parseFloat(G30_JR20_113 - G133_JR20).toFixed(3);
	var H134_JR20 = parseFloat(G30_JR20_114 * taeg_JR20).toFixed(3);
	var G134_JR20 = parseFloat(pmt_constant_JR20 - H134_JR20).toFixed(3);

	var G30_JR20_115 = parseFloat(G30_JR20_114 - G134_JR20).toFixed(3);
	var H135_JR20 = parseFloat(G30_JR20_115 * taeg_JR20).toFixed(3);
	var G135_JR20 = parseFloat(pmt_constant_JR20 - H135_JR20).toFixed(3);

	var G30_JR20_116 = parseFloat(G30_JR20_115 - G135_JR20).toFixed(3);
	var H136_JR20 = parseFloat(G30_JR20_116 * taeg_JR20).toFixed(3);
	var G136_JR20 = parseFloat(pmt_constant_JR20 - H136_JR20).toFixed(3);

	var G30_JR20_117 = parseFloat(G30_JR20_116 - G136_JR20).toFixed(3);
	var H137_JR20 = parseFloat(G30_JR20_117 * taeg_JR20).toFixed(3);
	var G137_JR20 = parseFloat(pmt_constant_JR20 - H137_JR20).toFixed(3);

	var G30_JR20_118 = parseFloat(G30_JR20_117 - G137_JR20).toFixed(3);
	var H138_JR20 = parseFloat(G30_JR20_118 * taeg_JR20).toFixed(3);
	var G138_JR20 = parseFloat(pmt_constant_JR20 - H138_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H127:H138)
	var B81 = (parseFloat(H127_JR20)+parseFloat(H128_JR20)+parseFloat(H129_JR20)+parseFloat(H130_JR20)+parseFloat(H131_JR20)+parseFloat(H132_JR20)+parseFloat(H133_JR20)+parseFloat(H134_JR20)+parseFloat(H135_JR20)+parseFloat(H136_JR20)+parseFloat(H137_JR20)+parseFloat(H138_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B81-SUM(PROJECTIE!G$40:G$45)
	var C81 = (parseFloat(G15phide.val()) - parseFloat(B81) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C78+C$30)
	var D81 = (Math.trunc(parseFloat(C81) + C30)).toFixed(2);

	var E81;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H81 = ((980.14*(D81 - C30)/10000 + 1400) * (D81 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I81 = ((216.16*((D81 - 14254)/10000) + 2397) * ((D81 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J81 = (0.42*D81-8780.9).toFixed(2);

	//=TRUNC(IF(D81<14255,H81,IF(D74>55960,J72,I72)))
	if (D81<14255) {
		E81 = Math.trunc(H81).toFixed(2); //Valur of E81
	}
	else if (D81>55960) {
		E81 = Math.trunc(J81).toFixed(2); //Valur of E81
	}
	else{
		E81 = Math.trunc(I81).toFixed(2); //Valur of E81
	}
	//=PROJECTIE!D$51-E81-SUM(PROJECTIE!G$40:G$43)
	var F81 = (parseFloat(D51phide.val())-parseFloat(E81)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_119 = parseFloat(G30_JR20_118 - G138_JR20).toFixed(3);
	var H139_JR20 = parseFloat(G30_JR20_119 * taeg_JR20).toFixed(3);
	var G139_JR20 = parseFloat(pmt_constant_JR20 - H139_JR20).toFixed(3);

	var G30_JR20_120 = parseFloat(G30_JR20_119 - G139_JR20).toFixed(3);
	var H140_JR20 = parseFloat(G30_JR20_120 * taeg_JR20).toFixed(3);
	var G140_JR20 = parseFloat(pmt_constant_JR20 - H140_JR20).toFixed(3);

	var G30_JR20_121 = parseFloat(G30_JR20_120 - G140_JR20).toFixed(3);
	var H141_JR20 = parseFloat(G30_JR20_121 * taeg_JR20).toFixed(3);
	var G141_JR20 = parseFloat(pmt_constant_JR20 - H141_JR20).toFixed(3);

	var G30_JR20_122 = parseFloat(G30_JR20_121 - G141_JR20).toFixed(3);
	var H142_JR20 = parseFloat(G30_JR20_122 * taeg_JR20).toFixed(3);
	var G142_JR20 = parseFloat(pmt_constant_JR20 - H142_JR20).toFixed(3);

	var G30_JR20_123 = parseFloat(G30_JR20_122 - G142_JR20).toFixed(3);
	var H143_JR20 = parseFloat(G30_JR20_123 * taeg_JR20).toFixed(3);
	var G143_JR20 = parseFloat(pmt_constant_JR20 - H143_JR20).toFixed(3);

	var G30_JR20_124 = parseFloat(G30_JR20_123 - G143_JR20).toFixed(3);
	var H144_JR20 = parseFloat(G30_JR20_124 * taeg_JR20).toFixed(3);
	var G144_JR20 = parseFloat(pmt_constant_JR20 - H144_JR20).toFixed(3);

	var G30_JR20_125 = parseFloat(G30_JR20_124 - G144_JR20).toFixed(3);
	var H145_JR20 = parseFloat(G30_JR20_125 * taeg_JR20).toFixed(3);
	var G145_JR20 = parseFloat(pmt_constant_JR20 - H145_JR20).toFixed(3);

	var G30_JR20_126 = parseFloat(G30_JR20_125 - G145_JR20).toFixed(3);
	var H146_JR20 = parseFloat(G30_JR20_126 * taeg_JR20).toFixed(3);
	var G146_JR20 = parseFloat(pmt_constant_JR20 - H146_JR20).toFixed(3);

	var G30_JR20_127 = parseFloat(G30_JR20_126 - G146_JR20).toFixed(3);
	var H147_JR20 = parseFloat(G30_JR20_127 * taeg_JR20).toFixed(3);
	var G147_JR20 = parseFloat(pmt_constant_JR20 - H147_JR20).toFixed(3);

	var G30_JR20_128 = parseFloat(G30_JR20_127 - G147_JR20).toFixed(3);
	var H148_JR20 = parseFloat(G30_JR20_128 * taeg_JR20).toFixed(3);
	var G148_JR20 = parseFloat(pmt_constant_JR20 - H148_JR20).toFixed(3);

	var G30_JR20_129 = parseFloat(G30_JR20_128 - G148_JR20).toFixed(3);
	var H149_JR20 = parseFloat(G30_JR20_129 * taeg_JR20).toFixed(3);
	var G149_JR20 = parseFloat(pmt_constant_JR20 - H149_JR20).toFixed(3);

	var G30_JR20_130 = parseFloat(G30_JR20_129 - G149_JR20).toFixed(3);
	var H150_JR20 = parseFloat(G30_JR20_130 * taeg_JR20).toFixed(3);
	var G150_JR20 = parseFloat(pmt_constant_JR20 - H150_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H139:H150)
	var B82 = (parseFloat(H139_JR20)+parseFloat(H140_JR20)+parseFloat(H141_JR20)+parseFloat(H142_JR20)+parseFloat(H143_JR20)+parseFloat(H144_JR20)+parseFloat(H145_JR20)+parseFloat(H146_JR20)+parseFloat(H147_JR20)+parseFloat(H148_JR20)+parseFloat(H149_JR20)+parseFloat(H150_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B82-SUM(PROJECTIE!G$40:G$45)
	var C82 = (parseFloat(G15phide.val()) - parseFloat(B82) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C82+C$30)
	var D82 = (Math.trunc(parseFloat(C82) + C30)).toFixed(2);

	var E82;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H82 = ((980.14*(D82 - C30)/10000 + 1400) * (D82 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I82 = ((216.16*((D82 - 14254)/10000) + 2397) * ((D82 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J82 = (0.42*D82-8780.9).toFixed(2);

	//=TRUNC(IF(D82<14255,H82,IF(D74>55960,J72,I72)))
	if (D82<14255) {
		E82 = Math.trunc(H82).toFixed(2); //Valur of E82
	}
	else if (D82>55960) {
		E82 = Math.trunc(J82).toFixed(2); //Valur of E82
	}
	else{
		E82 = Math.trunc(I82).toFixed(2); //Valur of E82
	}
	//=PROJECTIE!D$51-E82-SUM(PROJECTIE!G$40:G$43)
	var F82 = (parseFloat(D51phide.val())-parseFloat(E82)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_131 = parseFloat(G30_JR20_130 - G150_JR20).toFixed(3);
	var H151_JR20 = parseFloat(G30_JR20_131 * taeg_JR20).toFixed(3);
	var G151_JR20 = parseFloat(pmt_constant_JR20 - H151_JR20).toFixed(3);

	var G30_JR20_132 = parseFloat(G30_JR20_131 - G151_JR20).toFixed(3);
	var H152_JR20 = parseFloat(G30_JR20_132 * taeg_JR20).toFixed(3);
	var G152_JR20 = parseFloat(pmt_constant_JR20 - H152_JR20).toFixed(3);

	var G30_JR20_133 = parseFloat(G30_JR20_132 - G152_JR20).toFixed(3);
	var H153_JR20 = parseFloat(G30_JR20_133 * taeg_JR20).toFixed(3);
	var G153_JR20 = parseFloat(pmt_constant_JR20 - H153_JR20).toFixed(3);

	var G30_JR20_134 = parseFloat(G30_JR20_133 - G153_JR20).toFixed(3);
	var H154_JR20 = parseFloat(G30_JR20_134 * taeg_JR20).toFixed(3);
	var G154_JR20 = parseFloat(pmt_constant_JR20 - H154_JR20).toFixed(3);

	var G30_JR20_135 = parseFloat(G30_JR20_134 - G154_JR20).toFixed(3);
	var H155_JR20 = parseFloat(G30_JR20_135 * taeg_JR20).toFixed(3);
	var G155_JR20 = parseFloat(pmt_constant_JR20 - H155_JR20).toFixed(3);

	var G30_JR20_136 = parseFloat(G30_JR20_135 - G155_JR20).toFixed(3);
	var H156_JR20 = parseFloat(G30_JR20_136 * taeg_JR20).toFixed(3);
	var G156_JR20 = parseFloat(pmt_constant_JR20 - H156_JR20).toFixed(3);

	var G30_JR20_137 = parseFloat(G30_JR20_136 - G156_JR20).toFixed(3);
	var H157_JR20 = parseFloat(G30_JR20_137 * taeg_JR20).toFixed(3);
	var G157_JR20 = parseFloat(pmt_constant_JR20 - H157_JR20).toFixed(3);

	var G30_JR20_138 = parseFloat(G30_JR20_137 - G157_JR20).toFixed(3);
	var H158_JR20 = parseFloat(G30_JR20_138 * taeg_JR20).toFixed(3);
	var G158_JR20 = parseFloat(pmt_constant_JR20 - H158_JR20).toFixed(3);

	var G30_JR20_139 = parseFloat(G30_JR20_138 - G158_JR20).toFixed(3);
	var H159_JR20 = parseFloat(G30_JR20_139 * taeg_JR20).toFixed(3);
	var G159_JR20 = parseFloat(pmt_constant_JR20 - H159_JR20).toFixed(3);

	var G30_JR20_140 = parseFloat(G30_JR20_139 - G159_JR20).toFixed(3);
	var H160_JR20 = parseFloat(G30_JR20_140 * taeg_JR20).toFixed(3);
	var G160_JR20 = parseFloat(pmt_constant_JR20 - H160_JR20).toFixed(3);

	var G30_JR20_141 = parseFloat(G30_JR20_140 - G160_JR20).toFixed(3);
	var H161_JR20 = parseFloat(G30_JR20_141 * taeg_JR20).toFixed(3);
	var G161_JR20 = parseFloat(pmt_constant_JR20 - H161_JR20).toFixed(3);

	var G30_JR20_142 = parseFloat(G30_JR20_141 - G161_JR20).toFixed(3);
	var H162_JR20 = parseFloat(G30_JR20_142 * taeg_JR20).toFixed(3);
	var G162_JR20 = parseFloat(pmt_constant_JR20 - H162_JR20).toFixed(3);
	//=SUM('Amortiss 20 ans'!H151:H162)
	var B83 = (parseFloat(H151_JR20)+parseFloat(H152_JR20)+parseFloat(H153_JR20)+parseFloat(H154_JR20)+parseFloat(H155_JR20)+parseFloat(H156_JR20)+parseFloat(H157_JR20)+parseFloat(H158_JR20)+parseFloat(H159_JR20)+parseFloat(H160_JR20)+parseFloat(H161_JR20)+parseFloat(H162_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B83-SUM(PROJECTIE!G$40:G$45)
	var C83 = (parseFloat(G15phide.val()) - parseFloat(B83) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C83+C$30)
	var D83 = (Math.trunc(parseFloat(C83) + C30)).toFixed(2);

	var E83;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H83 = ((980.14*(D83 - C30)/10000 + 1400) * (D83 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I83 = ((216.16*((D83 - 14254)/10000) + 2397) * ((D83 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J83 = (0.42*D83-8780.9).toFixed(2);

	//=TRUNC(IF(D83<14255,H83,IF(D74>55960,J72,I72)))
	if (D83<14255) {
		E83 = Math.trunc(H83).toFixed(2); //Valur of E83
	}
	else if (D83>55960) {
		E83 = Math.trunc(J83).toFixed(2); //Valur of E83
	}
	else{
		E83 = Math.trunc(I83).toFixed(2); //Valur of E83
	}
	//=PROJECTIE!D$51-E83-SUM(PROJECTIE!G$40:G$43)
	var F83 = (parseFloat(D51phide.val())-parseFloat(E83)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_143 = parseFloat(G30_JR20_142 - G162_JR20).toFixed(3);
	var H163_JR20 = parseFloat(G30_JR20_143 * taeg_JR20).toFixed(3);
	var G163_JR20 = parseFloat(pmt_constant_JR20 - H163_JR20).toFixed(3);

	var G30_JR20_144 = parseFloat(G30_JR20_143 - G163_JR20).toFixed(3);
	var H164_JR20 = parseFloat(G30_JR20_144 * taeg_JR20).toFixed(3);
	var G164_JR20 = parseFloat(pmt_constant_JR20 - H164_JR20).toFixed(3);

	var G30_JR20_145 = parseFloat(G30_JR20_144 - G164_JR20).toFixed(3);
	var H165_JR20 = parseFloat(G30_JR20_145 * taeg_JR20).toFixed(3);
	var G165_JR20 = parseFloat(pmt_constant_JR20 - H165_JR20).toFixed(3);

	var G30_JR20_146 = parseFloat(G30_JR20_145 - G165_JR20).toFixed(3);
	var H166_JR20 = parseFloat(G30_JR20_146 * taeg_JR20).toFixed(3);
	var G166_JR20 = parseFloat(pmt_constant_JR20 - H166_JR20).toFixed(3);

	var G30_JR20_147 = parseFloat(G30_JR20_146 - G166_JR20).toFixed(3);
	var H167_JR20 = parseFloat(G30_JR20_147 * taeg_JR20).toFixed(3);
	var G167_JR20 = parseFloat(pmt_constant_JR20 - H167_JR20).toFixed(3);

	var G30_JR20_148 = parseFloat(G30_JR20_147 - G167_JR20).toFixed(3);
	var H168_JR20 = parseFloat(G30_JR20_148 * taeg_JR20).toFixed(3);
	var G168_JR20 = parseFloat(pmt_constant_JR20 - H168_JR20).toFixed(3);

	var G30_JR20_149 = parseFloat(G30_JR20_148 - G168_JR20).toFixed(3);
	var H169_JR20 = parseFloat(G30_JR20_149 * taeg_JR20).toFixed(3);
	var G169_JR20 = parseFloat(pmt_constant_JR20 - H169_JR20).toFixed(3);

	var G30_JR20_150 = parseFloat(G30_JR20_149 - G169_JR20).toFixed(3);
	var H170_JR20 = parseFloat(G30_JR20_150 * taeg_JR20).toFixed(3);
	var G170_JR20 = parseFloat(pmt_constant_JR20 - H170_JR20).toFixed(3);

	var G30_JR20_151 = parseFloat(G30_JR20_150 - G170_JR20).toFixed(3);
	var H171_JR20 = parseFloat(G30_JR20_151 * taeg_JR20).toFixed(3);
	var G171_JR20 = parseFloat(pmt_constant_JR20 - H171_JR20).toFixed(3);

	var G30_JR20_152 = parseFloat(G30_JR20_151 - G171_JR20).toFixed(3);
	var H172_JR20 = parseFloat(G30_JR20_152 * taeg_JR20).toFixed(3);
	var G172_JR20 = parseFloat(pmt_constant_JR20 - H172_JR20).toFixed(3);

	var G30_JR20_153 = parseFloat(G30_JR20_152 - G172_JR20).toFixed(3);
	var H173_JR20 = parseFloat(G30_JR20_153 * taeg_JR20).toFixed(3);
	var G173_JR20 = parseFloat(pmt_constant_JR20 - H173_JR20).toFixed(3);

	var G30_JR20_154 = parseFloat(G30_JR20_153 - G173_JR20).toFixed(3);
	var H174_JR20 = parseFloat(G30_JR20_154 * taeg_JR20).toFixed(3);
	var G174_JR20 = parseFloat(pmt_constant_JR20 - H174_JR20).toFixed(3);
	//=SUM('Amortiss 20 ans'!H163:H174)
	var B84 = (parseFloat(H163_JR20)+parseFloat(H164_JR20)+parseFloat(H165_JR20)+parseFloat(H166_JR20)+parseFloat(H167_JR20)+parseFloat(H168_JR20)+parseFloat(H169_JR20)+parseFloat(H170_JR20)+parseFloat(H171_JR20)+parseFloat(H172_JR20)+parseFloat(H173_JR20)+parseFloat(H174_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B84-SUM(PROJECTIE!G$40:G$45)
	var C84 = (parseFloat(G15phide.val()) - parseFloat(B84) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C84+C$30)
	var D84 = (Math.trunc(parseFloat(C84) + C30)).toFixed(2);

	var E84;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H84 = ((980.14*(D84 - C30)/10000 + 1400) * (D84 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I84 = ((216.16*((D84 - 14254)/10000) + 2397) * ((D84 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J84 = (0.42*D84-8780.9).toFixed(2);

	//=TRUNC(IF(D84<14255,H84,IF(D74>55960,J72,I72)))
	if (D84<14255) {
		E84 = Math.trunc(H84).toFixed(2); //Valur of E84
	}
	else if (D84>55960) {
		E84 = Math.trunc(J84).toFixed(2); //Valur of E84
	}
	else{
		E84 = Math.trunc(I84).toFixed(2); //Valur of E84
	}
	//=PROJECTIE!D$51-E84-SUM(PROJECTIE!G$40:G$43)
	var F84 = (parseFloat(D51phide.val())-parseFloat(E84)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_155 = parseFloat(G30_JR20_154 - G174_JR20).toFixed(3);
	var H175_JR20 = parseFloat(G30_JR20_155 * taeg_JR20).toFixed(3);
	var G175_JR20 = parseFloat(pmt_constant_JR20 - H175_JR20).toFixed(3);

	var G30_JR20_156 = parseFloat(G30_JR20_155 - G175_JR20).toFixed(3);
	var H176_JR20 = parseFloat(G30_JR20_156 * taeg_JR20).toFixed(3);
	var G176_JR20 = parseFloat(pmt_constant_JR20 - H176_JR20).toFixed(3);

	var G30_JR20_157 = parseFloat(G30_JR20_156 - G176_JR20).toFixed(3);
	var H177_JR20 = parseFloat(G30_JR20_157 * taeg_JR20).toFixed(3);
	var G177_JR20 = parseFloat(pmt_constant_JR20 - H177_JR20).toFixed(3);

	var G30_JR20_158 = parseFloat(G30_JR20_157 - G177_JR20).toFixed(3);
	var H178_JR20 = parseFloat(G30_JR20_158 * taeg_JR20).toFixed(3);
	var G178_JR20 = parseFloat(pmt_constant_JR20 - H178_JR20).toFixed(3);

	var G30_JR20_159 = parseFloat(G30_JR20_158 - G178_JR20).toFixed(3);
	var H179_JR20 = parseFloat(G30_JR20_159 * taeg_JR20).toFixed(3);
	var G179_JR20 = parseFloat(pmt_constant_JR20 - H179_JR20).toFixed(3);

	var G30_JR20_160 = parseFloat(G30_JR20_159 - G179_JR20).toFixed(3);
	var H180_JR20 = parseFloat(G30_JR20_160 * taeg_JR20).toFixed(3);
	var G180_JR20 = parseFloat(pmt_constant_JR20 - H180_JR20).toFixed(3);

	var G30_JR20_161 = parseFloat(G30_JR20_160 - G180_JR20).toFixed(3);
	var H181_JR20 = parseFloat(G30_JR20_161 * taeg_JR20).toFixed(3);
	var G181_JR20 = parseFloat(pmt_constant_JR20 - H181_JR20).toFixed(3);

	var G30_JR20_162 = parseFloat(G30_JR20_161 - G181_JR20).toFixed(3);
	var H182_JR20 = parseFloat(G30_JR20_162 * taeg_JR20).toFixed(3);
	var G182_JR20 = parseFloat(pmt_constant_JR20 - H182_JR20).toFixed(3);

	var G30_JR20_163 = parseFloat(G30_JR20_162 - G182_JR20).toFixed(3);
	var H183_JR20 = parseFloat(G30_JR20_163 * taeg_JR20).toFixed(3);
	var G183_JR20 = parseFloat(pmt_constant_JR20 - H183_JR20).toFixed(3);

	var G30_JR20_164 = parseFloat(G30_JR20_163 - G183_JR20).toFixed(3);
	var H184_JR20 = parseFloat(G30_JR20_164 * taeg_JR20).toFixed(3);
	var G184_JR20 = parseFloat(pmt_constant_JR20 - H184_JR20).toFixed(3);

	var G30_JR20_165 = parseFloat(G30_JR20_164 - G184_JR20).toFixed(3);
	var H185_JR20 = parseFloat(G30_JR20_165 * taeg_JR20).toFixed(3);
	var G185_JR20 = parseFloat(pmt_constant_JR20 - H185_JR20).toFixed(3);

	var G30_JR20_166 = parseFloat(G30_JR20_165 - G185_JR20).toFixed(3);
	var H186_JR20 = parseFloat(G30_JR20_166 * taeg_JR20).toFixed(3);
	var G186_JR20 = parseFloat(pmt_constant_JR20 - H186_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H175:H186)
	var B85 = (parseFloat(H175_JR20)+parseFloat(H176_JR20)+parseFloat(H177_JR20)+parseFloat(H178_JR20)+parseFloat(H179_JR20)+parseFloat(H180_JR20)+parseFloat(H181_JR20)+parseFloat(H182_JR20)+parseFloat(H183_JR20)+parseFloat(H184_JR20)+parseFloat(H185_JR20)+parseFloat(H186_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B85-SUM(PROJECTIE!G$40:G$45)
	var C85 = (parseFloat(G15phide.val()) - parseFloat(B85) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C85+C$30)
	var D85 = (Math.trunc(parseFloat(C85) + C30)).toFixed(2);

	var E85;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H85 = ((980.14*(D85 - C30)/10000 + 1400) * (D85 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I85 = ((216.16*((D85 - 14254)/10000) + 2397) * ((D85 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J85 = (0.42*D85-8780.9).toFixed(2);

	//=TRUNC(IF(D85<14255,H85,IF(D74>55960,J72,I72)))
	if (D85<14255) {
		E85 = Math.trunc(H85).toFixed(2); //Valur of E85
	}
	else if (D85>55960) {
		E85 = Math.trunc(J85).toFixed(2); //Valur of E85
	}
	else{
		E85 = Math.trunc(I85).toFixed(2); //Valur of E85
	}
	//=PROJECTIE!D$51-E85-SUM(PROJECTIE!G$40:G$43)
	var F85 = (parseFloat(D51phide.val())-parseFloat(E85)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_167 = parseFloat(G30_JR20_166 - G186_JR20).toFixed(3);
	var H187_JR20 = parseFloat(G30_JR20_167 * taeg_JR20).toFixed(3);
	var G187_JR20 = parseFloat(pmt_constant_JR20 - H187_JR20).toFixed(3);

	var G30_JR20_168 = parseFloat(G30_JR20_167 - G187_JR20).toFixed(3);
	var H188_JR20 = parseFloat(G30_JR20_168 * taeg_JR20).toFixed(3);
	var G188_JR20 = parseFloat(pmt_constant_JR20 - H188_JR20).toFixed(3);

	var G30_JR20_169 = parseFloat(G30_JR20_168 - G188_JR20).toFixed(3);
	var H189_JR20 = parseFloat(G30_JR20_169 * taeg_JR20).toFixed(3);
	var G189_JR20 = parseFloat(pmt_constant_JR20 - H189_JR20).toFixed(3);
	
	var G30_JR20_170 = parseFloat(G30_JR20_169 - G189_JR20).toFixed(3);
	var H190_JR20 = parseFloat(G30_JR20_170 * taeg_JR20).toFixed(3);
	var G190_JR20 = parseFloat(pmt_constant_JR20 - H190_JR20).toFixed(3);

	var G30_JR20_171 = parseFloat(G30_JR20_170 - G190_JR20).toFixed(3);
	var H191_JR20 = parseFloat(G30_JR20_171 * taeg_JR20).toFixed(3);
	var G191_JR20 = parseFloat(pmt_constant_JR20 - H191_JR20).toFixed(3);

	var G30_JR20_172 = parseFloat(G30_JR20_171 - G191_JR20).toFixed(3);
	var H192_JR20 = parseFloat(G30_JR20_172 * taeg_JR20).toFixed(3);
	var G192_JR20 = parseFloat(pmt_constant_JR20 - H192_JR20).toFixed(3);

	var G30_JR20_173 = parseFloat(G30_JR20_172 - G192_JR20).toFixed(3);
	var H193_JR20 = parseFloat(G30_JR20_173 * taeg_JR20).toFixed(3);
	var G193_JR20 = parseFloat(pmt_constant_JR20 - H193_JR20).toFixed(3);

	var G30_JR20_174 = parseFloat(G30_JR20_173 - G193_JR20).toFixed(3);
	var H194_JR20 = parseFloat(G30_JR20_174 * taeg_JR20).toFixed(3);
	var G194_JR20 = parseFloat(pmt_constant_JR20 - H194_JR20).toFixed(3);

	var G30_JR20_175 = parseFloat(G30_JR20_174 - G194_JR20).toFixed(3);
	var H195_JR20 = parseFloat(G30_JR20_175 * taeg_JR20).toFixed(3);
	var G195_JR20 = parseFloat(pmt_constant_JR20 - H195_JR20).toFixed(3);

	var G30_JR20_176 = parseFloat(G30_JR20_175 - G195_JR20).toFixed(3);
	var H196_JR20 = parseFloat(G30_JR20_176 * taeg_JR20).toFixed(3);
	var G196_JR20 = parseFloat(pmt_constant_JR20 - H196_JR20).toFixed(3);

	var G30_JR20_177 = parseFloat(G30_JR20_176 - G196_JR20).toFixed(3);
	var H197_JR20 = parseFloat(G30_JR20_177 * taeg_JR20).toFixed(3);
	var G197_JR20 = parseFloat(pmt_constant_JR20 - H197_JR20).toFixed(3);

	var G30_JR20_178 = parseFloat(G30_JR20_177 - G197_JR20).toFixed(3);
	var H198_JR20 = parseFloat(G30_JR20_178 * taeg_JR20).toFixed(3);
	var G198_JR20 = parseFloat(pmt_constant_JR20 - H198_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H187:H198)
	var B86 = (parseFloat(H187_JR20)+parseFloat(H188_JR20)+parseFloat(H189_JR20)+parseFloat(H190_JR20)+parseFloat(H191_JR20)+parseFloat(H192_JR20)+parseFloat(H193_JR20)+parseFloat(H194_JR20)+parseFloat(H195_JR20)+parseFloat(H196_JR20)+parseFloat(H197_JR20)+parseFloat(H198_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B86-SUM(PROJECTIE!G$40:G$45)
	var C86 = (parseFloat(G15phide.val()) - parseFloat(B86) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C86+C$30)
	var D86 = (Math.trunc(parseFloat(C86) + C30)).toFixed(2);

	var E86;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H86 = ((980.14*(D86 - C30)/10000 + 1400) * (D86 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I86 = ((216.16*((D86 - 14254)/10000) + 2397) * ((D86 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J86 = (0.42*D86-8780.9).toFixed(2);

	//=TRUNC(IF(D86<14255,H86,IF(D74>55960,J72,I72)))
	if (D86<14255) {
		E86 = Math.trunc(H86).toFixed(2); //Valur of E86
	}
	else if (D86>55960) {
		E86 = Math.trunc(J86).toFixed(2); //Valur of E86
	}
	else{
		E86 = Math.trunc(I86).toFixed(2); //Valur of E86
	}
	//=PROJECTIE!D$51-E86-SUM(PROJECTIE!G$40:G$43)
	var F86 = (parseFloat(D51phide.val())-parseFloat(E86)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_179 = parseFloat(G30_JR20_178 - G198_JR20).toFixed(3);
	var H199_JR20 = parseFloat(G30_JR20_179 * taeg_JR20).toFixed(3);
	var G199_JR20 = parseFloat(pmt_constant_JR20 - H199_JR20).toFixed(3);

	var G30_JR20_180 = parseFloat(G30_JR20_179 - G199_JR20).toFixed(3);
	var H200_JR20 = parseFloat(G30_JR20_180 * taeg_JR20).toFixed(3);
	var G200_JR20 = parseFloat(pmt_constant_JR20 - H200_JR20).toFixed(3);

	var G30_JR20_181 = parseFloat(G30_JR20_180 - G200_JR20).toFixed(3);
	var H201_JR20 = parseFloat(G30_JR20_181 * taeg_JR20).toFixed(3);
	var G201_JR20 = parseFloat(pmt_constant_JR20 - H201_JR20).toFixed(3);

	var G30_JR20_182 = parseFloat(G30_JR20_181 - G201_JR20).toFixed(3);
	var H202_JR20 = parseFloat(G30_JR20_182 * taeg_JR20).toFixed(3);
	var G202_JR20 = parseFloat(pmt_constant_JR20 - H202_JR20).toFixed(3);

	var G30_JR20_183 = parseFloat(G30_JR20_182 - G202_JR20).toFixed(3);
	var H203_JR20 = parseFloat(G30_JR20_183 * taeg_JR20).toFixed(3);
	var G203_JR20 = parseFloat(pmt_constant_JR20 - H203_JR20).toFixed(3);

	var G30_JR20_184 = parseFloat(G30_JR20_183 - G203_JR20).toFixed(3);
	var H204_JR20 = parseFloat(G30_JR20_184 * taeg_JR20).toFixed(3);
	var G204_JR20 = parseFloat(pmt_constant_JR20 - H204_JR20).toFixed(3);

	var G30_JR20_185 = parseFloat(G30_JR20_184 - G204_JR20).toFixed(3);
	var H205_JR20 = parseFloat(G30_JR20_185 * taeg_JR20).toFixed(3);
	var G205_JR20 = parseFloat(pmt_constant_JR20 - H205_JR20).toFixed(3);

	var G30_JR20_186 = parseFloat(G30_JR20_185 - G205_JR20).toFixed(3);
	var H206_JR20 = parseFloat(G30_JR20_186 * taeg_JR20).toFixed(3);
	var G206_JR20 = parseFloat(pmt_constant_JR20 - H206_JR20).toFixed(3);

	var G30_JR20_187 = parseFloat(G30_JR20_186 - G206_JR20).toFixed(3);
	var H207_JR20 = parseFloat(G30_JR20_187 * taeg_JR20).toFixed(3);
	var G207_JR20 = parseFloat(pmt_constant_JR20 - H207_JR20).toFixed(3);

	var G30_JR20_188 = parseFloat(G30_JR20_187 - G207_JR20).toFixed(3);
	var H208_JR20 = parseFloat(G30_JR20_188 * taeg_JR20).toFixed(3);
	var G208_JR20 = parseFloat(pmt_constant_JR20 - H208_JR20).toFixed(3);

	var G30_JR20_189 = parseFloat(G30_JR20_188 - G208_JR20).toFixed(3);
	var H209_JR20 = parseFloat(G30_JR20_189 * taeg_JR20).toFixed(3);
	var G209_JR20 = parseFloat(pmt_constant_JR20 - H209_JR20).toFixed(3);

	var G30_JR20_190 = parseFloat(G30_JR20_189 - G209_JR20).toFixed(3);
	var H210_JR20 = parseFloat(G30_JR20_190 * taeg_JR20).toFixed(3);
	var G210_JR20 = parseFloat(pmt_constant_JR20 - H210_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H199:H210)
	var B87 = (parseFloat(H199_JR20)+parseFloat(H200_JR20)+parseFloat(H201_JR20)+parseFloat(H202_JR20)+parseFloat(H203_JR20)+parseFloat(H204_JR20)+parseFloat(H205_JR20)+parseFloat(H206_JR20)+parseFloat(H207_JR20)+parseFloat(H208_JR20)+parseFloat(H209_JR20)+parseFloat(H210_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B87-SUM(PROJECTIE!G$40:G$45)
	var C87 = (parseFloat(G15phide.val()) - parseFloat(B87) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C87+C$30)
	var D87 = (Math.trunc(parseFloat(C87) + C30)).toFixed(2);

	var E87;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H87 = ((980.14*(D87 - C30)/10000 + 1400) * (D87 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I87 = ((216.16*((D87 - 14254)/10000) + 2397) * ((D87 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J87 = (0.42*D87-8780.9).toFixed(2);

	//=TRUNC(IF(D87<14255,H87,IF(D74>55960,J72,I72)))
	if (D87<14255) {
		E87 = Math.trunc(H87).toFixed(2); //Valur of E87
	}
	else if (D87>55960) {
		E87 = Math.trunc(J87).toFixed(2); //Valur of E87
	}
	else{
		E87 = Math.trunc(I87).toFixed(2); //Valur of E87
	}
	//=PROJECTIE!D$51-E87-SUM(PROJECTIE!G$40:G$43)
	var F87 = (parseFloat(D51phide.val())-parseFloat(E87)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);


	
	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_191 = parseFloat(G30_JR20_190 - G210_JR20).toFixed(3);
	var H211_JR20 = parseFloat(G30_JR20_191 * taeg_JR20).toFixed(3);
	var G211_JR20 = parseFloat(pmt_constant_JR20 - H211_JR20).toFixed(3);

	var G30_JR20_192 = parseFloat(G30_JR20_191 - G211_JR20).toFixed(3);
	var H212_JR20 = parseFloat(G30_JR20_192 * taeg_JR20).toFixed(3);
	var G212_JR20 = parseFloat(pmt_constant_JR20 - H212_JR20).toFixed(3);

	var G30_JR20_193 = parseFloat(G30_JR20_192 - G212_JR20).toFixed(3);
	var H213_JR20 = parseFloat(G30_JR20_193 * taeg_JR20).toFixed(3);
	var G213_JR20 = parseFloat(pmt_constant_JR20 - H213_JR20).toFixed(3);

	var G30_JR20_194 = parseFloat(G30_JR20_193 - G213_JR20).toFixed(3);
	var H214_JR20 = parseFloat(G30_JR20_194 * taeg_JR20).toFixed(3);
	var G214_JR20 = parseFloat(pmt_constant_JR20 - H214_JR20).toFixed(3);

	var G30_JR20_195 = parseFloat(G30_JR20_194 - G214_JR20).toFixed(3);
	var H215_JR20 = parseFloat(G30_JR20_195 * taeg_JR20).toFixed(3);
	var G215_JR20 = parseFloat(pmt_constant_JR20 - H215_JR20).toFixed(3);

	var G30_JR20_196 = parseFloat(G30_JR20_195 - G215_JR20).toFixed(3);
	var H216_JR20 = parseFloat(G30_JR20_196 * taeg_JR20).toFixed(3);
	var G216_JR20 = parseFloat(pmt_constant_JR20 - H216_JR20).toFixed(3);

	var G30_JR20_197 = parseFloat(G30_JR20_196 - G216_JR20).toFixed(3);
	var H217_JR20 = parseFloat(G30_JR20_197 * taeg_JR20).toFixed(3);
	var G217_JR20 = parseFloat(pmt_constant_JR20 - H217_JR20).toFixed(3);

	var G30_JR20_198 = parseFloat(G30_JR20_197 - G217_JR20).toFixed(3);
	var H218_JR20 = parseFloat(G30_JR20_198 * taeg_JR20).toFixed(3);
	var G218_JR20 = parseFloat(pmt_constant_JR20 - H218_JR20).toFixed(3);

	var G30_JR20_199 = parseFloat(G30_JR20_198 - G218_JR20).toFixed(3);
	var H219_JR20 = parseFloat(G30_JR20_199 * taeg_JR20).toFixed(3);
	var G219_JR20 = parseFloat(pmt_constant_JR20 - H219_JR20).toFixed(3);

	var G30_JR20_200 = parseFloat(G30_JR20_199 - G219_JR20).toFixed(3);
	var H220_JR20 = parseFloat(G30_JR20_200 * taeg_JR20).toFixed(3);
	var G220_JR20 = parseFloat(pmt_constant_JR20 - H220_JR20).toFixed(3);

	var G30_JR20_201 = parseFloat(G30_JR20_200 - G220_JR20).toFixed(3);
	var H221_JR20 = parseFloat(G30_JR20_201 * taeg_JR20).toFixed(3);
	var G221_JR20 = parseFloat(pmt_constant_JR20 - H221_JR20).toFixed(3);

	var G30_JR20_202 = parseFloat(G30_JR20_201 - G221_JR20).toFixed(3);
	var H222_JR20 = parseFloat(G30_JR20_202 * taeg_JR20).toFixed(3);
	var G222_JR20 = parseFloat(pmt_constant_JR20 - H222_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H211:H222)
	var B88 = (parseFloat(H211_JR20)+parseFloat(H212_JR20)+parseFloat(H213_JR20)+parseFloat(H214_JR20)+parseFloat(H215_JR20)+parseFloat(H216_JR20)+parseFloat(H217_JR20)+parseFloat(H218_JR20)+parseFloat(H219_JR20)+parseFloat(H220_JR20)+parseFloat(H221_JR20)+parseFloat(H222_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B88-SUM(PROJECTIE!G$40:G$45)
	var C88 = (parseFloat(G15phide.val()) - parseFloat(B88) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C88+C$30)
	var D88 = (Math.trunc(parseFloat(C88) + C30)).toFixed(2);

	var E88;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H88 = ((980.14*(D88 - C30)/10000 + 1400) * (D88 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I88 = ((216.16*((D88 - 14254)/10000) + 2397) * ((D88 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J88 = (0.42*D88-8780.9).toFixed(2);

	//=TRUNC(IF(D88<14255,H88,IF(D74>55960,J72,I72)))
	if (D88<14255) {
		E88 = Math.trunc(H88).toFixed(2); //Valur of E88
	}
	else if (D88>55960) {
		E88 = Math.trunc(J88).toFixed(2); //Valur of E88
	}
	else{
		E88 = Math.trunc(I88).toFixed(2); //Valur of E88
	}
	//=PROJECTIE!D$51-E88-SUM(PROJECTIE!G$40:G$43)
	var F88 = (parseFloat(D51phide.val())-parseFloat(E88)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);



	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_203 = parseFloat(G30_JR20_202 - G222_JR20).toFixed(3);
	var H223_JR20 = parseFloat(G30_JR20_203 * taeg_JR20).toFixed(3);
	var G223_JR20 = parseFloat(pmt_constant_JR20 - H223_JR20).toFixed(3);

	var G30_JR20_204 = parseFloat(G30_JR20_203 - G223_JR20).toFixed(3);
	var H224_JR20 = parseFloat(G30_JR20_204 * taeg_JR20).toFixed(3);
	var G224_JR20 = parseFloat(pmt_constant_JR20 - H224_JR20).toFixed(3);

	var G30_JR20_205 = parseFloat(G30_JR20_204 - G224_JR20).toFixed(3);
	var H225_JR20 = parseFloat(G30_JR20_205 * taeg_JR20).toFixed(3);
	var G225_JR20 = parseFloat(pmt_constant_JR20 - H225_JR20).toFixed(3);

	var G30_JR20_206 = parseFloat(G30_JR20_205 - G225_JR20).toFixed(3);
	var H226_JR20 = parseFloat(G30_JR20_206 * taeg_JR20).toFixed(3);
	var G226_JR20 = parseFloat(pmt_constant_JR20 - H226_JR20).toFixed(3);

	var G30_JR20_207 = parseFloat(G30_JR20_206 - G226_JR20).toFixed(3);
	var H227_JR20 = parseFloat(G30_JR20_207 * taeg_JR20).toFixed(3);
	var G227_JR20 = parseFloat(pmt_constant_JR20 - H227_JR20).toFixed(3);

	var G30_JR20_208 = parseFloat(G30_JR20_207 - G227_JR20).toFixed(3);
	var H228_JR20 = parseFloat(G30_JR20_208 * taeg_JR20).toFixed(3);
	var G228_JR20 = parseFloat(pmt_constant_JR20 - H228_JR20).toFixed(3);

	var G30_JR20_209 = parseFloat(G30_JR20_208 - G228_JR20).toFixed(3);
	var H229_JR20 = parseFloat(G30_JR20_209 * taeg_JR20).toFixed(3);
	var G229_JR20 = parseFloat(pmt_constant_JR20 - H229_JR20).toFixed(3);

	var G30_JR20_210 = parseFloat(G30_JR20_209 - G229_JR20).toFixed(3);
	var H230_JR20 = parseFloat(G30_JR20_210 * taeg_JR20).toFixed(3);
	var G230_JR20 = parseFloat(pmt_constant_JR20 - H230_JR20).toFixed(3);

	var G30_JR20_211 = parseFloat(G30_JR20_210 - G230_JR20).toFixed(3);
	var H231_JR20 = parseFloat(G30_JR20_211 * taeg_JR20).toFixed(3);
	var G231_JR20 = parseFloat(pmt_constant_JR20 - H231_JR20).toFixed(3);

	var G30_JR20_212 = parseFloat(G30_JR20_211 - G231_JR20).toFixed(3);
	var H232_JR20 = parseFloat(G30_JR20_212 * taeg_JR20).toFixed(3);
	var G232_JR20 = parseFloat(pmt_constant_JR20 - H232_JR20).toFixed(3);

	var G30_JR20_213 = parseFloat(G30_JR20_212 - G232_JR20).toFixed(3);
	var H233_JR20 = parseFloat(G30_JR20_213 * taeg_JR20).toFixed(3);
	var G233_JR20 = parseFloat(pmt_constant_JR20 - H233_JR20).toFixed(3);

	var G30_JR20_214 = parseFloat(G30_JR20_213 - G233_JR20).toFixed(3);
	var H234_JR20 = parseFloat(G30_JR20_214 * taeg_JR20).toFixed(3);
	var G234_JR20 = parseFloat(pmt_constant_JR20 - H234_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H223:H234)
	var B89 = (parseFloat(H223_JR20)+parseFloat(H224_JR20)+parseFloat(H225_JR20)+parseFloat(H226_JR20)+parseFloat(H227_JR20)+parseFloat(H228_JR20)+parseFloat(H229_JR20)+parseFloat(H230_JR20)+parseFloat(H231_JR20)+parseFloat(H232_JR20)+parseFloat(H233_JR20)+parseFloat(H234_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B89-SUM(PROJECTIE!G$40:G$45)
	var C89 = (parseFloat(G15phide.val()) - parseFloat(B89) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C89+C$30)
	var D89 = (Math.trunc(parseFloat(C89) + C30)).toFixed(2);

	var E89;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H89 = ((980.14*(D89 - C30)/10000 + 1400) * (D89 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I89 = ((216.16*((D89 - 14254)/10000) + 2397) * ((D89 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J89 = (0.42*D89-8780.9).toFixed(2);

	//=TRUNC(IF(D89<14255,H89,IF(D74>55960,J72,I72)))
	if (D89<14255) {
		E89 = Math.trunc(H89).toFixed(2); //Valur of E89
	}
	else if (D89>55960) {
		E89 = Math.trunc(J89).toFixed(2); //Valur of E89
	}
	else{
		E89 = Math.trunc(I89).toFixed(2); //Valur of E88
	}

	//=PROJECTIE!D$51-E89-SUM(PROJECTIE!G$40:G$43)
	var F89 = (parseFloat(D51phide.val())-parseFloat(E89)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);

	

	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_215 = parseFloat(G30_JR20_214 - G234_JR20).toFixed(3);
	var H235_JR20 = parseFloat(G30_JR20_215 * taeg_JR20).toFixed(3);
	var G235_JR20 = parseFloat(pmt_constant_JR20 - H235_JR20).toFixed(3);

	var G30_JR20_216 = parseFloat(G30_JR20_215 - G235_JR20).toFixed(3);
	var H236_JR20 = parseFloat(G30_JR20_216 * taeg_JR20).toFixed(3);
	var G236_JR20 = parseFloat(pmt_constant_JR20 - H236_JR20).toFixed(3);

	var G30_JR20_217 = parseFloat(G30_JR20_216 - G236_JR20).toFixed(3);
	var H237_JR20 = parseFloat(G30_JR20_217 * taeg_JR20).toFixed(3);
	var G237_JR20 = parseFloat(pmt_constant_JR20 - H237_JR20).toFixed(3);

	var G30_JR20_218 = parseFloat(G30_JR20_217 - G237_JR20).toFixed(3);
	var H238_JR20 = parseFloat(G30_JR20_218 * taeg_JR20).toFixed(3);
	var G238_JR20 = parseFloat(pmt_constant_JR20 - H238_JR20).toFixed(3);

	var G30_JR20_219 = parseFloat(G30_JR20_218 - G238_JR20).toFixed(3);
	var H239_JR20 = parseFloat(G30_JR20_219 * taeg_JR20).toFixed(3);
	var G239_JR20 = parseFloat(pmt_constant_JR20 - H239_JR20).toFixed(3);

	var G30_JR20_220 = parseFloat(G30_JR20_219 - G239_JR20).toFixed(3);
	var H240_JR20 = parseFloat(G30_JR20_220 * taeg_JR20).toFixed(3);
	var G240_JR20 = parseFloat(pmt_constant_JR20 - H240_JR20).toFixed(3);
	
	var G30_JR20_221 = parseFloat(G30_JR20_220 - G240_JR20).toFixed(3);
	var H241_JR20 = parseFloat(G30_JR20_221 * taeg_JR20).toFixed(3);
	var G241_JR20 = parseFloat(pmt_constant_JR20 - H241_JR20).toFixed(3);

	var G30_JR20_222 = parseFloat(G30_JR20_221 - G241_JR20).toFixed(3);
	var H242_JR20 = parseFloat(G30_JR20_222 * taeg_JR20).toFixed(3);
	var G242_JR20 = parseFloat(pmt_constant_JR20 - H242_JR20).toFixed(3);

	var G30_JR20_223 = parseFloat(G30_JR20_222 - G242_JR20).toFixed(3);
	var H243_JR20 = parseFloat(G30_JR20_223 * taeg_JR20).toFixed(3);
	var G243_JR20 = parseFloat(pmt_constant_JR20 - H243_JR20).toFixed(3);

	var G30_JR20_224 = parseFloat(G30_JR20_223 - G243_JR20).toFixed(3);
	var H244_JR20 = parseFloat(G30_JR20_224 * taeg_JR20).toFixed(3);
	var G244_JR20 = parseFloat(pmt_constant_JR20 - H244_JR20).toFixed(3);

	var G30_JR20_225 = parseFloat(G30_JR20_224 - G244_JR20).toFixed(3);
	var H245_JR20 = parseFloat(G30_JR20_225 * taeg_JR20).toFixed(3);
	var G245_JR20 = parseFloat(pmt_constant_JR20 - H245_JR20).toFixed(3);

	var G30_JR20_226 = parseFloat(G30_JR20_225 - G245_JR20).toFixed(3);
	var H246_JR20 = parseFloat(G30_JR20_226 * taeg_JR20).toFixed(3);
	var G246_JR20 = parseFloat(pmt_constant_JR20 - H246_JR20).toFixed(3);
	// =SUM('Amortiss 20 ans'!H235:H246)
	var B90 = (parseFloat(H235_JR20)+parseFloat(H236_JR20)+parseFloat(H237_JR20)+parseFloat(H238_JR20)+parseFloat(H239_JR20)+parseFloat(H240_JR20)+parseFloat(H241_JR20)+parseFloat(H242_JR20)+parseFloat(H243_JR20)+parseFloat(H244_JR20)+parseFloat(H245_JR20)+parseFloat(H246_JR20)).toFixed(2);
	
	//=PROJECTIE!G$15-B90-SUM(PROJECTIE!G$40:G$45)
	var C90 = (parseFloat(G15phide.val()) - parseFloat(B90) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C90+C$30)
	var D90 = (Math.trunc(parseFloat(C90) + C30)).toFixed(2);

	var E90;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H90 = ((980.14*(D90 - C30)/10000 + 1400) * (D90 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I90 = ((216.16*((D90 - 14254)/10000) + 2397) * ((D90 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J90 = (0.42*D90-8780.9).toFixed(2);

	//=TRUNC(IF(D90<14255,H90,IF(D74>55960,J72,I72)))
	if (D90<14255) {
		E90 = Math.trunc(H90).toFixed(2); //Valur of E90
	}
	else if (D90>55960) {
		E90 = Math.trunc(J90).toFixed(2); //Valur of E90
	}
	else{
		E90 = Math.trunc(I90).toFixed(2); //Valur of E90
	}
	//=PROJECTIE!D$51-E90-SUM(PROJECTIE!G$40:G$43)
	var F90 = (parseFloat(D51phide.val())-parseFloat(E90)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);


	
	//===========>>>>>>>>>>>>>>>>>
	var G30_JR20_227 = parseFloat(G30_JR20_226 - G246_JR20).toFixed(3);
	var H247_JR20 = parseFloat(G30_JR20_227 * taeg_JR20).toFixed(3);
	var G247_JR20 = parseFloat(pmt_constant_JR20 - H247_JR20).toFixed(3);

	var G30_JR20_228 = parseFloat(G30_JR20_227 - G247_JR20).toFixed(3);
	var H248_JR20 = parseFloat(G30_JR20_228 * taeg_JR20).toFixed(3);
	var G248_JR20 = parseFloat(pmt_constant_JR20 - H248_JR20).toFixed(3);

	var G30_JR20_229 = parseFloat(G30_JR20_228 - G248_JR20).toFixed(3);
	var H249_JR20 = parseFloat(G30_JR20_229 * taeg_JR20).toFixed(3);
	var G249_JR20 = parseFloat(pmt_constant_JR20 - H249_JR20).toFixed(3);

	var G30_JR20_230 = parseFloat(G30_JR20_229 - G249_JR20).toFixed(3);
	var H250_JR20 = parseFloat(G30_JR20_230 * taeg_JR20).toFixed(3);
	var G250_JR20 = parseFloat(pmt_constant_JR20 - H250_JR20).toFixed(3);

	var G30_JR20_231 = parseFloat(G30_JR20_230 - G250_JR20).toFixed(3);
	var H251_JR20 = parseFloat(G30_JR20_231 * taeg_JR20).toFixed(3);
	var G251_JR20 = parseFloat(pmt_constant_JR20 - H251_JR20).toFixed(3);

	var G30_JR20_232 = parseFloat(G30_JR20_231 - G251_JR20).toFixed(3);
	var H252_JR20 = parseFloat(G30_JR20_232 * taeg_JR20).toFixed(3);
	var G252_JR20 = parseFloat(pmt_constant_JR20 - H252_JR20).toFixed(3);

	var G30_JR20_233 = parseFloat(G30_JR20_232 - G252_JR20).toFixed(3);
	var H253_JR20 = parseFloat(G30_JR20_233 * taeg_JR20).toFixed(3);
	var G253_JR20 = parseFloat(pmt_constant_JR20 - H253_JR20).toFixed(3);

	var G30_JR20_234 = parseFloat(G30_JR20_233 - G253_JR20).toFixed(3);
	var H254_JR20 = parseFloat(G30_JR20_234 * taeg_JR20).toFixed(3);
	var G254_JR20 = parseFloat(pmt_constant_JR20 - H254_JR20).toFixed(3);

	var G30_JR20_235 = parseFloat(G30_JR20_234 - G254_JR20).toFixed(3);
	var H255_JR20 = parseFloat(G30_JR20_235 * taeg_JR20).toFixed(3);
	var G255_JR20 = parseFloat(pmt_constant_JR20 - H255_JR20).toFixed(3);

	var G30_JR20_236 = parseFloat(G30_JR20_235 - G255_JR20).toFixed(3);
	var H256_JR20 = parseFloat(G30_JR20_236 * taeg_JR20).toFixed(3);
	var G256_JR20 = parseFloat(pmt_constant_JR20 - H256_JR20).toFixed(3);

	var G30_JR20_237 = parseFloat(G30_JR20_236 - G256_JR20).toFixed(3);
	var H257_JR20 = parseFloat(G30_JR20_237 * taeg_JR20).toFixed(3);
	var G257_JR20 = parseFloat(pmt_constant_JR20 - H257_JR20).toFixed(3);

	var G30_JR20_238 = parseFloat(G30_JR20_237 - G257_JR20).toFixed(3);
	var H258_JR20 = parseFloat(G30_JR20_238 * taeg_JR20).toFixed(3);
	var G258_JR20 = parseFloat(pmt_constant_JR20 - H258_JR20).toFixed(3);
	//=SUM('Amortiss 20 ans'!H247:H258)
	var B91 = (parseFloat(H247_JR20)+parseFloat(H248_JR20)+parseFloat(H249_JR20)+parseFloat(H250_JR20)+parseFloat(H251_JR20)+parseFloat(H252_JR20)+parseFloat(H253_JR20)+parseFloat(H254_JR20)+parseFloat(H255_JR20)+parseFloat(H256_JR20)+parseFloat(H257_JR20)+parseFloat(H258_JR20)).toFixed(2);

	//=PROJECTIE!G$15-B91-SUM(PROJECTIE!G$40:G$45)
	var C91 = (parseFloat(G15phide.val()) - parseFloat(B91) - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())+parseFloat(G44phide.val())+parseFloat(G45phide.val()))).toFixed(2);

	//=TRUNC(C91+C$30)
	var D91 = (Math.trunc(parseFloat(C91) + C30)).toFixed(2);

	var E91;

	//Von 9.169 â‚¬ tot 14.255 â‚¬: #1 #1
	var H91 = ((980.14*(D91 - C30)/10000 + 1400) * (D91 - C30)/10000).toFixed(2);

	//Van 14.255 â‚¬ bis 55.960 â‚¬: #2 #1
	var I91 = ((216.16*((D91 - 14254)/10000) + 2397) * ((D91 - 14254)/10000)+965.58).toFixed(2); 

	//Van 55.961 â‚¬ tot 265.326 â‚¬: #3 #1
	var J91 = (0.42*D91-8780.9).toFixed(2);

	//=TRUNC(IF(D91<14255,H91,IF(D74>55960,J72,I72)))
	if (D91<14255) {
		E91 = Math.trunc(H91).toFixed(2); //Valur of E91
	}
	else if (D91>55960) {
		E91 = Math.trunc(J91).toFixed(2); //Valur of E91
	}
	else{
		E91 = Math.trunc(I91).toFixed(2); //Valur of E91
	}

	//=PROJECTIE!D$51-E91-SUM(PROJECTIE!G$40:G$43)
	var F91 = (parseFloat(D51phide.val())-parseFloat(E91)-(parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val()))).toFixed(2);

	//=SUM(B72:B91)
	var B92 = (parseFloat(B72)+parseFloat(B73)+parseFloat(B74)+parseFloat(B75)+parseFloat(B76)+parseFloat(B77)+parseFloat(B78)+parseFloat(B79)+parseFloat(B80)+parseFloat(B81)+parseFloat(B82)+parseFloat(B83)+parseFloat(B84)+parseFloat(B85)+parseFloat(B86)+parseFloat(B87)+parseFloat(B88)+parseFloat(B89)+parseFloat(B90)+parseFloat(B91)).toFixed(2);

	//=SUM(E72:E91)
	var E92 = (parseFloat(E72)+parseFloat(E73)+parseFloat(E74)+parseFloat(E75)+parseFloat(E76)+parseFloat(E77)+parseFloat(E78)+parseFloat(E79)+parseFloat(E80)+parseFloat(E81)+parseFloat(E82)+parseFloat(E83)+parseFloat(E84)+parseFloat(E85)+parseFloat(E86)+parseFloat(E87)+parseFloat(E88)+parseFloat(E89)+parseFloat(E90)+parseFloat(E91)).toFixed(2);

	//=SUM(F72:F91)
	var F92 = (parseFloat(F72)+parseFloat(F73)+parseFloat(F74)+parseFloat(F75)+parseFloat(F76)+parseFloat(F77)+parseFloat(F78)+parseFloat(F79)+parseFloat(F80)+parseFloat(F81)+parseFloat(F82)+parseFloat(F83)+parseFloat(F84)+parseFloat(F85)+parseFloat(F86)+parseFloat(F87)+parseFloat(F88)+parseFloat(F89)+parseFloat(F90)+parseFloat(F91)).toFixed(2);

  // console.log("D22==> " + D22);



	//
	// Start
	//
	// ======================================================================================
	// JAARLIJKSE AFTREKBARE KOSTEN  G46
	// ======================================================================================

	// =(IF(F$72<11,Berekeningsblad!B$37,IF(F$72>16,Berekeningsblad!B72,Berekeningsblad!B$52)))
	if (F72p<=10) {
		G46phide.val(parseFloat(B37).toFixed(2));
		G46p.val(Number(G46phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=11 && F72p<=16) {
		G46phide.val(parseFloat(B52).toFixed(2));
		G46p.val(Number(G46phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=17) {
		G46phide.val(parseFloat(B72).toFixed(2));
		G46p.val(Number(G46phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	I46phide.val('0.00');
	I46p.val('0,00');
	//
	// End
	//




	//
	// Start
	//
	// =(IF(F$72<11,Berekeningsblad!E$37,IF(F$72>16,Berekeningsblad!E72,Berekeningsblad!E$52)))
	if (F72p<=10) {
		G52phide.val(Math.trunc(E37).toFixed(2));
		G52p.val(Number(G52phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=11 && F72p<=16) {
		G52phide.val(Math.trunc(E52).toFixed(2));
		G52p.val(Number(G52phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=17) {
		G52phide.val(Math.trunc(E72).toFixed(2));
		G52p.val(Number(G52phide.val()).regular_to_euro(2, 3, '.', ','));
	}


	I52phide.val(Math.trunc(E34).toFixed(2));
	I52p.val(Number(I52phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G52/$D51
	G53phide.val((parseFloat(G52phide.val()/D51phide.val())*100).toFixed(2));
	G53p.val(Number(G53phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = I52/$D51
	I53phide.val((parseFloat(I52phide.val()/D51phide.val())*100).toFixed(2));
	I53p.val(Number(I53phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = D51-SUM(G40:G43)-G52
	var G54Value = (D51phide.val() - (parseFloat(G40phide.val())+parseFloat(G41phide.val())+parseFloat(G42phide.val())+parseFloat(G43phide.val())) - G52phide.val()).toFixed(2); 
	G54phide.val(G54Value);
	G54p.val(Number(G54phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = D51-SUM(I40:I43)-I52
	var I54Value = (D51phide.val() - (parseFloat(I40phide.val())+parseFloat(I41phide.val())+parseFloat(I42phide.val())+parseFloat(I43phide.val())) - I52phide.val()).toFixed(2); 
	I54phide.val(I54Value);
	I54p.val(Number(I54phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G54/12
	G55phide.val(parseFloat(G54phide.val()/12).toFixed(2));
	G55p.val(Number(G55phide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = I54/12
	I55phide.val(parseFloat(I54phide.val()/12).toFixed(2));
	I55p.val(Number(I55phide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G54/G19
	G56phide.val((parseFloat(G54phide.val()/G19phide.val())*100).toFixed(2));
	G56p.val(Number(G56phide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = I54/I19
	I56phide.val((parseFloat(I54phide.val()/I19phide.val())*100).toFixed(2));
	I56p.val(Number(I56phide.val()).regular_to_euro(2, 3, '.', ','));

	// =Berekeningsblad!F47/120-G60
	G66phide.val((parseFloat(F47)/120-parseFloat(G60phide.val())).toFixed(2));
	G66p.attr("data-posneg", G66phide.val());
	G66p.val(Number(G66phide.val()).regular_to_euro(2, 3, '.', ','));
	// =I54/12-I60
	I66phide.val((parseFloat(I54phide.val())/12-parseFloat(I60phide.val())).toFixed(2));
	I66p.attr("data-posneg", I66phide.val());
	I66p.val(Number(I66phide.val()).regular_to_euro(2, 3, '.', ','));

	// =Berekeningsblad!F67/180-G61
	G67phide.val((parseFloat(F67)/180 - parseFloat(G61phide.val())).toFixed(2));
	G67p.attr("data-posneg", G67phide.val());
	G67p.val(Number(G67phide.val()).regular_to_euro(2, 3, '.', ','));
	// =I54/12-I61
	I67phide.val((parseFloat(I54phide.val())/12 - parseFloat(I61phide.val())).toFixed(2));
	I67p.attr("data-posneg", I67phide.val());
	I67p.val(Number(I67phide.val()).regular_to_euro(2, 3, '.', ','));

	//=Berekeningsblad!F92/240-G62
	G68phide.val((parseFloat(F92)/240 - parseFloat(G62phide.val())).toFixed(2));
	G68p.attr("data-posneg", G68phide.val());
	G68p.val(Number(G68phide.val()).regular_to_euro(2, 3, '.', ','));
	//=I54/12-I62
	I68phide.val((parseFloat(I54phide.val())/12 - parseFloat(I62phide.val())).toFixed(2));
	I68p.attr("data-posneg", I68phide.val());
	I68p.val(Number(I68phide.val()).regular_to_euro(2, 3, '.', ','));
	// 
	// End
	// 




	


	// =======================================================================================
	// =======================================================================================
	//Formula = (IF(F$72<11,Berekeningsblad!F$47,IF(F$72>16,Berekeningsblad!F92,Berekeningsblad!F$67)))
	//Formula = (IF(F$72<11,Berekeningsblad!D$12,IF(F$72>16,Berekeningsblad!D22,Berekeningsblad!D$17)))
	//Formula = (IF(F$72<11,Berekeningsblad!B$47,IF(F$72>16,Berekeningsblad!B92,Berekeningsblad!B$67)))
	if (F72p<=10) {
		G74phide.val(parseFloat(F47).toFixed(2));
		G74p.val(Number(G74phide.val()).regular_to_euro(2, 3, '.', ','));

		G75phide.val(parseFloat(D12).toFixed(2));
		G75p.val(Number(G75phide.val()).regular_to_euro(2, 3, '.', ','));

		I75phide.val(parseFloat(D12).toFixed(2));
		I75p.val(Number(I75phide.val()).regular_to_euro(2, 3, '.', ','));

		G79phide.val(parseFloat(B47).toFixed(2));
		G79p.val(Number(G79phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=11 && F72p<=16) {
		G74phide.val(parseFloat(F67).toFixed(2));
		G74p.val(Number(G74phide.val()).regular_to_euro(2, 3, '.', ','));

		G75phide.val(parseFloat(D17).toFixed(2));
		G75p.val(Number(G75phide.val()).regular_to_euro(2, 3, '.', ','));

		I75phide.val(parseFloat(D17).toFixed(2));
		I75p.val(Number(I75phide.val()).regular_to_euro(2, 3, '.', ','));

		G79phide.val(parseFloat(B67).toFixed(2));
		G79p.val(Number(G79phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	else if (F72p>=17) {
		G74phide.val(parseFloat(F92).toFixed(2));
		G74p.val(Number(G74phide.val()).regular_to_euro(2, 3, '.', ','));
		
		G75phide.val(parseFloat(D22).toFixed(2));
		G75p.val(Number(G75phide.val()).regular_to_euro(2, 3, '.', ','));
		
		I75phide.val(parseFloat(D22).toFixed(2));
		I75p.val(Number(I75phide.val()).regular_to_euro(2, 3, '.', ','));

		G79phide.val(parseFloat(B92).toFixed(2));
		G79p.val(Number(G79phide.val()).regular_to_euro(2, 3, '.', ','));
	}
	I74phide.val((parseFloat(F72p)*parseFloat(I54phide.val()).toFixed(2)));
	I74p.val(Number(I74phide.val()).regular_to_euro(2, 3, '.', ','));

	I79phide.val(parseFloat(I46phide.val()).toFixed(2));
	I79p.val(Number(I79phide.val()).regular_to_euro(2, 3, '.', ','));

	G76phide.val((parseFloat(G74phide.val())+parseFloat(G75phide.val())).toFixed(2));
	G76p.val(Number(G76phide.val()).regular_to_euro(2, 3, '.', ','));
	I76phide.val((parseFloat(I74phide.val())+parseFloat(I75phide.val())).toFixed(2));
	I76p.val(Number(I76phide.val()).regular_to_euro(2, 3, '.', ','));

	G78phide.val((parseFloat(G20phide.val())+parseFloat(G21phide.val())).toFixed(2));
	G78p.val(Number(G78phide.val()).regular_to_euro(2, 3, '.', ','));
	I78phide.val((parseFloat(I20phide.val())+parseFloat(I21phide.val())).toFixed(2));
	I78p.val(Number(I78phide.val()).regular_to_euro(2, 3, '.', ','));

	G80phide.val((parseFloat(G78phide.val())+parseFloat(G79phide.val())).toFixed(2));
	G80p.val(Number(G80phide.val()).regular_to_euro(2, 3, '.', ','));
	I80phide.val((parseFloat(I78phide.val())+parseFloat(I79phide.val())).toFixed(2));	
	I80p.val(Number(I80phide.val()).regular_to_euro(2, 3, '.', ','));

	G82phide.val((parseFloat(G76phide.val())-parseFloat(G80phide.val())).toFixed(2));
	G82p.val(Number(G82phide.val()).regular_to_euro(2, 3, '.', ','));
	I82phide.val((parseFloat(I76phide.val())-parseFloat(I80phide.val())).toFixed(2));
	I82p.val(Number(I82phide.val()).regular_to_euro(2, 3, '.', ','));




	// ======================================================================================
	// ======================================================================================
	// ======================================================================================
	var A35 = 10.00;
	var A50 = 15.00;
	var A70 = 20.00;

	// =(Berekeningsblad!F47+Berekeningsblad!D12-SUM(G20:G21)-Berekeningsblad!B47)/G26/Berekeningsblad!A35
	var G86percent = (((parseFloat(F47) + parseFloat(D12) - (parseFloat(G20phide.val()) + parseFloat(G21phide.val())) - parseFloat(B47)) / parseFloat(G26phide.val()) / A35) * 100).toFixed(2);
	// =(I54*Berekeningsblad!A35+Berekeningsblad!D12-SUM(I20:I21))/I23/Berekeningsblad!A35
  var I86percent = (((parseFloat(I54phide.val())*A35 + parseFloat(D12) - (parseFloat(I20phide.val()) + parseFloat(I21phide.val()))) / parseFloat(I23phide.val()) / A35)*100).toFixed(2);

  // =(Berekeningsblad!F67+Berekeningsblad!D17-SUM(G20:G21)-Berekeningsblad!B67)/G26/Berekeningsblad!A50
  var G87percent = (((parseFloat(F67) + parseFloat(D17) - (parseFloat(G20phide.val()) + parseFloat(G21phide.val())) - parseFloat(B67)) / parseFloat(G26phide.val()) / A50) * 100).toFixed(2);
  // =(I54*Berekeningsblad!A50+Berekeningsblad!D17-SUM(I20:I21))/I23/Berekeningsblad!A50
  var I87percent = (((parseFloat(I54phide.val()) * parseFloat(A50) + parseFloat(D17) - (parseFloat(I20phide.val()) + parseFloat(I21phide.val()))) / parseFloat(I23phide.val()) / A50) * 100).toFixed(2);
  
  // =(Berekeningsblad!F92+Berekeningsblad!D22-SUM(G20:G21)-Berekeningsblad!B92)/G26/Berekeningsblad!A70
  var G88percent = (((parseFloat(F92) + parseFloat(D22) - (parseFloat(G20phide.val()) + parseFloat(G21phide.val())) - parseFloat(B92)) / parseFloat(G26phide.val()) / parseFloat(A70)) * 100).toFixed(2);
  // =(I54*Berekeningsblad!A70+Berekeningsblad!D22-SUM(I20:I21))/I23/Berekeningsblad!A70
  var I88percent = (((parseFloat(I54phide.val()) * parseFloat(A70) + parseFloat(D22) - (parseFloat(I20phide.val()) + parseFloat(I21phide.val()))) / parseFloat(I23phide.val()) / A70) * 100).toFixed(2);
  
  G86phide.val(G86percent);
  G86p.val(Number(G86phide.val()).regular_to_euro(2, 3, '.', ','));
  I86phide.val(I86percent);
  I86p.val(Number(I86phide.val()).regular_to_euro(2, 3, '.', ','));

  G87phide.val(G87percent);
  G87p.val(Number(G87phide.val()).regular_to_euro(2, 3, '.', ','));
  I87phide.val(I87percent);
  I87p.val(Number(I87phide.val()).regular_to_euro(2, 3, '.', ','));

  G88phide.val(G88percent);
  G88p.val(Number(G88phide.val()).regular_to_euro(2, 3, '.', ','));
  I88phide.val(I88percent);
  I88p.val(Number(I88phide.val()).regular_to_euro(2, 3, '.', ','));

}



/*JAARLIJKSE AFTREKBARE KOSTEN
	---->>jako
*/
$.fn.jako = function(){
	var D15hide = parseFloat($("#D15hide").val());
	var D51 = $("#D51");
	var D51hide = $("#D51hide");

	var G15 = $("#G15");
	var G30 = $('#G30');
	var G30hide = $('#G30hide');
	var G40 = $("#G40");
	var G40hide = $("#G40hide");
	var G41 = $("#G41");
	var G41hide = $("#G41hide");
	var G42 = $("#G42");
	var G42hide = $("#G42hide");
	var G43 = $("#G43");
	var G43hide = $("#G43hide");
	var G44 = $("#G44");
	var G44hide = $("#G44hide");
	var G45 = $("#G45");
	var G45hide = $("#G45hide");
	var G46 = $("#G46");
	var G46hide = $("#G46hide");
	var G47 = $("#G47");
	var G47hide = $("#G47hide");
	var G51 = $("#G51");
	var G51hide = $("#G51hide");

	var I40 = $("#I40");
	var I40hide = $("#I40hide");
	var I41 = $("#I41");
	var I41hide = $("#I41hide");
	var I42 = $("#I42");
	var I42hide = $("#I42hide");
	var I43 = $("#I43");
	var I43hide = $("#I43hide");
	var I44 = $("#I44");
	var I44hide = $("#I44hide");
	var I45 = $("#I45");
	var I45hide = $("#I45hide");
	var I46 = $("#I46");
	var I46hide = $("#I46hide");
	var I47 = $("#I47");
	var I47hide = $("#I47hide");
	var I51 = $("#I51");
	var I51hide = $("#I51hide");

	setTimeout(function(){
		// //Formula = G40
		I40hide.val(parseFloat(G40hide.val()).toFixed(2));
		I40.val(Number(I40hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = G41
		I41hide.val(parseFloat(G41hide.val()).toFixed(2));
		I41.val(Number(I41hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = G42
		I42hide.val(parseFloat(G42hide.val()).toFixed(2));
		I42.val(Number(I42hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = G43
		I43hide.val(parseFloat(G43hide.val()).toFixed(2));
		I43.val(Number(I43hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = D15*1.6%*1.065
		G44hide.val((parseFloat(D15hide*1.6*1.065) / 100).toFixed(2));
		G44.val(Number(G44hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = G44
		I44hide.val(parseFloat(G44hide.val()).toFixed(2));
		I44.val(Number(I44hide.val()).regular_to_euro(2, 3, '.', ','));

		//Formula = I45
		I45hide.val(parseFloat(G45hide.val()).toFixed(2));
		I45.val(Number(I45hide.val()).regular_to_euro(2, 3, '.', ','));

		// //Formula = SUM(G40:G46)
		var G47Value = (parseFloat(G40hide.val())+parseFloat(G41hide.val())+parseFloat(G42hide.val())+parseFloat(G43hide.val())+parseFloat(G44hide.val())+parseFloat(G45hide.val())+parseFloat(G46hide.val())).toFixed(2); 
		G47hide.val(G47Value);
		G47.val(Number(G47hide.val()).regular_to_euro(2, 3, '.', ','));

		

		//Formula = SUM(I40:I46)
		var I47Value = (parseFloat(I40hide.val())+parseFloat(I41hide.val())+parseFloat(I42hide.val())+parseFloat(I43hide.val())+parseFloat(I44hide.val())+parseFloat(I45hide.val())+parseFloat(I46hide.val())).toFixed(2); 
		I47hide.val(I47Value);
		I47.val(Number(I47hide.val()).regular_to_euro(2, 3, '.', ','));


		// ================================
		// BELASTINGEN (JAAR 1)
		//=================================
		D51hide.val(parseFloat(G15.val()).toFixed(2));
		D51.val(Number(D51hide.val()).regular_to_euro(2, 3, '.', ','));

		G51hide.val((parseFloat(D51hide.val()) - parseFloat(G47hide.val())).toFixed(2));
		G51.val(Number(G51hide.val()).regular_to_euro(2, 3, '.', ','));

		I51hide.val((parseFloat(D51hide.val()) - parseFloat(I47hide.val())).toFixed(2));
		I51.val(Number(I51hide.val()).regular_to_euro(2, 3, '.', ','));


		setTimeout(function() {
			$.fn.common();
		},200);

	},600);

}


/* 
	From to bottom #4 function
*/

/*HUURINKOMSTEN
	---->>huur
*/
$.fn.huur = function(){
	var G15 = $("#G15");
	var G23 = $("#G23");
	var G23hide = $("#G23hide");
	var G34 = $("#G34");
	var G34hide = $("#G34hide");
	var G35 = $("#G35");
	var G35hide = $("#G35hide");
	var G36 = $("#G36");
	var G36hide = $("#G36hide");
	var I23 = $("#I23");
	var I23hide = $("#I23hide");
	var I34 = $("#I34");
	var I34hide = $("#I34hide");
	var I35 = $("#I35");
	var I35hide = $("#I35hide");
	var I36 = $("#I36");
	var I36hide = $("#I36hide");

	//Formula = G15
	G34hide.val(parseFloat(G15.val()).toFixed(2));
	G34.val(Number(G34hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G34
	I34hide.val(parseFloat(G34hide.val()).toFixed(2));
	I34.val(Number(I34hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G15/12
	G35hide.val(parseFloat(G15.val()/12).toFixed(2));
	G35.val(Number(G35hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G35
	I35hide.val(parseFloat(G35hide.val()).toFixed(2));
	I35.val(Number(I35hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G34/G23
	G36hide.val((parseFloat(G34hide.val()/G23hide.val())*100).toFixed(2));
	G36.val(Number(G36hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = I34/I23
	I36hide.val((parseFloat(I34hide.val()/I23hide.val())*100).toFixed(2));
	I36.val(Number(I36hide.val()).regular_to_euro(2, 3, '.', ','));

	$.fn.jako();
}


/* 
	From to bottom #3 function
*/

/*PARAMETERS KLANT (EIGEN INBRENG)
	---->>pakl
*/
$.fn.pakl = function(){
	var D15hide = $("#D15hide");
	var G19 = $('#G19');
	var G19hide = $('#G19hide');
	var G20 = $('#G20');
	var G20hide = $('#G20hide');
	var G21 = $('#G21');
	var G21hide = $('#G21hide');
	var G23 = $('#G23');
	var G23hide = $('#G23hide');
	var G26 = $('#G26');
	var G26hide = $('#G26hide');
	var I19 = $('#I19');
	var I19hide = $('#I19hide');
	var I20 = $('#I20');
	var I20hide = $('#I20hide');
	var I21 = $('#I21');
	var I21hide = $('#I21hide');
	var I23 = $('#I23');
	var I23hide = $('#I23hide');
	var I26 = $('#I26');
	var I26hide = $('#I26hide');
	var F28 = $('#F28');
	var F28hide = $('#F28hide');
	var G28 = $('#G28');
	var G28hide = $('#G28hide');
	var I28 = $('#I28');
	var I28hide = $('#I28hide');
	var F29 = $('#F29');
	var F29hide = $('#F29hide');
	var G29 = $('#G29');
	var G29hide = $('#G29hide');
	var I29 = $('#I29');
	var I29hide = $('#I29hide');
	var F30 = $('#F30');
	var F30hide = $('#F30hide');
	var G30 = $('#G30');
	var G30hide = $('#G30hide');
	var I30 = $('#I30');
	var I30hide = $('#I30hide');

	//Formula = D15*0.2+G20+G21
	G26hide.val((parseFloat(D15hide.val())*0.2+parseFloat(G20hide.val())+parseFloat(G21hide.val())).toFixed(2));
	G26.val(Number(G26hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = I23
	I26hide.val(parseFloat(I23hide.val()).toFixed(2));
	I26.val(Number(I23hide.val()).regular_to_euro(2, 3, '.', ','));


	//Formula = G20+G21
	G29hide.val((parseFloat(G20hide.val())+parseFloat(G21hide.val())).toFixed(2));
	G29.val(Number(G29hide.val()).regular_to_euro(2, 3, '.', ','));
	
	//Formula = G26-G29
	G28hide.val((parseFloat(G26hide.val())-parseFloat(G29hide.val())).toFixed(2));
	G28.val(Number(G28hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = G28/G23
	F28hide.val((parseFloat(G28hide.val()/G23hide.val()) * 100).toFixed(2));
	F28.val(Number(F28hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = G19
	I28hide.val(parseFloat(G19hide.val()).toFixed(2));
	I28.val(Number(I28hide.val()).regular_to_euro(2, 3, '.', ','));


	//Formula = G29/G23
	F29hide.val((parseFloat(G29hide.val()/G23hide.val()) * 100).toFixed(2));
	F29.val(Number(F29hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = SUM(I20:I21)
	I29hide.val((parseFloat(I20hide.val())+parseFloat(I21hide.val())).toFixed(2));
	I29.val(Number(I29hide.val()).regular_to_euro(2, 3, '.', ','));


	//Formula = G23-G26
	G30hide.val((parseFloat(G23hide.val())-parseFloat(G26hide.val())).toFixed(2));
	G30.val(Number(G30hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = =G30/G23
	F30hide.val((parseFloat(G30hide.val()/G23hide.val()) * 100).toFixed(2));
	F30.val(Number(F30hide.val()).regular_to_euro(2, 3, '.', ','));
	//Formula = =I19-I28
	I30hide.val((parseFloat(I19hide.val())-parseFloat(I28hide.val())).toFixed(2));
	I30.val(Number(I30hide.val()).regular_to_euro(2, 3, '.', ','));

	$.fn.huur();
}



/* 
	From to bottom #2 function
*/

/*OVERZICHT INVESTERING
	---->>ovin
*/
$.fn.ovin = function(){
	var D15 = $("#D15");
	var D15hide = $("#D15hide");
	var G19 = $('#G19');
	var G19hide = $('#G19hide');
	var G20 = $('#G20');
	var G20hide = $('#G20hide');
	var G21 = $('#G21');
	var G21hide = $('#G21hide');
	var G23 = $('#G23');
	var G23hide = $('#G23hide');
	var I19 = $('#I19');
	var I19hide = $('#I19hide');
	var I20 = $('#I20');
	var I20hide = $('#I20hide');
	var I21 = $('#I21');
	var I21hide = $('#I21hide');
	var I23 = $('#I23');
	var I23hide = $('#I23hide');
	var F20 = $('#F20');
	var F20hide = $('#F20hide');
	var F21 = $('#F21');
	var F21hide = $('#F21hide');

	var F60 = $('#F60');
	var F60hide = $('#F60hide');

	var F61 = $('#F61');
	var F61hide = $('#F61hide');

	var F62 = $('#F62');
	var F62hide = $('#F62hide');

	var F72 = $('#F72');
	var F72hide = $('#F72hide');

	var F75 = $('#F75');
	var F75hide = $('#F75hide');


	//Start | On keyup functionality
	F20.val(euroCurrency(F20.val()));
  F20hide.val(parseFloat(euro_to_regular(F20.val())).toFixed(2));

	F21.val(euroCurrency(F21.val()));
  F21hide.val(parseFloat(euro_to_regular(F21.val())).toFixed(2));


  F60.val(euroCurrency(F60.val()));
  F60hide.val(parseFloat(euro_to_regular(F60.val())).toFixed(2));

  F61.val(euroCurrency(F61.val()));
  F61hide.val(parseFloat(euro_to_regular(F61.val())).toFixed(2));

  F62.val(euroCurrency(F62.val()));
  F62hide.val(parseFloat(euro_to_regular(F62.val())).toFixed(2));

  F72.val(euroCurrency(F72.val()));
  F72hide.val(parseFloat(euro_to_regular(F72.val())).toFixed(2));

  F75.val(euroCurrency(F75.val()));
  F75hide.val(parseFloat(euro_to_regular(F75.val())).toFixed(2));
  //End | On keyup functionality


	//Formula = D15
	// G19.val(D15.val());
	G19.val(Number(D15hide.val()).regular_to_euro(2, 3, '.', ','));
	G19hide.val(parseFloat(D15hide.val()).toFixed(2));


	//Formula = G19
	I19.val(G19.val());
	I19hide.val(parseFloat(G19hide.val()).toFixed(2));

	//Formula = G19*F20
	var G20value = ((parseFloat(G19hide.val())*parseFloat(F20hide.val()))/100).toFixed(6);
	G20hide.val(Math.round10(G20value, -2).toFixed(2));
	G20.val(Number(G20hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = G20
	I20hide.val(parseFloat(G20hide.val()).toFixed(2));
	I20.val(Number(G20hide.val()).regular_to_euro(2, 3, '.', ','));


	//Formula = G19*F21*1.21
	G21hide.val((((parseFloat(G19hide.val())*parseFloat(F21hide.val())*1.21))/100).toFixed(2));
	G21.val(Number(G21hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = I19*(F21-0.01)*1.21
	I21hide.val(((parseFloat(I19hide.val())*(parseFloat(F21hide.val()/100) - 0.01)*1.21)).toFixed(2));
	I21.val(Number(I21hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = SUM(G19:G21)
	G23hide.val((parseFloat(G19hide.val())+parseFloat(G20hide.val())+parseFloat(G21hide.val())).toFixed(2));
	G23.val(Number(G23hide.val()).regular_to_euro(2, 3, '.', ','));

	//Formula = SUM(I19:I21)
	I23hide.val((parseFloat(I19hide.val())+parseFloat(I20hide.val())+parseFloat(I21hide.val())).toFixed(2));
	I23.val(Number(I23hide.val()).regular_to_euro(2, 3, '.', ','));

	$.fn.pakl();
}	


/* 
	From to bottom #1 function
*/
/*GEGEVENS APPARTEMENT(EN)
	---->>ovin
*/
$.fn.gege = function(){
  console.log('#gege')
	var D15p = $("#D15");
	var D15hide = $("#D15hide");

  D15p.val(euroCurrency(D15p.val()));
  D15hide.val(parseFloat(euro_to_regular(D15p.val())).toFixed(2));

  var G15p = $('#G15');
  var G15show = $('#G15show');

	//Formula = D15*0.057
	G15show.val(euroCurrency((parseFloat(D15hide.val())*parseFloat(0.057)).toFixed(0)));
	G15p.val(((parseFloat(D15hide.val()) * 0.057)).toFixed(3));

	//Formula = G15/D15
	// $('#I15').html((parseFloat(G15p.val()/D15p)*100).toFixed(2)+'%');
	// G15Show


	$.fn.ovin();

	$.fn.common(); // main logic function

}
$.fn.gege();
}




